/* tslint:disable:max-line-length */

import { LanguageInterface } from "../LanguageInterface";

class Dutch implements LanguageInterface {
  public iso: string = "nl-NL";

  private language = {
    /*
    | Language Label in Selectbox (Change language global)
    */
    "nl-nl": "Dutch",
    "en-us": "English",

    /*
    | Default
    */

    "label-archive": "Archief",
    "your-logo-here": "Jouw logo hier",
    "label-readonly": "Alleen lezen",
    correction: "correctie",
    "title-new": "Nieuw",
    id: "ID",
    "label-other": "Diversen",
    "label-none": "None",
    "label-name": "Naam",
    "label-short-name": "Verkorte naam",
    "label-complex-name": "Naam wooncomplex",
    "label-agency": "Kantoor",
    "title-signin": "Inloggen",
    "label-signin": "Inloggen",
    "button-signup": "Aanmelden",
    "link-signup": "Aanmelden",
    "signup/start-for-free": "Gratis starten",
    "signup/main-text": "Nieuw account",
    "signup/info-text": "Maak een nieuw account en start met Casadesk",
    "confirmnewpassword/main-text": "Kies een wachtwoord",
    "confirmnewpassword/info-text": "Kies een wachtwoord en start met Casadesk",
    "resetconfirmnewpassword/main-text": "Kies een wachtwoord",
    "resetconfirmnewpassword/info-text": "Kies een nieuw wachtwoord en login",
    "menuitem-signout": "Uitloggen",
    "label-sign-up-page-agency-name": "Organisatie",
    "label-first-name": "Voornaam",
    "label-your-first-name": "Jouw voornaam",
    "label-last-name": "Achternaam",
    "link-go-to-signin": "Je hebt al een account?",
    "link-go-to-signin-underscore": "Ga naar login",
    "link-back-to-signin": "Terug naar inloggen",
    "button-back-to-signin": "Terug naar inloggen",
    "pages/singup-info/termsandconditionstext":
      "Ik ga akkoord met de :terms en :agreement",
    "terms-link": "algemene voorwaarden",
    "processing-agreement-link": "verwerkersovereenkomst",
    "link-forgot-password": "Wachtwoord vergeten",
    "title-reset-password": "Reset wachtwoord",
    "title-reset-password-notice":
      "Klik de knop en we sturen de instructies om het wachtwoord te herstellen naar jouw email adres.",
    "title-send-me-instructions": "Stuur mij instructies",
    "title-manual": "Handleiding",
    "lookup-component-prompt-notice":
      "Een :entity1 is niet gemaakt. Maak een :entity2 of klik Annuleren.",
    "label-yes": "Ja",
    "label-no": "Nee",
    "button-next": "Volgende",
    "button-previous": "Vorige",
    "button-newer": "Nieuwer",
    "button-older": "Ouder",
    "button-pay": "Betalen",
    "button-clear": "Geen",
    "title-go-back": "Ga terug",
    "label-skip": "Overslaan",
    "label-done": "Sluiten",
    "button-done": "Sluiten",
    "button-confirm": "Bevestigen",
    "button-deposit": "Storten",
    "title-heads-up": "Let op!",
    "title-new-version-notice":
      "Er is een nieuwe versie beschikbaar. Nu installeren?",
    "button-discard": "Weggooien",
    "discard-changes": "Wijzigingen weggooien",
    "title-attention": "Attentie",
    "button-add": "Toevoegen",
    "label-type": "Type",
    "label-typeclass": "Type class",
    "label-status": "Status",
    "title-dashboard": "Dashboard",
    "menuitem-dashboard": "Dashboard",
    "route-dashboard": "Dashboard",
    "title-todos": "Te doen",
    "label-period": "Periode",
    "label-invoice-number": "Factuurnummer",
    "label-bic": "BIC",
    "label-kvk": "KvK",
    iban: "IBAN",
    website: "Website",
    "label-website": "Website (voorbeeld: www.voorbeeld.nl)",
    "label-company-registry": "Kamer van Koophandel nr.",
    "label-iban": "Bankrekening Iban",
    "label-аmount": "Bedrag",
    "label-vat": "BTW",
    "label-vat-number": "BTW nummer",
    "label-excluding-vat": "Exclusief BTW",
    "label-including-vat": "Inclusief BTW",
    "label-include-payables": "Te betalen nota's",
    "label-include-unpaid-charges": "Onbetaalde nota's",
    "label-include-receivable": "Te ontvangen nota's",
    "label-include-snoozed-charges": "Gesnoozde nota's",
    "label-include-snoozed-payments": "Gesnoozde betalingen",
    "label-snoozed": "Snoozed",
    "label-not-sent": "Niet verzonden",
    "title-snooze-until": "Snooze tot",
    "label-include-snoozed-statements": "Gesnoozde afrekeningen",
    "label-still-to-be-paid": "Nog te betalen",
    "label-load-more": "Toon meer",
    "button-load-more": "Toon meer",
    "label-hide": "Verbergen",
    "label-hidden": "Verborgen",
    "label-hide-more": "Verberg meer",
    "label-currency": "Valuta",
    "error-text-currency": "Valuta",
    "currency-eur": "EUR",
    "currency-usd": "USD",
    "title-paid": "Betaald",
    "class-name-received": "Ontvangen",
    description: "Beschrijving",
    "label-description": "Beschrijving",
    subject: "Onderwerp",
    date: "Datum",
    status: "Status",
    content: "Content",
    "textfield-no-description": "geen beschrijving",
    "button-create": "Bewaren",
    "button-creating": "Bewaren...",
    "button-update": "Bewerken",
    "button-updating": "Bewerken...",
    "button-send": "Versturen",
    "button-send-pdf": "Versturen Factuur PDF",
    "button-create-invoice": "Afrekening afsluiten",
    "button-print-pdf": "Bekijken Factuur PDF",
    "button-view": "Bekijken",
    "button-preview-pdf": "Bekijken PDF",
    contracts: "Contracten",
    "textfield-contract": "Contract",
    "textfield-previous-contract": "Vorige contract: ",
    "title-contract": "Contract",
    "title-new-contract": "Nieuw contract",
    "label-new-contract": "Nieuw contract",
    "label-continue": "Doorgaan",
    "title-new-charge": "Nieuwe nota",
    "button-new-charge": "Nieuwe nota",
    "button-existing-charge": "Bestaande nota",
    "label-new-payment": "Nieuwe betaling",
    "title-new-payment": "Nieuwe betaling",
    "button-new-payment": "Nieuwe betaling",
    "button-existing-payment": "Bestaande betaling",
    "label-existing-payment": "Bestaande betaling",
    "title-charge-details": "Nota",
    "title-select-additional-charge": "Selecteer een volgende nota",
    "title-charge": "Nota",
    "title-invoice": "Factuur",
    "title-charges": "Nota's",
    "title-receivable-charges-unpaid-dashboard":
      "Nota’s - nog niet volledig ontvangen",
    "title-payable-charges-unpaid-dashboard":
      "Nota’s - nog niet volledig betaald",
    "title-payments-unused-dashboard":
      "Betalingen - nog niet volledig verwerkt",
    "label-charges": "Nota's",
    "label-contract-prices": "Contract bedragen",
    "title-contract-prices": "Bedrag",
    "title-property-prices": "Nota sjablonen",
    "subtitle-property-prices":
      "Laat automatisch nota's maken voor deze locatie",
    "subtitle-unit-prices": "Laat automatisch nota's maken voor dit huurobject",
    "button-add-price": "Nieuw bedrag",
    "button-add-charge-template": "Nieuwe nota sjabloon",
    "title-default-agency-fees": "Courtage",
    "hint-default-agency-fees":
      "The standaard waarden voor een nieuwe overeenkomst met een verhuurder",
    "title-property-default-agency-fees": "Courtage sjabloon",
    "subtitle-property-default-agency-fees":
      "Standaard courtage voor huurobjecten op deze locatie",
    "label/no-agency-fee": "Geen courtage",
    "title-unit": "Huurobject",
    "title-fullunit": "Huurobject",
    "label-unit": "Huurobject",
    "textfield-unit": "Huurobject",
    "label-contract": "Contract",
    "menuitem-units": "Vehuureenheden",
    "title-units-amount": ":amount Huurobjecten",
    "title-unit-amount": ":amount Huurobject",
    "title-units": "Huurobjecten",
    "title-property": "Locatie",
    "label-property": "Locatie",
    "title-payment": "Betaling",
    "title-properties": "Locaties",
    "label-contact": "Contactpersoon",
    "title-contacts": "Contactpersonen",
    "title-contact": "Contactpersoon",
    "textfield-date": "Datum",
    "label-amount": "Bedrag",
    "total-amount": "Geselecteerd: :amount",
    "label-total": "Totaal: :amount",
    "label-date": "Datum",
    "title-set-password": "Wachtwoord instellen",
    "title-please-wait": "Moment...",
    "button-please-wait": "Moment...",
    "button-close": "Sluiten",
    "button-close-and-next": "Sluiten en volgende",
    "button-open": "Openen",
    "button-send-confirmation-mail": "Stuur bevestiging email",
    "button-send-invite-mail": "Stuur email met uitnodiging ",
    "label-password": "Wachtwoord",
    "title-password": "Wijzig wachtwoord",
    "label-confirm-password": "Bevestig wachtwoord",
    "label-new-password": "Nieuw wachtwoord",
    "label-current-password": "Huidig wachtwoord",
    "button-change": "Wijzig",
    "label-changing": "Wijzigen...",
    "title-email": "Emаil",
    "label-email": "Emаil",
    "label-email-address": "E-Mail adres",
    "label-user-email": "Jouw email adres",
    "current-label-email": "Huidige email",
    "general-agency-label-email": "Algemeen bedrijfs e-mailadres",
    "label-search": "Zoeken",
    "label/searchcharge": "Zoek nota",
    "label/searchpayment": "Zoek betaling",
    "button-save": "Bewaren",
    "button-saving": "Bewaren...",
    "title-saving": "Bewaren...",
    "button-cancel": "Annuleren",
    "button-continue": "Doorgaan",
    "button-stop": "Stoppen",
    "menuitem-edit": "Bewerken",
    "menuitem-open": "Openen",
    "menuitem-edit-description": "Wijzigen beschrijving",
    "label-info": "Details",
    "label-history": "Geschiedenis",
    "tasks-notes-notifications-notfound":
      "Geen taken, notities of notificaties gevonden.",
    "button-remove": "Verwijderen",
    "menuitem-delete": "Verwijderen",
    "menuitem-delete-agreement": "Overeenkomst verwijderen",
    "menuitem-delete-person": "Contactpersoon verwijderen",
    "menuitem-delete-contract": "Verwijderen",
    "menuitem-delete-contract-hint": "Het contract definitief verwijderen",
    "menuitem-create-notification": "Nieuwe notificatie",
    "menuitem-create-notification-hint":
      "Maak een nieuwe notificatie voor dit contract",
    "menuitem-delete-unit": "Huurobject verwijderen",
    "menuitem-delete-property": "Adres verwijderen",
    "menuitem-delete-company": "Organisatie verwijderen",
    "menuitem-delete-charge": "Nota verwijderen",
    "menuitem-delete-payment": "Betaling verwijderen",

    // savings related
    "menuitem-undo-settle-with-savings": "Deze verrekening met het tegoed ongedaan maken",
    "menuitem-undo-savings-withdrawal": "Opname ongedaan maken",
    "hint/menuitem-undo-savings-withdrawal": "Deze opname uit het tegoed ongedaan maken",
    "menuitem-undo-savings-deposit": "Storting ongedaan maken",
    "hint/menuitem-undo-savings-deposit": "Deze storting in het tegoed ongedaan maken",
    "payment-details/menuitem-undo-settle-with-savings": "Verrekening ongedaan maken",
    "menuitem-undo-settle-charge-with-savings": "Verrekening ongedaan maken",
    "hint/menuitem-undo-settle-charge-with-savings": "De verrekening van deze nota ongedaan maken",
    
    "menuitem-undo-paid-directly-to-owner": "Directe betaling ongedaan maken",
    "hint/menuitem-undo-paid-directly-to-owner": "Deze nota werd niet direct aan de verhuurder betaald.",
    "menuitem-undo-credit-charge": "Creditering ongedaan maken",
    "hint/menuitem-undo-credit-charge":
      "De creditering voor deze nota ongedaan maken",
    "button-person": "Contactpersoon",
    "title-person": "Contactpersoon",
    "label-contactperson": "Contactpersoon",
    "label-person": "Persoon",
    "title-tenant": "Huurder",
    "title-manager": "Huismeester",
    "title-executor": "Uitvoerder",
    "label-tenant": "Huurder",
    "label-tenant-description": "Huurder (of vertegenwoordiger)",
    "label-user": "Gebruiker",
    "title-occupant": "Bewoner",
    "label-occupant": "Mede-huurder",
    "new-label-occupant": "Medehuurder",
    "label-occupants": "Bewoners",
    "new-label-occupants": "Medehuurders",
    "label-extra-persons": "Extra personen",
    "button-new-person": "Nieuwe contactpersoon",
    "button-add-executor": "Nieuw contact",
    "button-add-tenant": "Nieuwe huurder",
    "textfield-no-executor-found-click-add": "Geen contacten gevonden",
    "label-company": "Organisatie",
    "button-company": "Organisatie",
    "title-company": "Organisatie",
    "title-owner": "Eigenaar",
    "title-companies": "Organisaties",
    "label-company-name": "Naam organisatie",
    "label-owner-name": "Naam eigenaar",
    "title-new-company": "Nieuwe organisatie",
    "title-new-owner": "Nieuwe Eigenaar",
    "title-server-down": "Server onbereikbaar",
    "menuitem-new": "Nieuw",
    "title-page-not-found": "Pagina niet gevonden",
    "title-confirmation-link-expired":
      "Deze email bevesting link is niet meer geldig",
    "title-invite-link-expired":
      "Deze uitnodiging email link is niet meer geldig",
    "title-confirmation-link-expired-footer":
      "De link waarop je klikte is niet meer geldig. Klik op de knop hieronder en je onvangt een nieuwe.",
    "title-account-not-confirmed-header": "Account niet bevestigd",
    "account-confirmed": "Account bevestigd",
    "status-confirmed": "Bevestigd",
    "status-not-confirmed": "Niet bevestigd",
    "status-sent": "Verzonden",
    "statement-status/ready-for-review": "Klaar v. beoordeling",
    "statement-status/ready-to-send": "Klaar v. verzending",
    "title-account-not-confirmed-footer":
      "Jouw account bij Casadesk is niet bevestigd. Klik de link in de bevestiging email die is verzonden aan :email of klik op de knop hieronder op de email opnieuw te sturen.",
    "title-no-charges-to-list": "Klik Nieuwe nota en vul deze lijst.",
    "title-no-invoices-to-list": "Geen facturen gevonden",
    "pages/contract-section/price-info/totalmonthlyamount":
      ":amount totaal per maand",
    "pages/contract-section/price-info/pricenotfound":
      "Geen prijzen gevonden. Klik 'Nieuwe bedrag' om er een toe te voegen.",
    "pages/property-section/price-info/pricenotfound":
      "Geen nota sjablonen gevonden.",
    "title-no-charges-to-list-update":
      "No charges yet. Click the button 'Pay Charge' and start adding charges to your Casadesk system.",
    "title-no-charges-to-be-removed": "Geen nota's om te verwijderen",
    "title-no-default-agency-fees-to-list":
      "Klik nieuwe 'Nieuwe courtage' en vul deze lijst.",
    "title-property-no-units-to-list":
      "Klik Nieuw huurobject en vul deze lijst.",
    "title-no-units-to-list": "Geen huurobject gevonden.",
    "textfield-charge-was-deleted-you-can-find-payments":
      "De nota is verwijderd.",
    "title-no-payments-to-list": "Klik Nieuwe betalingn en vul deze lijst.",
    "title-bank-account": "Bankrekening",
    "label-bank-account": "Bankrekening",
    "label-bank-account-id": "Bankrekening nr.",
    "agency-profile-label-bank-account": "Bankrekening voor vastgoed beheer",
    "title-dropzone-upload-notice": "Sleep hier bestanden naartoe",
    "label-expiration-date-not-set": "Waarschuw datum ontbreekt",
    "title-select-charges-to-pay": "Selecteer te betalen notas",
    "textfield-no-unpaid-charges-for-unit":
      "Dit huurobject heeft geen onbetaalde nota's",
    "title-no-unpaid-charges-for-unit":
      "Dit huurobject heeft geen onbetaalde nota's",
    "title-only-inactive-units-can-be-deleted":
      "Alleen inactieve huurobjecten kunnen worden verwijderd. Dit huurobject inactief maken en verwijderen?",
    "symbol-infinity": "∞",
    "title-warning": "Waarschuwing",
    "menuitem-activate": "Als weer beschikbaar instellen",
    "button-activate": "Activeren",
    "menuitem-deactivate": "Als tijdelijk niet beschikbaar instellen",
    "menuitem-deactivate-hint":
      "Door een verbouwing of om andere reden is het huurobject tijdelijk niet beschikbaar",
    "menuitem-activate-hint": "Het huurobject is weer beschikbaar",
    "menuitem-archive": "Archiveren",
    "menuitem-archive-hint":
      "Zoals verwijderen maar dan niet definitief, je kunt het huurobject not terugvinden",
    "menuitem-unarchive-hint":
      "Het archiveren ongedaan maken en het huurobject weer beschikbaar maken",
    "label-unarchive": "Archiveren ongedaan maken",
    "label-deactivate": "Tijdelijk niet beschikbaar",
    "button-dont-save": "Niet bewaren",
    "title-users": "Gebruikers",
    "title-property-new-price": "Nieuw nota sjabloon",
    "subtitle-charge-new-price": "VVE bijdrage",
    "description-charge-new-price":
      "A new charge is created every selected period from the first day up to and including the last day",
    "title-property-price": "Locatie nota sjabloon",
    "button-show-more": "Toon meer",
    "button-show-less": "Toon minder",
    "button-ok": "Sluiten",
    "label-set-time-notification": "Bepaal tijdstip/notificatie",
    "menuitem-notifications": "Notificaties",
    "notifications-not-found": "Geen notificaties gevonden",
    "label-from-person-or-company": "Van persoon of organisatie",
    "button-paid-to": "Betaald aan",
    "title-paid-to": "Betaald aan",
    "label-paid-to": "Betaald aan",
    "label-received-from": "Ontvangen van",
    "title-received-from": "Ontvangen van",
    "menuitem-settle": "Verrekenen",
    "button-settle": "Verrekenen",
    "menuitem-unsettle": "Maak verrekening ongedaan",
    "button-unsettle": "Maak verrekening ongedaan",
    "button-unlink": "Ontkoppelen",
    "title-settle-charge": "Nota verrekenen",
    "title-charges-list": "Nota's lijst",
    "button-keep": "Behouden",
    "button-no-charge": "Nota nog niet bekend",
    "title-delete-contract": "Verwijder contract",
    "button-add-charge": "Nieuwe nota",
    "button-add-payment": "Nieuwe betaling",
    "button-add-contract": "Nieuw contract",
    "button-add-unit": "Nieuw huurobject",
    "button-add-property": "Nieuw adres",
    "button-new-property": "Nieuwe adres",
    "button-new-company": "Organisatie toevoegen",
    "button-add-note": "Nieuwe notitie",
    "button-add-attachment": "Bijlage toevoegen",
    "button-add-logo": "Upload logo",
    "button-add-agency-fee": "Nieuwe courtage",
    "title-add-agency-fee": "Nieuwe courtage",
    "button-add-user": "Nieuwe gebruiker",
    "title-system": "Systeem",
    "label-all-charges": "Alle nota's",
    "label-charge-for-contact": "Nota voor contactpersoon",
    "label-charge-for-company": "Nota voor organisatie",
    "label-charge-from-contact": "Nota van contactpersoon",
    "label-charge-from-company": "Nota van organisatie",
    "label-counterparty-iban": "Bankrekening tegenpartij",
    "label-counterparty": "Tegenpartij",
    "title-agency-fee-profile": "agency profile",
    "title-agency-fee-owner": "owner",
    "title-agency-fee-property": "property",
    "title-agency": "Kantoor",
    "label-click-set-the-end-date": "Klik hier om de eindatum te bepalen",
    "title-if-you-want-to-renew-the-contract":
      "Beëindig het contract niet indien je alleen gegevens wilt wijzigen zoals: huurbedrag, bewoner, huurobject,.. e.d. Klik in dat geval op op Vernieuw contract.",
    "menuitem-pay": "Verwerk betaling",
    "menuitem-quick-options": "Snelle opties",
    "menuitem-activities": "Activiteiten",
    "menuitem-consider-paidcharge":
      "Beschouw deze nota als betaald (betaling details onbekend)",
    "menuitem-settlepaymentwithsavings": "Verrekenen met tegoed",
    "hint/menuitem-settlepaymentwithsavings":
      "Het - resterende - bedrag verrekenen met het tegoed van :agencyName of een eigenaar",
    "menuitem-settlechargewithsavings": "Verreken met tegoed",
    "hint/menuitem-settlechargewithsavings": "Verreken deze nota met het tegoed",
    "menuitem-download-csv": "Download nota’s",
    "select-year-charts": "Selecteer het jaar waarvoor de nota’s worden gedownload",
    "select-year-charts-label": "Selecteer het jaar",

    "menuitem-create-credit-charge": "Maak een credit nota",
    "menuitem-set-charge-paid-to-owner": "Direct aan de eigenaar betaald",
    "hint/menuitem-set-charge-paid-to-owner":
      "De betaling komt niet binnen op de beheerrekening maar is direct aan de eigenaar voldaan",
    "page/chargeupdate-preprocess/paidtoowner-info":
      "De betaling voor deze nota is niet ontvangen op een bankrekening die met Casadesk wordt beheerd. De betaling wordt geregistreerd als betaald rechtstreeks aan de eigenaar.",
    "menuitem-create-credit-charge-for-receivable": "Credit nota",
    "button-create-credit-charge": "Maak een credit factuur",
    "hint/menuitem-create-credit-charge-for-receivable":
      "Maak of verwerk een creditnota voor een volledige of gedeeltelijke korting op deze nota",
    "menuitem-create-credit-charge-for-payable": "Verwerk een credit nota",
    "hint/menuitem-create-credit-charge-for-payable":
      "Een volledige of gedeeltelijke korting toepassen op deze nota",
    "page/chargeupdate-preprocess/credit-title": "Maak een credit nota",
    "page/chargeupdate-preprocess/credit-info":
      "Een credit nota wordt gemaakt, om deze nota ongedaan te maken, of om een korting te verlenen op deze nota.",
    "page/chargeupdate-preprocess/credit-defaultdescription": "Credit nota",
    "page/chargeupdate-preprocess/credit": "Credit",
    "hint/menuitem-undo-settle-with-savings":
      "Een eerdere verrekening met het tegoed ongedaan maken",
    "payment-details/hint/menuitem-undo-settle-with-savings":
      "De verrekening van deze nota ongedaan maken",
    "menuitem-consider-payment-used": "Beschouw deze betaling als verwerkt",
    "menuitem-consider-payment-fully-used":
      "Beschouw betaling volledig gebruikt",
    "menuitem-consider-payment-agencyfee":
      "Verwerk als betaling voor courtages",
    "menuitem-withdraw-from-agency-savings": "Opnemen van kantoor tegoed",
    "menuitem-consider-payment-income-for-agency":
      "Storten naar tegoed van :agencyname",
    "menuitem-agency-costs": "Verwerk als kosten voor :agencyName",
    "hint/menuitem-agency-costs":
      "Bijvoorbeeld de bankkosten, of andere kosten die niet door een eigenaar worden betaald",
    "menuitem-refund-payment": "Terugbetalen",
    "hint/menuitem-refund-payment":
      "De betaling is niet correct of onterecht ontvangen en wordt - deels - teruggestort",
    "title-click-continue-to-settle":
      "Click 'Continue' to settle charge :chargeToSettle with charge :chargeSelected",
    "title-charge-delete-from-charge-page-content-dialog":
      "De nota wordt verwijderd. Doorgaan?",
    "title-invoice-delete-from-charge-page-content-dialog":
      "De factuur wordt verwijderd. Doorgaan?",
    "title-payment-unsettle-from-charge-page-content-dialog":
      "De verrekening van de betaling wordt ongedaan gemaakt. Doorgaan?",
    "title-charge-was-created-to-settle-payments":
      "A charge was created to settle payment :paymentToSettle with payment :paymentSelected",
    "title-no-payments-to-list-without-button": "Geen betalingen gevonden",
    "title-payment-delete-from-payment-page-content-dialog":
      "De betaling wordt verwijderd. Doorgaan?",
    "dialog-info/removetransaction":
      "Verwijder deze transactie alleen indien er al een betaling bestaat voor deze transactie (om dubbelen te voorkomen). Verwijder deze transactie niet indien deze daadwerkelijk is gedaan via de bankrekening. Anders kunnen balans berekeningen voor deze bankrekening verkeerde resultaten produceren.",
    "title-charge-will-become-unpaid":
      "The charge will become unpaid. And you can use the payment to pay another charge.",
    "title-payment-unlink-from-payment-page-content-dialog":
      "De betaling wordt ontkoppeld van de nota. Doorgaan?",
    "title-date": "Date",
    "title-owners-reports": "Owners reports",
    "title-pay-charge": "Pay charge",
    "label-monthly": "Maandelijks",
    "title-monthly": "maandelijks",
    "label-id": "ID",
    and: "en",
    "label-percentagefee": "Percentage vergoeding",
    "title-welcome": "Welkom",
    "new-invoice": "Nieuw nota",
    "admin-fee":
      "Standaard administratiekosten voor het verrekenen van services",
    "label-more": "Meer...",
    "title-more": "Meer",
    "title-less": "Minder",
    "title-landlord": "Eigenaar",
    "title-start": "Start",
    "page/singup-dialog/confirmpassword": "Een email is verzonden naar :email.",
    "page/singup-dialog/confirmpassword-2":
      "Klik de link in de e-mail en kies een wachtwoord.",
    "label-direct": "Direct",
    "title-address": "Adres",
    "title-addresses": "Adressen",
    "change-address": "Wijzig adres",
    "link-counterparty": "Koppel tegenpartij",
    "unlink-counterparty": "Ontkoppel tegenpartij",
    "send-invoice-subject": "Afrekening",
    "label-landlord": "Verhuurder",
    "title-agreement": "Overeenkomst",
    "event-charge-settled": "Nota verrekend met andere nota",
    "event-charge-unsettled": "Verrekening met andere nota ongedaan gemaakt",
    "event-charge-settled-savings": "Nota verrekend met tegoed",
    "event-charge-unsettled-savings": "Verrekening met tegoed ongedaan gemaakt",
    "event-payment-refunded": "Betaling terugbetaald",
    "event-payment-unrefunded": "Terugbetaling ongedaan gemaakt",
    "event-charge-credited": "Nota gecrediteerd",
    "event-charge-uncredited": "Creditering ongedaan gemaakt",
    "event-charge-linked": "Nota gekoppeld",
    "event-charge-unlinked": "Nota ontkoppeld",
    "title-credit-invoice": "Credit factuur",
    "event-ponto-synchronization": "Ponto synchronization",
    "settlement-with-savings-description": "Verrekening met tegoed",
    "title-website-link": "Website link",
    "hint/title-website-link":
      "Publiceer deze link op de website en laat huurders inloggen bij het huurder portaal",
    "title-charge-delete-owner-tenant-from-charge-page":
      "Deze nota is onderdeel van een verrekening. Alle gerelateerde nota’s worden verwijderd.",
    "title-charge-locked-owner-tenant":
      "Verwijderen niet mogelijk. Onderdeel van gesloten afrekening.",
    "title-charge-not-allowed-to-delete-tenant-charge":
      "Verwijderen niet toegestaan. Onderdeel van een verrekening. Verwijder gerelateerde verhuurder nota.",

    /*
    |  Bank Transactions
    */

    "mt940-is-uploading": "Het MT940 bestand wordt geüpload. Moment...",
    "mt-940-is-processing": "Het MT940 bestand wordt verwerkt. Moment...",
    "you-have-verified-all-payments-from-file":
      "Alle betalingen van het MT940 bestand zijn gecontroleerd.",
    "status-verified": "Gecontroleerd",
    "status-not-verified": "Te controleren",
    verified: "gecontroleerd",
    "not-verified": "niet gecontroleerd",
    transaction: "Transactie",
    "to-verify": "Te controleren",
    "page/banktransactionfile-section/listoftransaction-info/transactionnotfound":
      "Klaar! Alle transacties zijn verwerkt.",
    removed: "Verwijderd",
    "wrong-charge-dialog-text":
      "De koppeling met de nota wordt ongedaan gemaakt.",
    "mt-940-0-payments-are-created": "Er zijn 0 betalingen gemaakt",
    "mt-940-does-not-have-payments":
      "Het bestand bevat geen bank transacties. Kies een ander.",
    "mt-940-not-all-payments-created":
      "Het bestand is verwerkt en er werden :transactionCount banktransacties gevonden. Voor deze :transactionCount banktransacties, zijn :paymentsCreatedCount betalingen gemaakt. Voor :paymentsNotCreatedCount banktransacties werden reeds eerder banktransacties gemaakt.",
    "mt-940-payments-amount": ":amount betalingen",
    "mt-940-processing-finished-1":
      "Het bestand met bank transacties is verwerkt met de volgende resultaten:",
    "mt-940-processing-finished-2":
      "Klik Doorgaan en start het controleren van de banktransacties.",
    "mt-940-processing-finished-2-close":
      "Klik Sluiten en start het controleren van de banktransacties.",
    "mt-940-processing-finished-total-count-payments":
      ":count bank transacties gevonden",
    "mt-940-processing-finished-created-count-payments":
      ":count betalingen gemaakt",
    "mt-940-processing-finished-existing-count-payments":
      "voor :count bank transacties bestaat al een betaling (deze bank transacties zijn eerder geupload)",
    "mt-940-processing-finished-not-recognized-count-payments":
      "voor :count transacties werd het formaat niet herkend (stuur een bericht aan Casadesk met het verzoek dit te onderzoeken)",
    "mt-940-uploading-is-crashed":
      "De server reageert niet, er is iets misgegaan. Probeer en upload het bestand opnieuw. Informeer Casadesk indien het probleem zich blijft herhalen.",
    "section/transactioncontrolbuttons-info/charges-were-found-1":
      "Deze betaling is automatisch gekoppeld aan een nota. Schakel naar Gecontroleerd indien dit inderdaad de juiste nota voor deze betaling is.",
    "section/transactioncontrolbuttons-info/charges-were-found-2":
      "Horen betaling en nota niet bij elkaar? Ontkoppel dan de nota en selecteer de juiste nota.",
    "section/transactioncontrolbuttons-info/charges-not-found-1":
      " Er werd geen nota gevonden voor deze betaling. Kies een bestaande nota, of maak een nieuwe nota, om aan deze betaling te koppelen. Schakel vervolgens naar Gecontroleerd.",
    "section/transactioncontrolbuttons-info/charges-not-found-2":
      "Nota nog niet bekend? Kies dan Nota nog niet bekend, en schakel naar Gecontroleerd.",
    "section/transactioncontrolbuttons-info/transactionverified":
      "Deze banktransactie is gecontroleerd. Klik Volgende.",
    "dialog/banktransactionfile-info/chargeunlink":
      "The charge are being unlinked.",
    "section/transactionconpaymentdetailsbuttons-info/transactionverified":
      "Deze banktransactie is gecontroleerd.",

    /*
    |  Breadcrumbs
    */

    /* list pages */
    "breadcrumbs-label-properties": "Adressen",
    "breadcrumbs-label-units": "Huurobjecten",
    "breadcrumbs-label-companies": "Organisaties",
    "breadcrumbs-label-contacts": "Contactpersonen",
    "breadcrumbs-label-owner-statements": "Financiële verslagen",
    "breadcrumbs-label-mails": "EMails",

    /* object page */
    "breadcrumbs-label-user": "Gebruiker",
    "breadcrumbs-label-notification": "Notificatie",
    "breadcrumbs-label-transaction-file": "Bank bestand",
    "breadcrumbs-label-property": "Adres",
    "breadcrumbs-label-unit": "Huurobject",
    "breadcrumbs-label-contract": "Contract",
    "breadcrumbs-label-tenant": "Huurder",
    "breadcrumbs-label-executor": "Uitvoerder",
    "breadcrumbs-label-manager": "Huismeester",
    "breadcrumbs-label-owner": "Eigenaar",
    "breadcrumbs-label-company": "Organisatie",
    "breadcrumbs-label-charge": "Nota",
    "breadcrumbs-label-payment": "Betaling",
    "breadcrumbs-label-bank-transaction": "Banktransactie",
    "breadcrumbs-label-agency-statement": "Financieel verslag kantoor",
    "breadcrumbs-label-owner-statement": "Afrekening periode",
    "breadcrumbs-label-task": "Taak",
    "breadcrumbs-label-note": "Notitie",
    "breadcrumbs-label-invoice": "Factuur",
    "breadcrumbs-label-activity-template": "Activiteit sjablonen",
    "breadcrumbs-label-activity": "Activiteit",
    "breadcrumbs-label-agency": "Kantoor",
    "breadcrumbs-label-conversation": "Conversatie",
    "breadcrumbs-label-agreement": "Overeenkomst",

    /* new pages */
    "breadcrumbs-label-new-property": "Nieuwe adres",
    "breadcrumbs-label-new-unit": "Nieuw huurobject",
    "breadcrumbs-label-new-contract": "Nieuw contract",
    "breadcrumbs-label-new-company": "Nieuwe organisatie",
    "breadcrumbs-label-new-person": "Nieuwe persoon",
    "breadcrumbs-label-new-tenant": "Nieuwe huurder",
    "breadcrumbs-label-new-executor": "Nieuw contact",
    "breadcrumbs-label-new-manager": "Nieuwe huismeester",
    "breadcrumbs-label-new-owner": "Nieuwe eigenaar",
    "breadcrumbs-label-new-user": "Nieuwe gebruiker",
    "breadcrumbs-label-new-charge": "Nieuwe nota",
    "breadcrumbs-label-new-payment": "Nieuwe betaling",
    "breadcrumbs-label-new-task": "Nieuwe taak",
    "breadcrumbs-label-new-note": "Nieuwe notitie",
    "breadcrumbs-label-new-invoice": "Nieuwe factuur",
    "breadcrumbs-label-new-activity-template": "Nieuwe activiteit sjablonen",
    "breadcrumbs-label-new-activity": "Nieuwe activiteit",
    "breadcrumbs-label-new-bill-settlement": "Verrekenen eindafrekening",

    /* menu pages */
    "breadcrumbs-label-finance": "Financiën",
    "breadcrumbs-label-finance-payments": "Betalingen",
    "breadcrumbs-label-finance-charges": "Nota's",
    "breadcrumbs-label-finance-banktransaction": "Bank",
    "breadcrumbs-label-finance-statements": "Afrekeningen",
    "breadcrumbs-label-finance-agencybalance": "Nota's voor kantoor",
    "breadcrumbs-label-finance-savings": "Tegoeden",
    "breadcrumbs-label-finance-reports": "Overzichten",
    "breadcrumbs-label-finance-invoices": "Facturen",
    "breadcrumbs-label-contact-persons": "Contactpersonen",
    "breadcrumbs-label-contact-companies": "Organisaties",
    "breadcrumbs-label-reports-ownerstatements": "Eigenaren",
    "breadcrumbs-label-reports-agencystatement": "Bureau",
    "breadcrumbs-label-reports-booklist": "Journaal",
    "breadcrumbs-label-reports-paylist": "Te betalen",
    "breadcrumbs-label-reports-overview": "Te ontvangen",
    "breadcrumbs-label-reports-balance": "Balans",
    "breadcrumbs-label-dashboard": "Dashboard",
    "breadcrumbs-label-dashboard-overview": "Start",
    "breadcrumbs-label-dashboard-tasks": "Taken",
    "breadcrumbs-label-dashboard-activities": "Activiteiten",
    "breadcrumbs-label-dashboard-statements": "Afrekeningen",
    "breadcrumbs-label-dashboard-contracts": "Contracten",
    "breadcrumbs-label-dashboard-notifications": "Notificaties",
    "breadcrumbs-label-dashboard-receivables": "Te ontvangen",
    "breadcrumbs-label-dashboard-payables": "Te betalen",
    "breadcrumbs-label-dashboard-unused": "Ongebruikt",
    "breadcrumbs-label-dashboard-notes": "Notities",
    "breadcrumbs-label-dashboard-messages": "Berichten",

    /* other */
    "breadcrumbs-label-settings": "Instellingen",
    "breadcrumbs-label-unit-charges": "Nota's huurobject",
    "breadcrumbs-label-renew-contract": "Contract vernieuwen",
    "breadcrumbs-label-charge-settle": "Nota verrekenen",
    "breadcrumbs-label-payment-settle": "Betaling verrekenen",
    "breadcrumbs-label-pay-charge": "Nota betalen",
    "breadcrumbs-label-pay-invoice": "Factuur betalen",
    "breadcrumbs-label-use-payment": "Betaling gebruiken",
    "breadcrumbs-label-default-unit-prices": "Standaard bedragen huurobject",
    "breadcrumbs-label-new": "Nieuw",
    "breadcrumbs-label-confirm-task": "Bevestig taak",
    "breadcrumbs-label-send-email": "Stuur email",

    /* dashboard subtitle*/
    "dashboard-charges/subtitle": "Koppel aan een betaling, of snooze nog even",
    "dashboard-payments/subtitle": "Koppel aan een nota, of snooze nog even",
    "dashboard-statements/subtitle": "Verzend nu, of snooze nog even",
    "dashboard-contracts/subtitle":
      "Deze huurobjecten hebben geen getekend contract, of het contract loopt af",

    /*
    |  Charge
    */

    "charge-is-locked":
      "Deze nota kan niet worden gewijzigd omdat hij is opgenomen in een financieel verslag",
    "charge-is-fully-paid": "De nota is reeds volledig betaald",
    "you-can-not-create-payment-charge-is-fully-paid":
      "Voor deze nota kan geen betaling worden ingevoerd. De nota is reeds volledig betaald. Gebruik de betaling voor een andere nota of verwijder eerst een betaling bij deze nota.",
    "please-choose-an-existing-charge-and-click-create":
      "Selecteer een bestaande nota",
    "please-choose-an-existing-charge-and-click-continue-to-finish":
      "Please choose an existing charge and click 'Continue' button to finish transaction",
    "please-choose-an-existing-charge-and-click-continue":
      "Please choose an existing charge and click 'Continue' button",
    "page/chargeupdate-link/sendreminder": "Stuur een betaalherinnering",
    "page/chargeupdate-link/sendreminder-hint":
      "Stuur een betaalherinnering indien de nota nog niet - volledig - is betaald",

    // Charge Create

    "for-period": "Periode afrekening",
    "charge-for-period": "Nota voor periode",
    "first-date-for-period": "Eerste dag periode ",
    "button-create-extra-charge": "Gebruik voor andere nota",
    day: "Dag",
    month: "Maand",
    year: "Jaar",
    "title-charge-type": "Nota type",
    "charge-type-name": "Label",
    "charge-class-id-type": "Type",

    // Charge Settle

    "amount-paid": "Bedrag betaald",
    "due-date-payment": "Vervaldatum betaling",
    "no-end-date": "geen einddatum",
    "click-continue-to-settle-charge":
      "Klik 'Doorgaan' om :chargeToSettle met :chargeSelected te verrekenen",
    "payment-was-created-to-settle-charges":
      "Voor het verrekenen van :chargeToSettle met :chargeSelected is een speciale vereken betaling gemaakt",
    "please-select-charge-from-list": "selecteer nota in deze lijst",

    // Charge Template

    "label-repeat-period": "Herhaal periode",
    "repeat-period-once": "Eenmaal",
    "repeat-period-weekly": "Weekelijks",
    "repeat-period-monthly": "Maandelijks",
    "repeat-period-yearly": "Jaarlijks",
    "due-date-for-first-payment":
      "Vervaldatum 1ste betaling (indien afwijkend van gebruikelijke vervaldag)",
    "label-payment-offset": "Te betalen uiterlijk",
    "due-date-offset": "Due date offset",
    "payment-offset-first-day-of-period": "eerste dag periode",
    "payment-offset-minus-3-day": "3 dagen voor start periode",
    "payment-offset-minus-2-day": "2 dagen voor start periode",
    "payment-offset-minus-1-day": "1 dag voor start periode",
    "payment-offset-plus-1-day": "1 dag na start periode",
    "payment-offset-plus-2-day": "2 dagen na start periode",
    "payment-offset-plus-3-day": "3 dagen na start periode",
    "payment-offset-week-after": "1 week na start periode",
    "payment-offset-week-before": "1 week voor start periode",
    "first-date-of-payment": "Datum eerste betaling",
    "end-date-of-payment": "Laatste betalingsdatum",
    "default-unit-prices":
      "Standaard bedragen huurobject (voor nieuwe contracten)",
    "default-unit-prices-short": "Standaard bedragen huurobject",
    "create-default-price-for": "Bepaal standaard prijzen voor",
    "charge-template-type-rent": "Huur",
    "charge-template-type-parking": "Parkeerplaats",
    "charge-template-type-deposit": "Borg",
    "charge-template-type-administration-fee": "Administratie kosten",
    "charge-template-type-agency-fee": "Courtage",
    "charge-template-type-late-fee": "Te laat betalen boete",
    "charge-template-type-deposit-refund": "Borg retour",
    "charge-template-type-loss": "Afschrijving",
    "charge-template-type-utilities": "Nutsvoorzieningen",
    "charge-template-type-water": "Water",
    "charge-template-type-gas": "Gas",
    "charge-template-type-electricity": "Elektriciteit",
    "charge-template-type-taxes": "Belastingen",
    "charge-template-type-banking-costs": "Bank kosten",
    "charge-template-type-other-receivable": "Te ontvangen overig",
    "charge-template-type-other-payable": "Te betalen overig",
    "charge-template-type-payout": "Uitbetalen",
    "charge-template-type-surplus": "Te veel ontvangen",

    /*
    |  Payment
    */

    "status-used": "Gebruikt",
    "status-unused": "Ongebruikt",
    "status-partially-used": "Gedeeltelijk gebruikt",
    unused: "Ongebruikt",
    "pay-charge": "Betaal nota",
    payment: "Betaling",
    payments: "Betalingen",
    "title-payments": "Betalingen",
    "title/deposits-and-withdrawals": "Stortingen en opnames",
    "payment-not-found": "Betaling niet gevonden",
    "payment-is-fully-used": "Betaling reeds voledig gebruikt",
    "payment-is-removed": "Payment is removed",
    "balance-for-contract": "Nota's voor contract",
    "balance-for-property": "Nota's voor adres",
    "balance-for-unit": "Nota's voor huurobject",
    "balance-for-activity": "Nota's voor activiteit",
    "balance-for-company": "Nota's voor organisatie",
    "agency-balance": "Nota's voor kantoor",
    "profit-loss-balance": "Winst en verlies balans",
    "owner-statement-for": "Afrekening voor",
    "download-owner-statement": "Download financieel verslag",
    "download-agency-statement": "Download agency statement",
    to: "Aan",
    from: "Van",
    "from-lowercase": "van",
    "to-lowercase": "aan",
    with: "Met",
    "add-a-message": "Voeg bericht toe",
    summary: "Samenvatting",
    "details-for": "Details voor inkomsten en uitgaven",
    "owner-savings-for": "Tegoed", 
    "payment-type-cash-description": "Nota is contant betaald",
    "payment-type-bank-description": "Nota is per bank betaald",
    "payment-type-cheque-description": "Nota is met een cheque betaald",
    "payment-type-from-deposit-description":
      "Verlaagt de borg doo rmiddel van betaling ",
    "payment-creation-type-manual": "Handmatig",
    "payment-creation-type-transaction-file": "Banktransactie bestand",
    "payment-creation-type-pay-until": "Betaal tot functie",
    reference: "Referentie",
    "ledger-account": "Balans rekening",
    "bank-transaction": "Banktransactie",
    verify: "Controleer",
    "payment-successfully-processed": "Betaling succesvol verwerkt",
    "create-an-extra-payment": "Maak een extra betaling",
    "you-are-going-to-pay-create-extra-payment":
      "Er wordt :paymentAmount van :chargeAmount betaald voor nota. Nog een betaling maken voor het resterende bedrag?",
    "fill-info-about-new-payment":
      "Verstrek hieronder de gegevens van de betaling en betaal de nota hierboven genoend",
    "select-one-payment-to-pay-charges":
      "Selecteer een betaling hieronder om de nota hierboven te betalen",
    "click-finish-to-pay":
      "Klik Afronden om :chargesSum te betalen met :paymentAmount.",
    "can-not-update-settle-payment":
      "Een verreken betaling kan niet worden gewijzigd.",
    "can-not-update-settle-charge":
      "Een verreken nota kan niet worden gewijzigd.",
    "payment-created": "Betaling gemaakt",
    "you-paid-the-last-charge-of-contract":
      "Alle nota's van dit contract zijn betaald. De balans wordt niet langer getoond bij het huurobject. De balans vind je terug in het contract, tab financieel",
    "payments-might-have-been-unlinked":
      "Betalingen kunnen opnieuw beschikbaar zijn gekomen na het verwijderen van de nota. Gebruik deze betalingen voor het betalen van andere nota's. Je vindt deze betalingen terug in: Financieel | Betalingen.",
    "no-charges-found": "Geen nota's gevonden",
    "button-click-create-extra-payment":
      "Click 'Create extra payment' to create an extra payment for the charge.",
    "button-click-skip-extra-payment":
      "Click 'Skip' if you want to settle the charge later.",
    "charge-created": "Charge created",
    "do-you-want-to-create-extra-charge":
      "You are about to use a payment of :paymentAmount to pay a charge of :chargeAmount. That leaves an extra amount available of :additionalChargeAmount.",
    "do-you-want-to-create-extra-charge-2": `Click button "Create charge" to create an extra charge for :additionalChargeAmount. Or click "Skip" to do it later.`,
    "title-use-for-additional-charge": `Click "Use for additional charge" to use the extra amount available for another charge.`,
    "title-use-for-additional-charge-2": `Click "Skip" if you want to use the extra amount available later.`,
    "create-an-extra-charge": "Maak een extra nota",
    "using-agency-fee": "The agency fee settings inherited from the",
    "payment-and-charge-should-have-same-classes":
      "Koppelen van een te betalen nota met een ontvangen betaling, of een te ontvangen nota met een betaalde betaling, is niet mogelijk.",
    "button-create-extra-payment": "Maak aanvullende betaling",
    "button-settle-the-difference": "Verreken het verschil",
    "payment-is-locked":
      "Deze betaling kan niet worden gewijzigd omdat hij is opgenomen in een financieel verslag",
    "include-paid-charges": "Inclusief betaalde nota's",
    "please-link-unused-payments":
      "Betaal nota's met de betalingen of verwijder ze.",
    "click-continue-to-settle-payment":
      "Klik 'Doorgaan' om :chargeToSettle met :chargeSelected te verrekenen",
    "charges-were-settled":
      "Nota :chargeToSettle is succesvol verrekend, ey nota :chargeSelected",
    "click-to-replace-iban":
      "Klik Wijzigen om :oldIban te vervangen door :newIban voor :person",
    "payment-from": "Betaling van",
    "please-choose-an-existing-payment":
      "Please choose an existing charge and click save button to finish transaction",
    "title-remove-savings-payment-warning":
      "Deze nota of betaling kan niet worden verwijderd. Het is onderdeel van een storting, opname of verrekening met het tegoed. Kies voor ongedaan maken.",
    cannot_use_option_modified_true:
      "Cannot use the options, please save data and try again",

    // Payment Link

    "title-additional-charge-for-payment": "Volgende nota voor betaling",
    "title-use-payment": "Betaling gebruiken om nota te betalen",

    // Payment Create

    "you-are-about-to-stop":
      "Stoppen met het controleren van banktransacties. Open het bestand met transacties om weer door te gaan met controleren. Stoppen?",
    "pay-charges": "Betaal nota(s)",
    "which-starts-on-day": "die start op datum:",
    "charge-from": "Te betalen aan:",
    "charge-for": "Te ontvangen van:",
    charge_already_is_fully_paid: "Deze nota is al volledig betaald!",
    contract_is_not_signed_yet: "Het contract is nog niet getekend",

    // Payment Settle

    "title-settle-payment": "Betaling verrekenen",
    "title-settle-payment-warning":
      "Deze betaling verrekenen is niet meer mogelijk. De betaling is al volledig verwerkt.",

    /*
    |  Finance
    */

    "label-finance": "Financiën",
    "title-finance": "Financiën",
    "upload-mt940-file": "Upload bank transacties",
    link: "Link",
    linking: "Linkt...",
    "menuitem-use": "Gebruiken",
    linked: "Gekoppeld",
    "menuitem-unlink": "Maak betaling ongedaan",
    unlinked: "Betaling ongedaan gemaakt",
    unlinking: "Betaling wordt ongedaan gemaakt...",
    uploading: "Uploaden...",
    processing: "Verwerken...",
    "processing-file": "Verwerken MT940 bestand",
    "processing-notice": "Verwerken bank transacties.",
    processed: "Verwerkt",
    "processing-x-of-y": "Verwerken :x van :y",
    "linked-payments-so-far":
      "Voor :linked betalingen zijn nota's gevonden en is de betaling automatisch verwerkt.",
    "transaction-files": "Transactie bestanden",
    "bank-transactions": "Bank transacties",
    "title-bank": "Bank",
    "bank-transaction-upload-notice": "Uploaden bank transacties...",
    success: "Succes",
    error: "Fout",
    "create-charge": "Nieuwe nota",
    "create-payment": "Create payment",
    "payments-processed": ":x betalingen verwerkt",
    "unlink-succeeded": "Link verbroken",
    "charge-payment-unlinked":
      "De link tussen nota en betaling is verbroken. De betaling is nu beschikbaar om een andere nota mee te betalen. Je vindt de betaling in Financiën | Betalingen.",
    overdue: "Te laat",
    "change-section/charge-info/relatedtoobject-object":
      "Wijzig het object van deze nota",
    "bank-accounts": "Bankrekeningen",
    "delete-bank-account": "Verwijder bankrekening",
    "you-are-about-to-delete-bank-account":
      "Bankrekening :name :number wordt verwijderd. Dit kan niet ongedaan worden gemaakt. Doorgaan?",
    "add-bank-account": "Nieuwe bankrekening",
    "bank-account-number": "Bankrekening nummer",
    default: "Standaard",
    "this-payment-is-fully-used-you-can-not-link":
      "Deze betalig is volledig gebruikt. Het is niet langer beschikbaar een om nota mee te betalen.",
    "use-this-charge-to-settle": "Verreken met deze nota",
    "use-this-payment-to-settle": "Verreken met deze betaling",
    "select-charge-to-settle-with": "Selecteer een nota om mee te verrekenen",
    "select-payment-to-settle-with":
      "Selecteer een betaling om mee te verrekenen",
    "fill-out-the-payment-details": "Betalinggegevens invullen",
    "no-charges-found-select-other-object":
      "Geen nota's gevonden. Selecteer een contract, huurobject, locatie of organisatie ",
    "pay-with-payment": "Selecteer nota voor betaling",
    "use-this-payment-to-pay": "Gebruik deze betaling",
    "no-transactions-to-list":
      "Klik 'Upload transacties' en selecteer het bestand met banktransacties van uw bank.",
    "transactions-list-notice":
      "Klik 'Upload transacties' en selecteer het MT-940 bestand van uw bank.",
    "bank-accounts-subtitle": "De bankrekeningen om de huur op te ontvangen",

    /*
    |  Property
    */

    "property-address": "Selecteer adres",
    "dropdown-searchforddress-label": "Selecteer adres",
    "no-manager-found-click-add":
      "No caretaker found. Click 'New caretaker' and create a new one",
    "property-page-property-update-units-related-to-property":
      "Huurobjecten op deze locatie",
    "no-properties-to-list-for-property":
      "Klik Nieuwe locatie en vul deze lijst.",

    /*
    |  Person
    */

    "personcreate-newperson-title": "Nieuwe persoon",
    persons: "Contactpersonen",
    "title-persons": "Contactpersonen",
    "person-pick": "Kies een contactpersoon",
    "managercreate-newmanager-title": "Nieuwe Huismeester",
    "button-add-person": "Nieuwe persoon",
    "contract-create-button-add-person-to-contract":
      "Persoon toevoegen aan contract",
    "contract-update-button-add-person-to-contract":
      "Persoon toevoegen aan contract",
    "contract-renew-button-add-person-to-contract":
      "Persoon toevoegen aan contract",
    "no-person-found-click-add":
      "No person found. Click 'Add person' and create a new one",
    "new-tenant": "Nieuwe huurder",
    "page/companyupdate-section/person-info/nopersonsfound":
      "Geen personen gevonden",
    "page/persons-info/nopersonsfound": "Geen personen gevonden.",
    "menuitem-send-mobile-app-link": "Stuur mobiele app link",
    "page/personupdate-preprocess/sendlink-info":
      "Send an email to the owner with a link to access the mobile app for owners. Continue?",
    "option-new-person": "Nieuwe persoon",
    "option-existing-person": "Bestaande persoon",

    /*
    |  Unit
    */

    "create-unit": "Nieuw huurobject",
    "tenant-contact-info": "Contactgegevens huurder",
    "unit-number": "Nummer huurobject",
    "unit-type": "Type huurobject",
    "unit-type-room": "Kamer",
    "unit-type-studio": "Studio",
    "unit-type-apartment": "Appartement",
    "unit-type-house": "Huis",
    "unit-type-house-boat": "Woonboot",
    "unit-type-commercial-space": "Commerciële ruimte",
    "unit-type-garage": "Garage",
    "unit-type-villa": "Villa",
    "unit-type-senior-accomodation": "Senior accommodatie",
    "unit-type-live-in-guardian": "Inwonend",
    "unit-type-bungalow": "Bungalow",
    "unit-type-live-workspace": "Woon-werkruimte",
    "unit-type-no-preference": "Onbekend",
    "unit-type-complex": "Wooncomplex",
    "new-property": "Nieuwe locatie",
    "new-address": "Nieuwe adres",
    "old-address": "Oud adres",
    "new-unit": "Nieuw huurobject",
    "square-meters": "Vierkante meters",
    rooms: "Aantal kamers totaal",
    "separate-bedrooms": "Aantal afzonderlijke slaapkamers",
    bathrooms: "Aantal badkamers",
    "publication-title": "Publicatie titel",
    "no-unit-found-click-add":
      "Geen huurobject gevonden. Klik 'Nieuw huurobject' om er een te maken.",
    "add-new-default-charge-template": "Nieuwe nota",
    "no-default-charges-to-list":
      "Geen standaard bedragen gevonden. Klik 'Nieuw bedrag' om er een te maken.",
    "showing-count-x-of-y-units": "Toont :x van :y huurobjecten",
    "you-can-not-make-changes-when-unit-is-not-active":
      "Bijwerken kan niet als het huurobject inactief is",
    "unit-is-inactive": "Huurobject is inactief",

    /*
    |  Contract
    */

    end: "Beëindigen",
    "menuitem-end": "Beëindigen",
    "menuitem-clear-end-date": "Einddatum verwijderen",
    "menuitem-renew": "Vernieuwen",
    "button-renew": "Vernieuwen",
    "launchpanel/option-renew": "Vernieuw dit contract",
    "launchpanel/option-adjust": "Huur aanpassen",
    "launchpanel/send-adjust": "Stuur huuraanpassing gegevens",
    "launchpanel/contract-option/createchargetemplate":
      "Contract bedrag toevoegen",
    "launchpanel/contract-option/createchargetemplate-hint":
      "Een door de huurder te betalen bedrag toevoegen aan het contract",
    sign: "Ondertekenen",
    proforma: "Proforma",
    "create-contract": "Nieuw contract",
    "end-contract": "Beëindig contract",
    "end-agency-fee": "End agency fee",
    "end-charge-template": "End charge template",
    "renew-contract": "Vernieuw contract",
    "update-date": "Bijwerken datum",
    "charges-will-be-created-to-this-point":
      "De status wijzigt naar 'Ondertekend'. Dit kan niet meer worden gewijzigd. De nota's voor dit contract worden nu automatisch gemaakt",
    "sign-contract-first-charge-will-be-created-on-date":
      "Het contract wordt getekend. The eerste nota wordt gemaakt voor :firstDate",
    "charges-which-were-removed": "Nota's die zijn verwijderd",
    "dialog/postprocess-removecharges-info1":
      "De lijst met nota’s wordt nu bijgewerkt. Dit kan enkele minuten duren.",
    "you-are-about-to-set-end-date":
      "Bepaal de datum voor de laatste dag. Zodra de financiën (borg verrekenen e.d.) zijn afgerond wordt het contract gesloten.",
    "you-are-about-to-continue-contract":
      "Het contract wordt doorgezet. Selecteer een nieuwe waarschuw datum voor het contract.",
    "if-you-want-change-contract-click-renew":
      "Indien je wijzigingen wilt maken (huurder, bewoner, huur,..) klik Vernieuwen.",
    "set-new-date-or-renew":
      "Bepaal een nieuwe waarschuw datum of vernieuw het contract en werk zaken bij als huurder, bewoner, huur,.. e.d.",
    "contract-sign-warning":
      "De status van het contract wordt Ondertekend. Dit kan niet ongedaan worden gemaakt.",
    "contract-sign-warning-1":
      "De huurnota's worden automatisch gemaakt met ingang van :firstDate.",
    "contract-sign-warning-2":
      "De financiele startdatum in Casadesk voor :agencyName is :financialStartDate. Er worden geen nota’s gemaakt voor de periode voor deze datum.",
    "contract-sign-warning-3":
      "Deze regel voorkomt dat nota's worden gemaakt voor de verleden tijd.",
    "agreement-sign-warning":
      "De status van het overeenkomst wordt Ondertekend. Dit kan niet ongedaan worden gemaakt.",
    "agreement-sign-warning-1":
      "De nota's worden automatisch gemaakt met ingang vanaf :firstDate.",
    "agreement-sign-warning-2":
      "De financiele startdatum in Casadesk voor :agencyName is :financialStartDate. Er worden geen nota’s gemaakt voor de periode voor deze datum. Deze regel voorkomt dat nota's worden gemaakt voor de verleden tijd.",
    "agreement-sign-warning-3":
      "De nota's worden automatisch gemaakt met ingang vanaf de eerste dag van het eerstvolgende nieuwe contract.",
    "unit-does-not-have-default-charges-yet":
      "Dit huurobject heeft nog geen standaard vergoedingen. Nu de standaard vergoedingen instellen?",
    "first-date": "Eerste dag",
    "renew-date": "Vernieuw datum",
    "last-date": "Laatste dag",
    "last-date-1st-expiration-date": "1ste vervaldag contract",
    "expiration-date": "Vervaldatum",
    "date-pay-charges-until": "Datum betaal nota tot",
    "final-date-2nd-expiration-date": "2de vervaldag contract",
    "final-date": "Tweede vervaldatum",
    "end-date": "Einddatum (definitief laatste huurdag)",
    "label/end-date": "Einddatum",
    "contract-expiration-date": "Notificatie datum",
    "hint/contractexpirationdate":
      "Op de notificatie datum ontvang je een melding in verband met een aankomende vervaldatum",
    "last-date-of-period-cannot-be-earlier-then-first-date":
      "De laatste datum kan niet voor de eerste datum liggen",
    "last-date-of-period-pretty-close":
      "Info: de laatste dag ligt erg kort na de eerst dag.",
    "last-date-agreed-contract":
      "The last date is the last day of the period agreed in the contract.",
    drop: "Vervallen",
    "cancel-the-contract": "Contract annuleren",
    "contract-ended": "Contract beëindigd",
    "no-tenant-found-click-add":
      "Niets gevonden. Probeer opnieuw of klik Nieuwe huurder.",
    "no-contracts-to-list":
      "Geen contracten gevonden. Klik 'Nieuw contract' en maak er een.",
    "set-end-date": "Einddatum instellen",
    "clear-end-date": "Verwijderen einddatum",
    "page/agreementupdate-launchpanel/setenddate": "Einddatum instellen",
    "page/agreementupdate-launchpanel/setenddate-hint":
      "Bepaal de laatste datum waarvoor een vergoeding nota moet worden gemaakt",
    "page/agreementupdate-launchpanel/clearenddate": "Einddatum verwijderen",
    "page/agreementupdate-launchpanel/clearenddate-hint":
      "Wanneer de gekozen einddatum verkeerd is",
    "page/agreementupdate-launchpanel/delete-hint":
      "De overeenkomst definitief verwijderen",
    "set-warning-date": "Instellen waarschuwdatum",
    "change-warning-date": "Wijzigen notificatiedatum",
    "end-contract-modal-title": "Beëindigen contract",
    "end-agency-fee-modal-title": "Einddatum instellen voor courtage",
    "expiration-contract-modal-title": "Bepaal waarschuw datum voor cotract",
    "end-charge-template-modal-title": "Bepaal eindatum voor nota sjabloon",
    "end-date-not-set": "Einddatum ontbreekt",
    "mark-past-invoices-as-paid-until":
      "Maak automatisch de betalingen voor alle nota's tot datum:",
    "you-created-concept-contract":
      "De contractgegevens zijn vastgelegd. De status van het contract is nu 'Concept'. Zodra de status wijzigt naar 'Ondertekend', worden automatisch de nota's gemaakt.",
    "first-date-in-the-past-ask-automatically-create-payments":
      "De eerste dag van het contract ligt in het verleden. Klik Doorgaan en alle nota's in het verleden worden automatisch voorzien van een betaling. Klik Overrslaan en alle nota's in het verleden blijven onbetaald.",
    "want-to-change-the-rent":
      "De huur aanpassen voor dit contract? Klik dan op Vernieuwen.",
    "you-can-not-update-signed-contract": "You can not update signed contract",
    "you-did-not-create-charge-rent":
      "Er is nog geen nota sjabloon gemaakt voor de huur. Nu zo’n nota sjabloon maken? Met een nota sjabloon worden huur nota’s automatisch gemaakt.",
    "you-did-not-create-charge-deposit":
      "Er is nog geen nota sjabloon gemaakt voor de borg. Nu zo’n nota sjabloon maken? Met een nota sjabloon wordt de nota voor de borg automatisch gemaakt.",
    "you-did-not-create-agency-fee":
      "Je hebt geen courtage geregistreerd. Alsnog doen?",
    "you-can-delete-only-concept-contracts":
      "Dit contract kan niet worden verwijderd. Zodra een contract de status 'Ondertekend' heeft, kan het niet meer worden verwijderd.",
    "sign-the-contract-to-create-charges":
      "Onderteken het contract en maak nota's",
    "no-charges-sign-the-contract-to-create-charges":
      "Nog geen nota's voor dit contract.",
    "contract-update-dialog-sign-post-process-message-1":
      "De status is gewijzigd naar Ondertekend.",
    "contract-update-dialog-sign-post-process-message-2":
      "Vanaf nu worden nota’s automatisch gemaakt. Zodra gereed, vind je die nota’s terug op de tab Financiën.",
    "you-can-not-update-charge-templates-for-active-contract":
      "Een ondertekend contract kan niet meer worden gewijzigd. Fout gemaakt die moet worden verbeterd? Verwijder dan dit contract en maak een nieuw. Dit contract houden maar vernieuwen? Klik dan de knop Vernieuwen.",
    "menuitem-create-charges-for-next-period": "Volgende huurnota maken",
    "dialog/createchargesfornextmonth-info":
      "De huurnota’s voor de periode :period worden gemaakt.",
    "dialog/preprocess-createchargesnextmonth/title": "Maak huurnota’s",
    "email/subject-rent-adjust": "Huurwijziging",

    //Collective invoice coach
    "launchpanel-menuitem/createfirstinvoice": "Huuroverzicht voor huurder",
    "launchpanel-menuitem/createlastinvoice": "Eindnota voor huurder",
    "coach/collectiveinvoice-step/first-title": "Selecteer de nota’s",
    "coach/collectiveinvoice-step/second-title": "Vervaldatum",
    "coach/collectiveinvoice-step/third-title": "Afronden",
    "coach/collectiveinvoice-step/first-info":
      "Selecteer de nota’s voor het huuroverzicht",
    "coach/collectiveinvoice-step/second-info":
      "Selecteer de uiterste betaaldatum voor de nieuwe huurder",
    "coach/collectiveinvoicefirst-step/third-info":
      "De factuur voor de nieuwe huurder wordt gemaakt. Bekijk en print de factuur, of verzend de factuur per email naar de nieuwe huurder",
    "coach/collectiveinvoicefinal-step/third-info":
      "De factuur voor de huurder wordt gemaakt. Bekijk en print de factuur, of verzend de factuur per email naar de huurder",
    "coach/collectiveinvoice-preprocess/info":
      "Er zijn geen nota’s gevonden. Controleer of het contract is getekend, en de eerste nota’s zijn gemaakt",
    "coach/collectiveinvoice-preprocess/infonotfoundcharges":
      "Alle nota’s voor dit contract zijn betaald. Een eindafrekening om onbetaalde nota’s te verrekenen is dus niet nodig.",
    "preprocess/collectiveinvoice-info/alreadycreatedinvoice":
      "De eerder gemaakte factuur opnieuw gebruiken, of een nieuwe factuur maken en vervangen?",
    "preprocess/collectiveinvoice-info/alreadycreatedinvoiceoption":
      "Bekijk en print de factuur, of verzend de factuur per email naar de nieuwe huurder.",
    "coach-error-duedate": "Vervaldatum",
    "coach-error-chargeids": "Nota's",
    "coach/collectiveinvoice-scenario/company-step/fourth-errorinfo2":
      "Ga terug en verhelp het probleem, of klik 'Annuleren' en probeer het later opnieuw.",
    "coach/collectiveinvoice-preprocess/infoisnotsigned":
      "Het contract is nog niet getekend. Wijzig de status van het contract naar getekend en probeer opnieuw.",
    "coach/collectiveinvoice-preprocess/enddateisnotset":
      "Bepaal eerst de einddatum",
    "launchpanel-menuitem/createextracharge": "Extra nota voor huurder",

    // Settle charge coach
    "coach/settlecharge-step/first-info":
      "Selecteer een nota en klik Verrekenen",
    "coach/settlecharge-step/second-info":
      "De nota's zijn met elkaar verrekend",

    // Settle payment coach
    "coach/settlepayment-step/first-info":
      "Selecteer een betaling en klik Verrekenen",
    "coach/settlepayment-step/second-info":
      "De betalingen zijn succesvol verrekend",

    // Renew
    "click-finish-to-create-new-contract":
      "Klik 'Afronden' om het contract te vernieuwen en als getekend te veronderstellen.",

    /*
    |  Contact/Company/User
    */

    phone: "Telefoon",
    "agency-phone": "Algemeen telefoonnummer",
    "phone-1": "Telefoon 1",
    "phone-2": "Telefoon 2",
    "label-mob-number": "Mobiele telefoon",
    "other-phone": "Andere telefoon",
    profession: "Functie",
    address: "Zoek adres",
    "label-address": "Adres",
    role: "Rol",
    "role-admin": "Administrateur",
    "role-none": "Geen",
    "role-owner": "Eigenaar",
    "role-occupant": "Bewoner",
    "role-tenant": "Huurder",
    "role-user": "Gebruiker",
    "role-vendor": "Leverancier",
    "role-manager": "Manager",
    "role-mede-huurder": "Mede-huurder",
    "type-owner": "Eigenaar",
    "type-vendor": "Leverancier",
    "date-of-birth": "Geboortedatum",
    "place-of-birth": "Geboorteplaats",
    "identity-document-type": "ID document type",
    "identity-document-number": "ID document nummer",
    "identity-document-type-passport": "Paspoort",
    "identity-document-type-driving-licence": "Rijbewijs",
    "identity-document-type-identity-card": "ID kaart",
    "gender-type": "Geslacht",
    "language-type": "Taal",
    "can-not-update-removed-person": "Can not update removed person",
    "can-not-update-removed-company": "Can not update removed company",
    "no-company-found-click-add":
      "No company found. Click 'Add company' and create a new one",
    "company-update-persons-related-to-company":
      "Contactpersonen van deze organisatie",
    "company-update-persons-related-to-owner":
      "Contactpersonen van deze eigenaar",
    "company-update-properties-related-to-owner": "Locaties van deze eigenaar",
    "company-update-properties-related-to-company":
      "Locaties van deze organisatie",
    "no-contacts-to-list": "Klik Nieuwe contactpersoon en vul deze lijst.",
    "no-companies-to-list": "Klik Nieuwe organisatie en vul deze lijst.",
    "page/companyupdate-section/property-info/propertyforcompanynotfound":
      "Geen locaties gevonden.",
    "you-are-about-to-delete-user":
      ":name wordt verwijderd. Dit kan niet ongedaan worden gemaakt. Doorgaan?",
    "verification-email-sent":
      "Klik de verificatie link in het bericht dat is gezonden naar :newEmail. Totdat het nieuwe e-mail adres is geverifieerd, blijft het actieve e-mail adres :currentEmail.",
    "system-sent-notification-to-new-user":
      "Een uitnodging met link is per email aan de nieuwe gebruiker verzonden.",
    "invitation-email-sent": "Uitnodiging verzonden",
    "new-executor": "Nieuw contact",
    "new-user": "Nieuwe gebruiker",
    "broken-month-calculation": "Gebroken maand berekening",
    "delete-user": "Verwijderen gebruiker",
    "user-info": "Gebruiker informatie",
    "change-email": "Wijzig email",
    "new-email": "Nieuwe email",
    "confirm-email": "Herhaal nieuwe email",
    "confirm-email-should-be-equal": "Email adressen zijn niet gelijk",
    "title-savings": "Tegoeden",
    "button-withdrawal": "Opname tegoed",
    "page/companyupdate-section/statements-tab/finance-info/nostatementsfound":
      "Geen afrekeningen gevonden.",
    "title-no-statements-to-list": "Geen afrekeningen gevonden.",

    /*
    |  Attachments
    */

    attachments: "Bijlagen",
    "attachments-for-person":
      "Bijlagen voor deze persoon (documenten en afbeeldingen)",
    "attachments-for-caretaker":
      "Bijlagen voor deze huismeester (documenten en afbeeldingen)",
    "attachments-for-executor":
      "Bijlagen voor deze uitvoerder (documenten en afbeeldingen)",
    "attachments-for-tenant":
      "Bijlagen voor deze huurder (documenten en afbeeldingen)",
    "attachments-for-company":
      "Bijlagen voor deze organisatie (documenten en afbeeldingen)",
    "attachments-for-owner":
      "Bijlagen voor deze eigenaar (documenten en afbeeldingen)",
    "attachments-for-property":
      "Bijlagen voor deze locatie (documenten en afbeeldingen)",
    "attachments-for-address":
      "Bijlagen voor deze address (documenten en afbeeldingen)",
    "attachments-for-unit":
      "Bijlagen voor dit huurobject (documenten en afbeeldingen)",
    "attachments-for-contract":
      "Bijlagen voor dit contract (documenten en afbeeldingen)",
    "attachments-for-agency":
      "Bijlagen voor dit kantoor (documenten en afbeeldingen)",
    "attachments-for-task":
      "Bijlagen voor deze taak (documenten en afbeeldingen)",
    "attachments-for-conversation":
      "Bijlagen voor deze conversatie (documenten en afbeeldingen)",
    "private-attachments-for-task":
      "Bijlagen die prive moeten blijven (documenten en afbeeldingen)",
    "shared-attachments-for-note":
      "Bijlagen die kunnen worden gedeeld (documenten en afbeeldingen)",
    "private-attachments-for-note":
      "Bijlagen die prive moeten blijven (documenten en afbeeldingen)",
    "attachments-for-invoice":
      "Bijlagen voor deze factuur (documenten en afbeeldingen)",
    "attachments-for-activity":
      "Bijlagen voor deze activiteit (documenten en afbeeldingen)",
    "attachments-for-user":
      "Bijlagen voor deze gebruiker (documenten en afbeeldingen)",
    "title-attachments": "Bijlagen",
    "attachments-for-charge":
      "Bijlagen voor deze nota (documenten en afbeeldingen)",
    "attachments-for-email": "Bijlagen voor deze e-mail",
    /*
    |  Agency fee
    */

    "fixed-fee": "Vaste vergoeding",
    "percentage-fee": "Percentage vergoeding",
    "fixed-plus-percentage-mode": "Vast plus percentage vergoeding",
    "agreement-card/percentagefee-label": "Percentage",

    /*
    |  Notification
    */

    "amount-to-pay": "Bedrag te betalen",
    "due-date": "Vervaldatum",
    "continue-contract": "Doorgaan contract",
    "you-are-about-to-set-expiration-date":
      "De waarschuw datum voor het contract wordt aangepast. Een waarschuwing verschijnt nu op deze datum.",
    "open-notification-details": "Zie notificatie details",
    "open-activity-details": "Open activity details",
    "open-task-details": "Open task details",
    "task-details": "Taak details: ",
    "days-ago": "dagen geleden",
    "unpaid-charges": "Onbetaalde nota's",
    "notification-details": "Notificatie details",
    "unpaid-charge": "Onbetaalde nota",
    "unpaid-invoice": "Onbetaalde factuur",
    "charge-was-sent": "Nota is verzonden",
    "invoice-was-sent": "Factuur is verzonden",
    "email-was-sent-to": "EMail is verzonden aan:",
    "email-was-sent": "EMail is verzonden",
    number: "Nummer",
    "unpaid-notification-was-created-because":
      "Deze notificatie is er omdat de nota niet op tijd is betaald. Neem contact op met de huurder, of snooze deze notificatie.",
    "event-update-contract-prices-was-created-because-part-1":
      "Controleer of het contract moet worden vernieuwd en de bedragen aangepast. Klik op de contract link hieronder om dit nu te doen. Of kies voor Sluimeren om het later te doen.",
    "event-update-contract-prices-was-created-because-part-2":
      "Deze notificatie werd gemaakt als een jaarlijkse herinering om vast te stellen of de bedragen nog correct zijn.",
    "open-charge-details": "Zie nota details",
    "open-tenant-details": "Zie huurder details",
    "open-contract-details": "zie contrac details",
    "open-unit-details": "zie huurobject details",
    created: "Gemaakt",
    "expiring-contracts": "Aflopende contracten",
    "no-notifications": "Geen notifications",
    expires: "Loopt af",
    "expiring-contract": "aflopend contract",
    "expiring-notification-was-created-because":
      "Deze notificatie is gemaakt vanwege de waarschuw datum van het contract. Mogelijk veloopt het contract binnenkort. Ga na of het contract moet worden Beëindigd. Zo niet, stel dan een nieuwe waarschuw datum in.",
    "unpaid-charge-notification": "Nota onbetaald notificatie",
    "unpaid-notification-deactivated-charge-fully-paid":
      "De nota onbetaald notificatie is inmiddels inactief omdat de nota is betaald",
    "unpaid-notification-not-deactivated-charge-partly-paid":
      "De nota onbetaald notificatie is niet inactief gemaakt omdat de nota slechts deels betaald is",
    "notification-information": "Notificatie informatie",
    "contract-notification": "Notificatie",
    "expiring-contract-notification": "Expiring contract notification",
    snooze: "Snooze",
    unsnooze: "Niet meer snoozen",
    "snooze-date-will-be-removed":
      "de sluimerdatum wordt verwijderd en de notificatie weer actief",
    "snooze-for-days": "Sluimer voor (dagen)",
    "snooze-until-date": "Sluimer tot (datum)",
    or: "of",
    "you-can-snooze-for-1-day": "Sluimer voor minstens 1 dag",
    "email-was-saved": "Email was saved",

    /*
    |  Activities and Tasks
    */

    "activity-templates": "Activiteiten",
    "new-activity": "Nieuwe activiteit",
    activity: "Activiteit",
    "status-open": "Open",
    "status-close": "Sluit",
    "status-closed": "Voltooid",
    "status-finished": "Voltooid",
    "activitytemplatecreate-addactivity-title": "Nieuwe activiteit sjabloon",
    "page/setting-tab/activities-field/newactivity-type/button":
      "Nieuwe activiteit",
    "create-activities-with-tasks": "Maak activiteiten met taken",
    "determine-name-for-activity":
      "Verstrek de naam van de nieuwe activiteit sjabloon en voeg taken toe.",
    "determine-name-for-activity-2":
      "Met een activiteit sjabloon maak je met 1 klik een groep taken voor een check in, incident,.. e.d. Activiteit sjablonen zijn beschikbaar bij huurobjecten.",
    "activity-name": "Naam activiteit",
    tasks: "Taken",
    "new-task": "Nieuwe taak",
    "new-note": "Nieuwe notitie",
    "number-of-tasks": "Aantal taken",
    "delete-activity": "Verwijder activiteit",
    "delete-note": "Delete note",
    "you-are-about-to-delete-activity":
      "De activiteit ':name' verwijderen? Dit kan niet ongedaan worden gemaakt.",
    "you-are-about-to-delete-task":
      "De taak ':name' verwijderen? Dit kan niet ongedaan worden gemaakt.",
    "you-are-about-to-delete-note":
      "De notitie verwijderen? Dit kan niet ongedaan worden gemaakt.",
    "you-are-about-to-delete-event":
      "De notitie gebeurtenis? Dit kan niet ongedaan worden gemaakt.",
    "create-individual-task": "Nieuwe taak",
    "menuitem-add-task": "Nieuwe taak",
    "button-add-task": "Nieuwe taak",
    "button-add-activity": "Nieuwe activiteit",
    "menuitem-create-task": "Taak maken",
    "charge-details/menuitem-create-task": "Nieuwe taak",
    "confirm-task": "Bevestig taak",
    "you-are-about-to-create-task-for-unit":
      "Er wordt een taak gemaakt voor huurobject :unit.",
    "you-are-about-to-create-task-for-property":
      "Er wordt een taak gemaakt voor locatie :property.",
    "registered-by": "Geregistreerd door",
    "assigned-to-me": "Door mij te doen",
    "include-closed": "Voltooide taken",
    "include-closed-messages": "Inclusief voltooid",
    "include-still-to-show": "Gesnoozde taken",
    "to-show-on": "Te tonen op",
    "include-activities-tasks": "Inclusief activiteit taken",
    "created-by-me": "Door mij gemeld",
    instructions: "Instructie",
    instruction: "Instructie",
    "to-do-by": "Behandelaar",
    "reported-by": "Gemeld door",
    assignee: "Behandelaar",
    reporter: "Melder",
    "to-be-executed-on-or-before": "Doen op of voor",
    "final-date-for-task": "Te doen op of voor",
    "show-me-from": "Snooze deze taak tot",
    "show-me-from-task-dialog": "Snooze deze taak tot",
    "days-to-execute": "Dagen resterend",
    "minimum-one-day": "Minimaal 1 dag",
    "no-tasks-created": "Geen taken gevonden",
    "create-tasks-associated-with-the-activity":
      "Maak de taken voor deze activiteit",
    "delete-task": "verwijder taak",
    "this-field-is-required": "Deze informatie is noodzakelijk",
    "label-overview": "Overzicht",
    "unfinished-tasks": "Onvoltooide taken",
    "no-tasks": "Geen taken",
    task: "Taak",
    incident: "Incident",
    "menuitem-finish": "Afronden",
    "menuitem-unfinish": "Onvoltooide",
    "button-finish": "Afronden",
    "button-finish-task": "Taak afronden",
    "button-close-task": "Sluit taak",
    "button-reopen-task": "Heropen taak",
    "button-unfinish-task": "Onvoltooide taak",
    "you-are-about-to-finish-task":
      "Taak ':name' wordt verwijderd uit de lijst 'Openstaande taken'.",
    "you-are-about-to-unfinish-task":
      "You are about to unfinish ':name' task. The task will be marked as undone.",
    "edit-task": "Taak",
    "update-task": "Bewaren",
    "activity-template": "Activiteit sjablonen",
    "create-tasks-for": "Nieuwe activiteit :activityTemplate",
    "you-are-about-to-create-task-for-activity-for-unit":
      "Maak een nieuwe activiteit ':activityTemplate' met taken voor: :unit.",
    "you-are-about-to-create-task-for-activity-for-property":
      "Maak een nieuwe activiteit ':activityTemplate' met taken voor: :property.",
    "create-tasks": "Nieuwe activiteit",
    "confirm-tasks": "Bevestig taken",
    "deselect-tasks-you-do-not-want-to-apply":
      "Taken die je niet nodig hebt kunt je uitvinken. Ook kun je taken toevoegen. Zorg dat de taken de juiste persoon, instructies en uitvoeringsdatum hebben.",
    "task-was-finished": "Taak :task nog niet klaar",
    "task-was-created": "Task :task gemaakt",
    "task-was-updated": "Task :task bijgewerkt",
    "task-was-removed": "Task :task was verwijderd",
    "task-for-unit-done": "Betreft :unit",
    "task-for-unit-created": "Betreft :unit",
    "task-for-unit-updated": "Betreft :unit",
    "task-for-unit-removed": "Betreft :unit",
    "task-for-property-done": "Betreft :property",
    "task-for-property-created": "Betreft :property",
    "task-for-property-updated": "Betreft :property",
    "task-for-property-removed": "Betreft :property",
    "done-by-executor": "gedaan door :executor",
    "page/activity-field/name-label": "Naam",
    "new-task-based-on-conversation":
      "Nieuwe taak op basis van deze conversatie",

    /*
    |  Timeline
    */

    timeline: "Tijdlijn",
    note: "Notitie",
    "type-a-note": "Type een notitie...",
    "please-enter-a-note": "Type een notitie",
    memo: "Memo",
    "memo-text": "Memo tekst",
    "add-memo": "Memo toevoegen",
    "menuitem-add-memo": "Memo",
    "launch-panel-add-memo": "Open de memo",
    "remove-memo": "Verwijder memo",
    "to-set-a-notification":
      "Kies een datum en tijd in de toekomst om een notificatie in te stellen",
    time: "Time",
    due: "Verschuldigd",
    by: "door",
    for: "door",
    reminder: "Reminder",
    "launch-panel-pay-charge": "Verwerk betaling voor deze nota",
    "hint/launch-panel-pay-charge":
      "Registreer een betaling (wanneer die niet als banktransactie binnenkomt)",
    "launch-panel-settle-charge": "Verreken met andere nota",
    "hint/launch-panel-settle-charge": "Verreken deze nota met een andere nota",
    "launch-panel-settle-payment": "Verrekenen met een andere betaling",
    "hint/launch-panel-settle-payment":
      "Deze betaling - deels - verrekenen met een andere betaling",
    "launch-panel-send-payment-by-email": "Stuur per e-mail",
    "hint/launch-panel-send-payment-by-email":
      "Stuur details van de betaling per e-mail naar wie jij wilt",
    "hint/launch-panel-send-task-by-email":
      "Stuur deze taak per e-mail naar wie jij wilt",
    "launch-panel-register-charge": "Nieuwe nota op basis van deze betaling",
    "hint/launch-panel-register-charge":
      "Op basis van deze betaling wordt een nota gemaakt, bijvoorbeeld voor een automatisch afgeschreven energierekening",
    "payment-date": "Datum betaling",
    "launch-panel-add-memo-for-charge": "Bewerken memo voor deze nota",
    "launch-panel-add-extra-charge-for-unit": "Maak een extra nota",
    "menuitem-open-memo": "Memo openen",
    "charge-details/menuitem-open-memo": "Memo",
    "hint/launch-panel-renew-contract":
      "Huurverhoging doorvoeren, een bedrag toevoegen of bewoner aanpassen",
    "hint/launch-panel-adjust-contract":
      "De bedragen van het huurcontract bekijken en aanpassen",
    "hint/launch-panel-adjust-contract-unitpage":
      "De bedragen van het actieve huurcontract bekijken en aanpassen",
    "hint/launch-panel-set-end-date-contract":
      "Wanneer de huurder heeft opgezegd en de laatste huurdatum vast staat",
    "hint/launch-panel-clear-end-date-contract":
      "Wanneer de ingestelde einddatum verkeerd is",
    "hint/launch-panel-create-extra-charge":
      "Extra eenmalige kosten voor de huurder, of een bedrag te ontvangen door de huurder",
    "hint/launch-panel-create-charge-uncoming-period":
      "Vast de volgende huurnota maken om bijvoorbeeld een vooruitbetaling te verwerken",
    "hint/launch-panel-create-rent-statement":
      "Overzicht van de nota’s die de huurder moet betalen",
    "hint/launch-panel-create-final-statement":
      "De bedragen nog te verrekenen met de huurder, inclusief retour borg",
    "hint/launch-panel-drop":
      "Wanneer het contract niet door alle partijen zal worden getekend",
    "hint/launch-panel-remove": "Het contract definitief verwijderen",
    "launch-panel-send-tenant-portal-link-hint":
      "Via de portal kan de huurder een storing melden (zichtbaar in dashboard | berichten)",
    "launch-panel-unit-extra-charge-hint":
      "Extra eenmalige kosten voor de eigenaar van dit huurobject, of juist een te ontvangen bedrag (een belastingteruggave bijvoorbeeld)",
    "launch-panel-create-contract": "Nieuw huurcontract",
    "hint/launch-panel-create-contract":
      "Maak een concept huurcontract voor een nieuwe huurder",
    "launch-panel-bill-settlement": "Verrekenen eindafrekening",
    "hint/launch-panel-bill-settlement":
        "Verdeel een eindafrekening (water, elektriciteit, verwarming,..) over de huurders", 
    "launch-panel-create-agreement": "Nieuwe verhuur- of beheerovereenkomst",
    "hint/launch-panel-create-agreement":
      "Maak een concept overeenkomst voor de afspraken met de eigenaar",
    "launch-panel-create-default-contract-amount": "Standaard huurbedragen",
    "launch-panel-create-default-contract-amount-hint":
      "Bijwerken van de standaard bedragen voor een nieuw huurcontract",
    "launch-panel-move-unit": "Huurobject verplaatsen",
    "launch-panel-move-unit-hint":
      "Het huurobject koppelen aan een andere locatie / adres",
    "launch-panel-create-pdf": "Maak PDF",
    "launch-panel-create-pdf-hint":
      "Maak een PDF document met de details van de nota",
    "contract-launch-panel-create-pdf": "Maak PDF",
    "contract-launch-panel-create-pdf-hint":
      "Maak een PDF document met de contract details",
    "launch-panel-create-invoice": "Maak factuur",
    "launch-panel-create-invoice-hint":
      "Factuurnummer toevoegen en de definitieve PDF maken",
    "notification-rent-message": "Huurprijs aanpassen",
    "launch-panel-send-to-landlord": "Stuur naar verhuurder",
    "hint/launch-panel-send-to-landlord":
      "Stuur de details van dit contract naar de verhuurder. Dit is inclusief de details van de voorgaande versie van het contract, indien beschikbaar.",

    /*
    |  Event
    */

    event: "Gebeurtenis",
    notification: "Notificatie",
    "by-user": "(door :user)",
    "event-charge-overdue-title": "Vervalt (:daysd)",
    "event-charge-overdue-reason":
      "Nota ( :charge ) is vervallen. Het had betaald moeten zijn op :date.",
    "event-invoice-overdue-reason":
      "Factuur ( :charge ) is vervallen. Het had betaald moeten zijn op :date.",
    "event-contract-expiring-title": "Verloopt",
    "event-contract-ending-title": "Eindigt",
    "event-contract-expiring-reason":
      "Contract voor huurder ( :tenant ) en huurobject ( :unit ) verloopt op :date.",
    "event-contract-ending-reason":
      "Contract voor huurder ( :tenant ) en huurobject ( :unit ) eindigt op :date.",
    "event-contract-ended-title": "Beëindigd",
    "event-contract-ended-reason": "Contract Beëindigd op :date.",
    "event-system-created-title": ":entity gemaakt",
    "event-system-updated-title": ":entity bijgewerkt",
    "event-system-removed-title": ":entity verwijderd",
    "created-owner-statement": "Nieuw finacieel verslag",
    "owner-statement-was-created": "Financieel verslag voor :month is gereed.",
    "owner-statement-was-sent":
      "Financieel verslag voor :month is verzonden aan de eigenaar.",
    "owner-statement-warning": "Financieel verslag waarschuwing",
    "owner-statement-type-agency": "Kantoor",
    "owner-statement-type-owner": "Eigenaar",
    "owner-statement-type-tenant": "Huurder",
    "send-owner-statement-for": "Zend financieel verslag voor :month",
    "sent-owner-statement": "Zend financieel verslag",
    "owner-statement": "Afrekening",
    "owner-statement-closed": "Afgesloten",
    // carry: "Transport", // deprecated: carry info is no longer presented nor used otherwise
    payout: "Uitbetaling",
    view: "Bekijk",
    "exclusive-vat": "Exclusief BTW",
    "total-agency-services": "Totaal dienstverlening",
    "total-to-pay-by-owner": "Totaal te betalen door",
    "to-be-paid-to-owner": "Te betalen",
    "to-be-received-from-owner": "Te ontvangen",
    "total-sum-charges-for-month":
      "Totaal van de te ontvangen en te betalen nota's in",
    "total-expences": "Totaal uitgaven",
    "total-sum-payments-for-month": "Totaal inkomsten ontvangen",
    "details-for-the-result": "Details voor",
    "this-is-first-owner-statement":
      "Dit is het eerste financieel verslag voor jou. Dit verslag bevat alle nota's van deze periode, en alle voorgaande perioden.",
    totals: "Totalen",
    "charges-paid-in": "Nota's betaald in",
    "late-payments": "Late betalingen",
    "to-be-paid": "Te betalen door :ownername",
    "to-be-received": "Te ontvangen door :ownername",
    "to-be-paid-small-first-letter": "te betalen door :ownername",
    "to-be-received-small-first-letter": "te ontvangen door :ownername",
    "paid-by-owner-small-first-letter": "betaald door :ownername",
    "received-by-owner-small-first-letter": "ontvangen door :ownername",
    "paid-by-owner": "Betaald door :ownername",
    "received-by-owner": "Ontvangen door :ownername",
    "still-to-be-paid": "Nog te betalen door :ownername",
    "still-to-be-received": "Nog te ontvangen door :ownername",
    "already-settled": "Reeds betaald",
    "still-to-be-received-from-the-beginning":
      "Nog te ontvangen aan het begin van :period (van vorige afrekening)",
    "still-to-be-received-for-month": "Niet ontvangen in",
    "still-to-be-received-at-the-end":
      "Nog te ontvangen aan het einde van :period (naar volgende afrekening)",
    "create-owner-statement-send-it-to-owner":
      "Maak een financieel verslag en stuur het naar de eigenaar",
    "charge-paid-with-payment": "Nota :charge werd betaald",
    "charge-and-payment-were-unlinked":
      "De betaling :payment voor nota :charge is ongedaan gemaakt",
    "company-and-person-were-linked":
      "De persoon :person is toegevoegd aan de organisatie :company",
    "event-details": "Event details",
    "event-update-contract-prices": "Aanpassen contract bedragen",
    "event-statement-was-created": "Afrekening gemaakt",
    "event-statement-was-closed": "Afrekening afgesloten",
    "amount-to-credit": "Bedrag te crediteren",

    // Event details update window (Unit update titles)
    "title-updated-unit-number": "Updated Unit Number",
    "title-updated-unit-type-id": "Updated Unit Type Id",
    "title-updated-paid-status-id": "Updated Paid Status Id",
    "title-updated-square-meters": "Updated Square Meters",
    "title-updated-room-number": "Updated Room Number",
    "title-updated-bedroom-number": "Updated Bedroom Number",
    "title-updated-bathroom-number": "Updated Bathroom Number",
    "title-updated-publication-title": "Updated Publication Title",
    "title-updated-unit-status-id": "Updated Unit Status Id",
    "title-updated-planning-data": "Updated Planning Data",
    "title-updated-note": "Updated Note",

    /*
    |  Settings
    */

    "label-settings": "Instellingen",
    "title-settings": "Instellingen",
    "menuitem-settings": "Instellingen",
    "settings-user-profile": "Gebruiker",
    "settings-user-profile-title": "Profiel gebruiker",
    "settings-agency-profile": "Kantoor",
    "settings-agency-profile-panel": "Profiel kantoor",
    "settings-email-subject": "E-Mail onderwerp",
    "settings-agency-profile-panel-subtitle":
      "Naam, Adres, Bankrekeningnummer, Website, Telefoonnummer,…",
    "settings-agency-preferences-panel-subtitle":
      "Standaard instellingen nieuwe gebruiker, nieuwe contract, nieuwe nota,…",
    preferences: "Voorkeuren",
    "agency-preferences": "Voorkeuren kantoor",
    "agency-logo-section": "Bedrijfslogo",
    "agency-logo-section-subtitle":
      "Het logo wordt gebruikt in emails, facturen, rapporten en andere documenten",
    language: "Taal",
    "use-beta-version-features": "Activeer beta versie functionaliteiten",
    "hint-bankaccount-info":
      "Dit bankrekeningnummer wordt vermeld op de facturen",
    "label/agency-general-contact": "Algemeen contactpersoon voor beheer",
    "label/company-general-contact": "Algemeen contactpersoon",
    "hint-agency-short-name":
      "Beperk tot 12 letters. Wordt bijvoorbeeld gebruikt in een sms bericht ",
    "use-show-review-features": "Beoordeel afrekeningen",
    "use-not-show-username-features": "Gebruik het algemeen adres als afzender",
    "settings/agencyprofile-info/notshowusername-link":
      "Algemeen e-mail adres instellen",

    /*
    |  Reports
    */

    reports: "Overzichten",
    "title-reports": "Overzichten",
    "title-statements": "Afrekeningen",
    "title-statements-dashboard": "Afrekeningen - klaar om te verzenden",
    "owner-statements-for": "Financiële verslagen voor",
    "agency-statements": "Bureau",
    "agency-statement": "Agency statement",
    "title-agency-statements": "Resultaten",
    "agency-statement-for": "Agency statement for",
    "financial-statement": "Financieel verslag",
    "created-with-casadesk": "Created with Casadesk",
    "owner-statements-subtitle": "Afrekening voor de eigenaar",
    "financial-report-for": "Afrekening voor",
    result: "Resultaat",
    "payout-section-title/previouspayoutcharges":
      "Voorgaande afrekeningen :period",
    "payout-section-title/newactualpayoutcharge": "Afrekening :period",
    "payout-section-title/additionalactualpayoutcharge":
      "Aanvullende afrekening :period",
    "payout-section-title/ofwhichsettled": "Betaald en/of verrekend",
    "payout-section-title/settlements": "Te verrekenen",
    "payout-section-title/topay": "Resteert te betalen",
    "payout-section-title/savings": "Tegoed",
    "preprocess/lockstatement-info/beforesend":
      "Na afsluiten is het niet meer mogelijk om deze afrekening en haar nota’s te wijzigen.",
    "preprocess/lockstatement-info/beforeprint":
      "Voor deze afrekening wordt een factuur gemaakt en de afrekening op Verzonden gezet. Eenmaal gemaakt kan de factuur niet meer worden verwijderd. Doorgaan?",
    "preprocess/lockstatement-info/needactivateinvoicing":
      "Factureren staat nog niet aan. Om factureren aan te zetten ga je naar Instellingen | Kantoor profiel. Deze optie is alleen beschikbaar voor een beheerder",
    "preprocess/lockstatement-error/statementoutdated-info/needactivateinvoicing":
      "De afrekening is gewijzigd. Bekijk nog eens en probeer opnieuw.",
    "button-download": "Download",
    "page/reports-tab/booklist-title": "Journaal",
    "page/reports-tab/booklist-info": "Download het journaal voor de periode:",
    "page/reports-tab/paylist-title": "Te betalen",
    "page/reports-tab/paylist-info":
      "Overzicht van te betalen nota’s die nog niet - volledig - zijn voldaan.",
    "page/reports-tab/overview-title": "Te ontvangen",
    "page/reports-tab/overview-info":
      "Overzicht van te ontvangen nota’s die nog niet - volledig - zijn voldaan.",
    "page/reports-tab/balance-title": "Balans",
    "page/reports-tab/balance-section-title": "Balans voor huurobjecten",
    "page/reports-tab/balance-info":
      "Download de balans voor huurobjecten voor de periode:",
    "owner-statements-to-invoice-status": "Te factureren",
    "owner-statements-all-invoiced-status": "Gefactureerd",
    "preprocess/createinvoice": "De factuur wordt gemaakt. Doorgaan?",

    /*
    |  Invoices
    */

    invoices: "Facturen",
    "title-invoices": "Facturen",

    /*
    |  Filters
    */

    all: "Alle",
    empty: "Leeg",
    unpaid: "Onbetaald",
    rented: "Verhuurd",
    "all-payments": "Alle betalingen",
    "unused-payments": "Ongebruikte betalingen",
    "all-charges": "All charges",
    unfinished: "Onvoltooid",
    "all-active": "Alle (actief)",

    /*
    |  Mail System
    */

    message: "Bericht",
    reason: "Resultaat verbinding:",
    logs: "EMail server zegt:",
    mail: "EMail",
    mails: "EMails",
    "my-email-account": "Mijn Email Account",
    "user-email-accounts": "Gebruiker Email Accounts",
    "agency-email-accounts": "Kantoor Email Accounts",
    active: "Actief",
    inactive: "Inactief",
    "new-email-account": "Nieuw Email Account",
    "add-email-account": "Toevoegen nieuw email account",
    "update-email-account": "Bijwerken email account",
    imap: "IMAP",
    "imap-user": "IMAP Gebruiker",
    "imap-password": "IMAP Wachtwoord",
    "imap-host": "IMAP Host",
    "imap-port": "IMAP Port",
    "email-provider": "Email provider",
    "no-emails-to-list": "Klik Nieuw email adres en vul deze lijst.",
    "email-was-changed": "Het email adres is gewijzigd",
    "email-was-successfully-changed":
      "het email adres is succesvol gewijzigd. Gebruik vanaf nu het nieuwe email adres wanneer je in Casadesk inlogt",
    "unsubcribed-successfully": "Succesvol afgemeld",
    "mail-box-mail-page": "EMail box",
    "title-mail-box-mail-page": "EMail box",
    "mail-page-title": "EMail page",
    "email-box-page-no-emails-list-admin":
      "There are no agency email accounts activated. Click on 'Add Email Account' button to create a new agency email account, or activate an existing account in the mail settings: 1.Go to Settings 2.Go to Mail tab 3.Choose and update the account you want to use.",
    "email-box-page-no-emails-list-manager":
      "Your agency has no activated agency email account yet. Contact with the administrator for more details",
    "email-box-page-no-emails-list-admin-active":
      "Agency email accounts ‌are activated. Casadesk updates emails every 10 minutes. Your emails will be displayed here.",
    "mail-page-detail-title": "EMail details",
    "mails-pagee-mail-accounts": "EMail accounts",
    "history-url-mail-details": "EMail details",
    "history-url-mails": "EMails",
    "setting-page-no-user-emails-to-list":
      "No emails yet. Add users to your Casadesk system to see their email accounts here.",
    "button-google-account-google-logout": "Logout from",
    "button-google-account-google-login": "Login with Google",
    "label-ssl": "label-ssl",

    /*
    |   Agency profile
    */

    locale: "Landinstellingen",
    "default-locale": "Standaard presentatie (datums, getallen,..)",
    "default-language": "Standaard taal",
    "default-calculation": "Standaard calculation",
    "calculation-month": "Maand",
    "calculation-year": "Jaar",
    "locale-en-us": "United States",
    "locale-nl-nl": "The Netherlands",
    "locale-en-cy": "Cyprus",
    "settings/agencyprofile-label/notificationperiod":
      "Standaard notificatie periode (maanden)",
    "settings/agencyprofile-info/notificationperiod":
      "Een paar maanden voorafgaand aan de eerstvolgende vervaldatum toont Casadesk een notificatie voor een contract.",
    "settings/agencyprofile-label/vat": "Standaard BTW percentage",
    "settings/agencyprofile-label/fee": "Percentage administratiekosten",
    "settings/agencyprofile-info/vat":
      "Het BTW percentage wordt toegepast in nieuwe facturen",
    "settings/agencyprofile-info/fee":
      "De administratiekosten worden toegevoegd aan de servicekosten (beschikbaar in de verrekenen coach van het huurobject)",
    "settings/agencyprofile-info/invoices": "Facturen",
    "settings/agencyprofile-info/invoices-hint":
      "Van iedere factuur wordt een kopie naar dit email adres verzonden",
    "settings/agencyprofile-info/sender": "Afzender voor emails",
    "settings/agencyprofile-info/sender-hint":
      "Afzender voor automatisch verzonden emails",
    "settings/agencyprofile-info/sender-general-contact":
      "Algemeen contactpersoo",
    "settings/agencyprofile-info/sender-general-email": "Algemeen email adres",
    "settings/agencyprofile-info/reviewfeatures":
      "Laat een andere gebruiker de afrekeningen controleren voor ze te versturen",
    "settings/agencyprofile-section/ownerstatements-label/statementemailtext":
      "Standaard afrekening email tekst",
    "settings/agencyprofile-section/ownerstatements-title/defaulttextforstatementemail":
      "Standaard tekst voor de afrekening email",
    "settings/agencyprofile-section/ownerstatements-title/defaulttextforadjustrentemail":
      "Standaard tekst voor huuraanpassing e-mail",
    "settings/agencyprofile-section/ownerstatements-hint/sendcopy":
      "Standaard waarden voor de ‘Stuur een kopie’ optie in ‘Stuur e-mail’ pagina’s",
    "settings/agencyprofile-section/ownerstatements-title/sendcopyofattachments":
      "Stuur kopie van bijlagen naar",
    "settings/agencyprofile-section/ownerstatements-label/sendcopytoemails":
      "Stuur kopie bijlage(n) aan e-mail adres",
    "settings/agencyprofile-info/brokenmonthexplanation":
      "Een dag huur baseren op maand- of jaarhuur",
    "settings/agencyprofile-info/brokenmonthcalculation":
      "Bereken de huur per dag voor een volledig jaar (365 dagen), of voor - het aantal dagen in - de betreffende maand.",

    /*
    |  Types
    */

    // Charge types

    "rent": "Huur",
    "basic_rent": "Kale huur",
    "deposit": "Borg",
    "parking": "Parkeren",
    "administration_fee": "Administratie fee",
    "late_fee": "Te laat fee",
    "deposit_refund": "Borg retour",
    "loss": "Verlies",
    "utilities": "Nutsvoorzieningen G/W/L",
    "water": "Water",
    "gas": "Gas",
    "electricity": "Electriciteit",
    "taxes": "Belastingen",
    "banking_costs": "Bank kosten",
    "agency_fee": "Courtage / Vergoeding",
    "surplus": "Teveel",
    "settlement": "Afrekening",
    "other_receivable": "Overig te ontvangen",
    "other_payable": "Overig te betalen",
    "paid_to_much": "Te veel betaald",
    "late_payment_fee": "Extra kosten",
    "furnished": "Service",
    "facilities": "Overige faciliteiten",
    "stub_receivable": "Dummy nota",
    "stub_payable": "Dummy nota",
    "payout_receivable": "Afrekening",
    "payout_payable": "Afrekening",
    "overpaid_receivable": "Teveel betaald",
    "overpaid_payable": "Teveel betaald",
    "refund_receivable": "Terugbetaling",
    "refund_payable": "Terugbetaling",
    "savings_account_withdraw": "Opname uit tegoed",
    "savings_account_deposit": "Storting naar tegoed",
    "owner_association_contribution": "VVE bijdrage",
    "credit": "Credit",
    "credit_payable": "Credit",
    "credit_receivable": "Credit",
    "settled_bill_receivable": "Verrekende nota",
    "settled_bill_payable": "Verrekende nota",


    //Unit types
    room: "Kamer",
    studio: "Studio",
    apartment: "Appartement",
    house: "Huis",
    boat: "Woonboot",
    commercial: "Commercieel",
    garage: "Garage",
    villa: "Villa",
    senior_accommodation: "Senior accommodatie",
    live_in_guardian: "Hospita",
    bungalow: "Bungalow",
    live_workspace: "Live workspace",
    no_preference: "OG Algemeen",
    complex: "Wooncomplex",

    //FixedPlusPercentageModes types
    fpp_both: "Zowel percentage als vaste vergoeding toepassen",
    fpp_wichever_low: "Alleen laagste bedrag toepassen",
    fpp_wichever_high: "Alleen hoogste bedrag toepassen",

    //Repeat period types
    once: "Eenmaal",
    monthly: "Maandelijks",
    yearly: "Jaarlijks",
    weekly: "Weekelijks",

    //Charge classes types
    receivable: "Te ontvangen",
    payable: "Te betalen",
    "receivable-template": "te ontvangen",
    "payable-template": "te betalen",

    //Contract status types
    concept: "Concept",
    signed: "Getekend",
    dropped: "Vervallen",
    expiring: "Aflopend",
    ending: "Eindigt",
    ended: "Beëindigd",
    closed: "Afgerond",

    //Payment types
    payment_type_cash: "Contant",
    payment_type_bank: "Bank",
    payment_type_cheque: "Cheque",
    payment_type_settlement: "Verrekening",
    payment_type_settled_bill: "Verrekende nota",
    payment_type_other: "Diversen",
    payment_type_savings_account: "Tegoed",

    //Statements status
    definitive: "Definitief",
    "statement-status-definitive": "Gefactureerd",
    "statement-status-concept": "Concept",

    // Identify types
    passport: "Paspoort",
    driving_licence: "Rijbewijs",
    identity_card: "ID kaart",
    none: "Geen",

    // Gender types
    gender_type_male: "Man",
    gender_type_female: "Vrouw",
    gender_type_unknown: "Onbekend",

    // Creation types
    "creation-type-auto": "Auto",
    "creation-type-manual": "Handmatig",
    "creation-type-file": "Bestand",

    //Unit service status type
    unit_service_status_type_management: "In beheer",
    unit_service_status_type_inactive: "Archief (inactief)",

    //Assignment service status type
    assignment_service_status_type_inactive: "Inactief",
    assignment_service_status_type_tenantsearch: "Verhuuropdracht",
    assignment_service_status_type_operational: "Operationeel beheer",
    assignment_service_status_type_financial: "Administratief beheer",
    assignment_service_status_type_operationalfinancial: "Beheer",

    /*
    |  Socket
    */

    "socket-connected": "Socket connected",
    "socket-disconnected": "Socket disconnected",
    "socket-disconnected-message-line-1": "Verdorie!",
    "socket-disconnected-message-line-2":
      "We kunnen plots geen verbinding krijgen met de server. Moment, we blijven het proberen.",
    "socket-disconnected-message-line-3":
      "Dit venster sluit automatisch zodra er weer verbinding met de server is.",
    "socket-disconnected-message-line-4":
      "Een moment geduld tot we de server weer kunnen bereiken...",

    /*
    |  Backend Errors (sync)
    */

    be_statement_not_found: "Afrekening niet gevonden",
    be_iban_in_use: "Deze bankrekening wordt reeds gebruikt voor :displayName",
    be_no_balance_for_period: "No balance for this period",
    be_incorrect_email_address: "Email adres is niet correct",
    be_not_allowed_change_email_account:
      "You have not enough rights to create or change this email address",
    be_charge_class_unmatch: "Charge class of related objects does not match",
    be_contact_exists: "Dit email adres is al in gebruikt bij :displayName",
    be_payment_date_earlier_than_first_date:
      "Payment date cannot be earlier than first date",
    be_payment_not_found: "Payment not found",
    be_payment_requires_transaction: "Payment requires a transaction",
    be_duration_must_be_at_least_one_period:
      "Duration of a Charge Template must be at least one period",
    be_last_earlier_than_first_date:
      "Last date of period cannot be earlier than first date",
    be_final_rental_period_date_early:
      "De tweede vervaldag lam moey voor de eerste vervaldag liggen",
    be_account_already_confirmed: "Account is al bevestigd",
    be_account_blocked: "Dit account is geblokkeerd",
    be_account_not_confirmed: "Jouw account is nog niet bevestigd",
    be_only_one_email_allowed: "Only one email account is allowed per contact",
    be_ajv_not_validated: "De informatie in het veld ':fieldName' is niet correct",
    be_minimum_two_admins_required:
      "De gebruikersrol kan niet worden gewijzigd. Er is minimaal 1 gebruiker met de admin rol nodig.",
    be_password_regex_invalid:
      "Minstens 8 letters en 1 cijfer. Leestekens gebruiken",
    "be_password_regex_invalid-1": "mag ook, zoals: ! # @ & * +",
    be_array_expected: "Field should be an array",
    be_contract_end_date_in_past: "Contract end date can not be in the past",
    be_array_length_expected: "Invalid array length",
    be_body_invalid: "Invalid request body",
    be_charge_template_not_found: "Charge not found",
    be_agency_fee_not_found: "Agency fee not found",
    be_company_exists: "De naam is al in gebruik. Kies een andere naam.",
    be_company_not_found: "Organisatie niet gevonden",
    be_company_name_required: "Vul een naam voor de organisatie in",
    be_auto_created_charges_cannot_be_deleted:
      "Automatically created charges cannot be deleted",
    be_contact_company_not_related: "Contact and company are not related",
    be_action_minimum_two_admins_required:
      "De gebruikersrol kan niet worden gewijzigd. Er is minimaal 1 gebruiker met de admin rol nodig.",
    be_contact_not_found: "Contact not found",
    be_contract_not_found: "Contract not found",
    be_contract_cannot_delete_has_linked_payments:
      "Some of the charges in this contract has linked payments to it's charges so it is not possible to delete the contract.",
    be_contract_cannot_end_has_linked_payments:
      "Some of the charges in this contract has linked payments to it's charges so it is not possible to end the contract.",
    be_contract_already_ended: "Contract is already ended",
    be_contract_cannot_end_in_this_date: "Contract cannot end in this date.",
    be_contract_not_signed: "Contract must be signed",
    be_agency_cannot_change: "Agency cannot be changed",
    be_data_required: "Data is required",
    be_unit_number_required:
      "Een huurobject nummer is nodig want dit is niet het eerste huurobject voor deze locatie",
    be_invalid_date: "Datum niet correct",
    be_email_account_not_found: "EMail adres niet gevonden",
    be_unit_cannot_be_deactivated_due_to_active_contracts:
      "Inactief maken van het huurobject is niet mogelijk want er zijn nog een of meer actieve contracten",
    be_email_required: "Email is required",
    be_es_add_error: "Error occured when adding record to elastic search",
    be_es_check_index_error:
      "Error occured when checking index in elastic search",
    be_es_get_error: "Error occured when getting record from elastic search",
    be_es_remove_error:
      "Error occured when removing record from elastic search",
    be_es_query_error: "Error occured when searching record in elastic search",
    be_event_not_found: "Event not found",
    be_event_reply_wrong_type: "You can't reply on this type of event",
    be_field_required: "Required field is missing",
    be_file_ext_not_supported: "File extension is not supported",
    be_file_too_big: "Bestand te groot",
    be_firstname_email_required: "Een voornaam en email adres zijn verplicht.",
    be_fk_value_not_found: "Foreign key value not found",
    be_json_parse_error: "Error occured during parsing of json",
    be_main_tenant_missing:
      "De huurder heeft geen algemeen contactpersoon. Selecteer een contactpersoon en probeer opnieuw",
    be_main_tenant_not_found:
      "Contact marked as main tenant doesn't exist in this agency",
    be_missing_file: "Geen bestand gevonden om te uploaden",
    be_success_delete: "Successfully deleted",
    be_model_not_found: "Model not found",
    be_no_charge_template_contract_link: "Charge should be linked to contract",
    be_charge_template_of_signed_contract_cannot_be_removed:
      "Charge of a signed Contract can not be removed",
    be_charge_template_of_signed_contract_cannot_be_updated:
      "Wijzigen kan niet, het contract is al getekend",
    be_no_contact_for_contract:
      "Contact for contract relations between this id's not found",
    be_no_event_agency_link: "Event is not related to your agency",
    be_no_version_token_in_app: "No version token in app config",
    be_not_allowed: "You are not allowed to do this",
    be_not_tenant: "Contact marked as main tenant is not tenant",
    be_password_required: "Verstrek een wachtwoord",
    be_password_invalid_pattern:
      "Password should contain 6 letters and consist of mixed letters and numbers.",
    be_password_does_not_match: "Wachtwoorden zijn niet gelijk",
    be_password_wrong: "Verkeerd wachtwoord",
    be_period_required: "Periods param is required",
    be_remove_property_with_units:
      "Deze locatie kan niet worden verwijderd, het heeft huurobjecten",
    be_property_not_found: "Property is not found",
    be_remove_owner: "Contact owns properties and can't be removed",
    be_remove_self: "You can't remove yourself",
    be_owner_required: "Owner is required",
    be_remove_users_admins: "Users or admins can't be removed",
    be_server_error:
      "De server ondervond een probleem. Het Casadesk team heeft hiervan bericht ontvangen. Probeer het later opnieuw.",
    be_token_already_used: "Token is already used",
    be_token_invalid: "Your session is expired.",
    insufficient_savings_balance: "Onvoldoende tegoed",
    charge_is_part_of_a_settlement_with_savings: "Deze nota is onderdeel van een verekening met het tegoed",

    be_token_required: "Token is required",
    be_es_unknown_type: "Unknown type of elastic search index",
    be_unit_not_found: "Unit not found",
    be_unrecognized_action: "Unrecognized action",
    be_update_remove_signed_contract:
      "Signed contracts can't be updated or removed",
    be_user_id_required: "User id is required",
    be_user_not_found: "User not found",
    be_version_required: "Version is required",
    be_work_order_not_found: "Work order not found",
    be_contact_for_contract_missing_description:
      "If the Person type is Other, description field is required.",
    be_mt940_file_invalid:
      "The provided bank transaction does not comply with MT-940 standard.",
    be_unauthorized: "Unauthorized",
    be_disabled: "This feature is temporarily disabled.",
    be_charge_create_requires_at_least_one_relation:
      "Charge requires at least one relation.",
    be_charge_create_property_needs_person:
      "Property does not have a Person as an owner.",
    be_cannot_remove_charge_because_it_was_used_in_financial_statement:
      "Cannot delete charge because it's already been used in an owner statement",
    be_contract_cannot_end_charges_exist_in_financial_statement:
      "You can not end a contract because some charges were used in an owner statement. To end this contract first you need to delete an owner statement.",
    cannot_change_charge_because_it_was_used_in_financial_statement:
      "Can not change charge because it was used in an owner statement",
    cannot_change_payment_because_it_was_used_in_financial_statement:
      "Can not change payment because it was used in an owner statement",
    cannot_unlink_charge_because_it_was_used_in_financial_statement:
      "Cannot unlink charge because it's already been used in an owner statement",
    cannot_unlink_charge_because_financial_statement_locked:
      "Ontkoppelen niet mogelijk. De nota is verwerkt in een afgesloten afrekening",
    cannot_unlink_payment_because_financial_statement_locked:
      "Ontkoppelen niet mogelijk. Het gekoppelde bedrag is verwerkt in een afgesloten afrekening",
    cannot_unlink_payment_because_it_was_used_in_financial_statement:
      "Cannot unlink payment because it's already been used in an owner statement",
    cannot_change_charge_class:
      "De nota klasse (te betalen, te ontvangen) kan niet worden gewijzigd. De klasse moet dezelfde zijn als de gekoppelde betaling.",
    payment_is_fully_used:
      "You fully used this payment. Please choose another one or create new payment",
    such_email_already_exist: "Het email adres is al in gebruik",
    cannot_unlink_settle_payment: "Can not unlink settle payment",
    cannot_update_settle_payment: "Can not update settle payment",
    cannot_change_linked_object_in_automatically_created_charges:
      "Can not change linked object in automatically created charges",
    be_leave_company_not_allowed: "Admins and users cannot leave their agency",
    cannot_change_class_of_payment_that_already_linked_to_the_charge:
      "De betaling klasse (betaald, ontvangen) kan niet worden gewijzigd. De klasse moet dezelfde zijn als de gekoppelde nota.",
    cannot_remove_settled_payment:
      "Verwijderen niet mogelijk. Ontkoppel en probeer opnieuw",
    cannot_remove_settled_charge:
      "Verwijderen niet mogelijk. Ontkoppel en probeer opnieuw",
    cannot_remove_special_settlement_charge:
      "You can not delete this charge. This charge is a special settlement charge for the settlement of two payments. Go to one of the payments and unsettle them and charge will disappear.",
    cannot_remove_special_settlement_payment:
      "You can not delete this payment. This payment is a special settlement payment for the settlement of two charges. Go to one of the charges and unsettle them and payment will disappear.",
    cannot_remove_contract: "You can remove only concept contract or renewed",
    email_already_use:
      "Kies een ander email adres. Dit email adres is al in gebruik",
    cannot_pay_charge_with_different_type_of_payment:
      "Koppelen van een te betalen nota met een ontvangen betaling, of een te ontvangen nota met een betaalde betaling, is niet mogelijk.",
    "cannot_create_charge_template_with_unsigned-contract":
      "Cannot create charge template with unsigned contract",
    "you-can-not-change-the-amount-for-a-charge":
      "You can not change the amount for a charge",
    "you-can-not-change-the-amount-for-a-payment":
      "You can not change the amount for a payment",
    cannot_settle_payment_with_equal_types:
      "Can not settle payment and charges with equal types",
    cannot_settle_settled_payment: "Can not settle settled payment",
    should_be_filled_one_of_the_fees_types:
      "Should be set one of the fees types",
    cannot_settle_payments_with_different_amount:
      "Can not settle payments with different amount",
    be_remove_tenant_with_contracts:
      "Verwijderen gaat niet. Deze persoon is een huurder met een of meer contracten.",
    cannot_unlink_payment_of_the_process_settle:
      "Verwijderen van deze betaling gaat niet. Deze betaling is een speciale systeem betaling die is gemaakt voor de verrekening van 2 nota’s. Maak de verrekening ongedaan en dan verwijnt deze betaling.",
    cannot_unlink_charge_of_the_process_settle:
      "Deze nota en betaling kunnen niet worden losgekoppeld. Ze werden geregistreerd voor het tegoed. Ga naar het tegoed en verwijder daar de betreffende storting of opname.",
    be_unit_number_exist: "Nummer huurobject bestaat al",
    this_company_have_a_property:
      "Deze organisatie kan niet worden verwijderd. De organisatie is een eigenaar met locaties. Verwijder eerst de locaties, of verplaats de locaties naar een andere eigenaar, en probeer het dan opnieuw.",
    payment_charge_class:
      "Koppelen van een te betalen nota met een ontvangen betaling, of een te ontvangen nota met een betaalde betaling, is niet mogelijk.",
    cannot_remove_finished_contract:
      "Dit contract kan niet worden verwijderd omdat de einddatum is bepaald. Verwijder de einddatum en probeer opnieuw",
    vat_less_than_amount: "BTW bedrag moet lager zijn dan het factuur bedrag",
    cannot_set_end_date_renewed:
      "De einddatum kan niet meer worden gewijzigd. Dit contract is al geëindigd of vernieuwd.",
    contract_has_manual_charges:
      "Dit contract kan niet worden verwijderd. Dit contract is gekoppeld aan handmatig geregistreerde nota’s, en/of nota’s zijn gekoppeld aan handmatig geregistreerde betalingen. Ontkoppel deze nota’s en probeer opnieuw.",
    contract_has_manual_payments:
      "Dit contract kan niet worden verwijderd. Dit contract is gekoppeld aan handmatig geregistreerde nota’s, en/of nota’s zijn gekoppeld aan handmatig geregistreerde betalingen. Ontkoppel deze nota’s en probeer opnieuw.",
    financial_operations_were_blocked:
      "Deze functie is niet beschikaar op dit moment omdat financiële gegevens worden bijgewerkt. Probeer later opnieuw.",
    forbid_remove_opened_activity:
      "Deze activiteit kan niet worden verwijderd omdat de status Open is. Sluit eerst deze activiteit en probeer het dan opnieuw.",
    notification_period_warning:
      "Kies een datum die ligt na de eerste dag van het contract.",
    notification_rent_message: "Huuraanpassing",
    notification_adjust_rent_message: "Huurprijs aanpassen",
    agency_fee_is_forbidden_to_remove_from_unit:
      "De courtage kan niet worden verwijderd. Een huurobject heeft minstens 1 courtage nodig.",
    contract_forbidden_to_sign:
      "Dit contract kan niet worden getekend. De standaard basis huurpijs ontbreekt in dit contract of de courtage ontbreekt in het huurobject. Zorg dat er een standaard basis huurprijs en courtage zijn, en probeer het dan opnieuw.",
    agency_fee_template_first_day_restrictions:
      "De eerste datum voor de courtage kan niet worden gewijzigd. De eerste datum voor een courtage moet eerder of gelijk zijn aan de eerste datum voor het contract bij dit huurobject.",
    agency_fee_template_first_day_restrictions_2:
      "De eerste datum voor de courtage kan niet worden gewijzigd want de eerste courtage nota is al gemaakt.",
    be_account_number_exist:
      "The bankrekening kan niet worden vastgelegd. Het bankrekening nummer is al in gebruik. Wijzig het bankrekening nummer en probeer opnieuw.",
    payment_link_fee_charges:
      "Er werden geen onbetaalde courtage nota’s gevonden. De betaling blijft beschikbaar. Probeer later opnieuw.",
    cannot_change_charge_class_in_auto:
      "De nota is niet bewaard. De nota klasse (te ontvangen, te betalen) kan niet worden gewijzigd voor een automatisch gemaakte nota. Verwijdere de nota en maak handmatig een nieuwe.",
    agency_fee_for_this_object_already_exist:
      "De courtage kan niet worden bewaard. Het huurobject heeft al een courtage.",
    cant_create_unit_without_rent_template_and_agency_fee_template:
      "Het huurobject kan niet worden geregistreerd. De courtage ontbreekt. Voeg de ontbrekende informatie toe, en probeer opnieuw.",
    description_not_valid: "Teveel informatie verstrekt",
    cant_create_contract_without_rent_template:
      "Het contract kan niet worden geregistreerd. Een bedrag voor de kale huur ontbreekt. Voeg dit ontbrekende bedrag toe en probeer opnieuw.",
    locked_charge_update_forbidden:
      "Deze nota kan niet worden gewijzigd. De nota is in een afgesloten afrekening verwerkt.",
    payout_charge_update_forbidden:
      "Deze afrekening nota kan niet worden gewijzigd. Het wordt automatisch gemaakt en bijgewerkt door het systeem.",
    locked_charge_remove_forbidden:
      "De nota kan niet worden verwijderd. Het is onderdeel van een definitieve factuur. Maak een credit nota om deze nota ongedaan te maken.",
    payout_charge_remove_forbidden:
      "Deze afrekening nota kan niet worden verwijderd. Het wordt automatisch gemaakt en bijgewerkt door het systeem.",
    invoice_creation_forbidden_date:
      "The creation of an invoice is forbidden, because the first date of statement is before of activation invoice date",
    invoice_creation_forbidden_credit:
      "Factureren niet mogelijk. Originele nota is geen factuur.",
    such_email_already_exists:
      "Kies een ander email adres. Dit email adres is al in gebruik",
    savings_forbid_unlink:
      "Deze nota en betaling kunnen niet worden losgekoppeld. Ze werden geregistreerd voor het tegoed. Ga naar het tegoed en verwijder daar de betreffende storting of opname.",
    savings_forbid_unsettle:
      "De betaling details kunnen niet worden gewijzigd omdat de betaling is vastgelegd in verband met het tegoed.",
    amount_will_be_less_then_zero: "Het is niet mogelijk een opname te doen.",
    zero_amount:
      "Opname is niet mogelijk. Het bedrag is niet correct. Pas het bedrag aan en probeer opnieuw.",
    mt_upload_only:
      "Dit bestand kan niet worden verwerkt. Het is geen MT940 bestand. Kies een MT940 bestand en probeer opnieuw.",
    be_user_with_such_email_exists:
      "Kies een ander email adres. Dit email adres is al in gebruik",
    withdraw_impossible: "Er is geen tegoed op dit moment.",
    forbidden_to_settle_payout:
      "De geselecteerde nota’s kunnen niet worden verrekend. En afrekening nota kan alleen met een andere afrekening worden verrekend.",
    update_first_date_to_past_is_forbidden_charge_template:
      "Wijzig de eerste datum naar vandaag of later",
    email_has_not_be_sent:
      "De email is niet verzonden. Er is een fout opgetreden.",
    email_has_not_be_sent_max_size:
      "De email is niet verzonden. De email is te groot.",
    invoice_creation_forbidden: "Factuur bestaat al",
    forbid_create_charge_whithout_counter_party:
      "Nota niet vastgelegd. Tegenpartij ontbreekt.",
    payout_charge_unsettle_forbidden:
      "De verrekening kan niet ongedaan worden gemaakt,  de afrekening is gefactureerd.",
    forbidden_remove_transaction:
      "Een bank transactie kan niet worden verwijderd",
    no_payouts_in_owner_statement:
      "Geen factuur gemaakt. De afrekening heeft geen bedrag om te verrekenen.",
    unverified_payments_in_statement:
      "Afrekening kan niet worden afgesloten. Een of meer betalingen zijn nog niet gecontroleerd.",
    expiration_date_is_invalid:
      "De melding vervaldatum moet in de toekomst zijn",
    be_charge_not_found: "Nota niet gevonden",
    general_contact_id_required: "Verplicht veld",
    cannot_change_statement_period_for_automatically_created_charge_before_start_date:
      "De afrekening periode kan niet voor de financieële start datum liggen",
    "cannotpaycharge-info/bankaccountmissing":
      "Bankrekening ontbreekt. Voeg de bankrekening voor het vastgoed beheer toe in: Instellingen | Kantoor profiel",
    invoice_creation_forbidden_before_previous:
      "De afrekening kon niet worden gemaakt. Rond eerst de afrekening voor voorgaande periode af en probeer het dan opnieuw.",
    can_not_make_savings_action: "De nota is al volledig verrekend",
    use_remove_from_savings:
      "Verwijderen niet mogelijk; onderdeel van verrekening met een tegoed",
    can_not_use_undo_with_not_savings_entity:
      "Geen verrekening met een tegoed gevonden",
    can_not_make_savings_for_fully_used_payment:
      "De betaling is al volledig gebruikt",
    email_address_required: "Email address required",
    mobile_phone_required: "Mobile phone required",
    mobile_phone_invalid:
      "Geldig telefoonnummer: 0612345678, of het internationale formaat: +31612345678",
    cannot_unlink_overpaid_charge_from_refunded_payment:
      "Ontkoppelen van betaling en nota lukt niet. Verwijder eerst de terugbetaling en probeer opnieuw.",
    cannot_remove_refunded_payment:
      "Verwijderen van de betaling lukt niet. Verwijder eerst de terugbetaling en probeer opnieuw.",
    cannot_unlink_refunded_payment_from_overpaid_charge:
      "Verwijderen van de nota lukt niet. Verwijder eerst de terugbetaling en probeer opnieuw.",
    cannot_remove_refund_charge:
      "Verwijderen van de nota lukt niet. Verwijder eerst de terugbetaling en probeer opnieuw",
    forbidden_update_removed_charges:
      "Het is niet mogelijk een verwijderd object te wijzigen",
    cannot_refund_payment_without_counterparty:
      "Koppel de  tegenpartij in de betaling en probeer opnieuw.",
    only_refunded_charge_can_be_unrefunded:
      "De terugbetaling ongedaan maken lukt niet. Een terugbetaling werd niet gevonden.",
    cannot_remove_contract_with_locked_charges:
      "Dit contract kan niet worden verwijderd. Een of meer aan dit contract gekoppelde nota’s zijn definitief. Een nota is definitief wanneer die, bijvoorbeeld, onderdeel is van een definitieve factuur.",
    cannot_change_generalcontactid_if_company_is_tenant:
      "Deze persoon kan niet worden verwijderd. De persoon is de contactersoon in een or meerder contracten.",
    account_recently_synchronized: 
        "De laatste bank transacties werden al opgehaald gedurende de laatste 30 minuten. Probeer het later opnieuw.",
    be_remove_property_with_not_deletable_units:
      "The lokatie kan niet worden verwijderd. Een of meer huurobjecten hebben nog een actief contract of overeenkomst.",
    be_unit_cannot_be_deleted_due_to_active_contracts_and_agreements:
      "Het huurobject kan niet worden verwijderd. Er is nog een actief contract of overeenkomst.",
    readonly_payment_update_forbidden:
      "Kan de betaling niet wijzigen. Deze betaling is alleen-lezen.",
    readonly_charge_update_forbidden:
      "Kan de nota niet wijzigen. Deze nota is alleen-lezen.",
    statement_period_could_not_be_older_than_4_years:
      "De periode kan niet ouder zijn dan 4 jaren",
    statement_period_could_not_be_before_financial_start_date:
      "De periode kan niet voor de financiële startdatum :financialStartDate liggen",
    cannot_unlink_payment_from_paid_directly_to_owner_charge:
      "Een betaling kan niet worden ontkoppeld van een direct betaalde nota",
    cannot_remove_paid_directly_to_owner_charge:
      "De betaling kan niet worden verwijderd want de gekoppelde nota is direct betaald",
    cannot_remove_payment_related_to_paid_directly_to_owner_charge:
      "De nota kan niet worden verwijderd want zij is direct betaald",
    cannot_credit_fully_settled_charge: "Cannot credit fully settled charge",
    forbidden_to_remove_agency_fee_with_active_charges:
      "Deze overeenkomst kan niet worden verwijderd omdat er nota's bestaan voor deze overeenkomst. Verwijder de nota’s en probeer opnieuw.",
    forbidden_to_change_expiration_date_while_contract_renewing:
      "Forbidden to change expiration date while contract renewing",
    cannot_remove_credit_charge:
      "Deze nota is alleen lezen en kan om die reden niet worden verwijderd of aangepast.",
    cannot_undo_credit_which_was_settled_with_savings:
      "Deze nota is alleen lezen en kan om die reden niet worden verwijderd of aangepast.",
    cannot_credit_charges_with_system_types:
      "Crediteren niet mogelijk. De nota werd door het systeem gemaakt",
    cannot_credit_charges_which_was_settled_with_savings:
      "Crediteren niet mogelijk. Maak eerst verrekening met tegoed ongedaan.",
    cannot_credit_payout_without_invoice_amount:
      "Crediteren niet mogelijk. De afrekening bevat geen factuurbedrag",
    credit_amount_for_payouts_can_not_be_bigger_than_invoice_amount:
      "Crediteren niet mogelijk. Het credit bedrag is hoger dan het factuurbedrag",
    forbidden_to_uncredit_locked_charges:
      "Crediteren niet mogelijk. De nota is onderdeel van een afgesloten afrekening",
    credit_amount_is_larger_than_invoiced_amount:
      "Crediteren niet mogelijk. Het credit bedrag is hoger dan het factuurbedrag",
    cannot_process_file_with_transactions_length_greater_than_250:
      "Bank transacties niet verwerkt. Upload een bestand met maximaal 250 transacties.",
    archived_unit: "Niet toegestaan. Het huurobject is gearchiveerd",
    no_previous_contract: "Geen voorafgaand contract gevonden",
    forbidden_settle_with_savings_fully_paid_charge:
      "Het bedrag kan niet worden verrekend met een tegoed.",
    last_bank_account_cannot_be_deleted:
      "Verwijderen niet toegestaan. Minimaal één bankrekening noodzakelijk",
    default_bank_account_should_be_present:
      "Wijzigingen niet toegestaan. Minimaal één standaard bankrekening is noodzakelijk",
    cannot_credit_charge_with_amount_zero:
      "Crediteren niet mogelijk. Het te crediteren bedrag moet groter dan 0 zijn.",
    something_went_wrong: "Something went wrong from ponto side",
    no_supported_accounts: "Accounts are not supported",
    cannot_archive_unit:
      "Er is nog een actieve overeenkomst of huurcontract. Laat de overeenkomst of het huurcontract eerst eindigen alvorens het huurobject te archiveren.",
    cannot_extend_contract_for_not_later_date:
      "De nieuwe datum moet na de voorgaande contract datum liggen",
    cannot_create_charge_with_counterparty_object_owner:
      "Nota niet gemaakt. Verhuurder kan niet zichzelf betalen.",
    forbidden_settle_with_savings_not_locked_payout_charges:
      "Sluit de afrekening af om deze nota te verrekenen.",
    cannot_renew_the_contract:
      "Kies een andere startdatum. Het contract kan niet worden vernieuwd voor perioden met definitieve nota’s. Nota’s worden definitief indien zij deel uitmaken van een afrekening die is afgesloten.",

    //Agency statements
    deposited_title: "Stortingen naar tegoed",
    deposited_row_description: "Totaal stortingen",
    withdrawn_title: "Opnames van tegoed",
    withdrawal_row_description: "Totaal opnames",
    "button-withdrawal-agency-statement": "Opnemen",
    agency_charges_title: "Nota’s kantoor",
    agency_charges_already_pay_title: "Nota’s kantoor reeds voldaan",
    savings_account: "Tegoed",

    //Special default error message for fields
    maxlength: "Teveel informatie verstrekt",
    minlength: "Dit veld is verplicht",
    minitems: "Dit veld is verplicht",
    date_can_be_up_to_2_months:
      "Deze datum kan tot 1 jaar in het verleden of toekomst liggen.",
    format: "Dit veld is verplicht",

    "is-impossible-to-make-a-table": "Geen nota’s gevonden",

    /*
    |  Frontend Errors
    */
    "agreement-cannot-be-removed-because-of-locked-charges":
      "Deze overeenkomst kan niet worden verwijderd. Een nota voor de periode :firstDate - :lastDate is onderdeel van een reeds afgesloten afrekening. Kies de einddatum :lastDate om deze overeenkomst te beëindigen.",
    "wrong-file-type":
      "Het gekozen bestandstype wordt niet ondersteund. Ondersteunde bestandstypes: .jpg, .jpeg, .bmp, .png, .doc, .docx, .pdf.",
    "wrong-file-type-logo":
      "Het gekozen bestandstype wordt niet ondersteund. Ondersteunde bestandstypes: .jpg, .jpeg, .png",
    "wrong-file-size": "Bestandomvang os te groot.",
    "no-statement-for-this-month":
      "Geen financieel overzicht gevonden voor de gekozen maand. Kies een andere maand.",
    "note-can-not-be-longer-than-255":
      "De notitie kan niet langer zijn dan 255 letters.",
    "this-field-is-not-valid": "Dit veld is is niet correct.",
    "check-internet-try-again":
      "Controleer jouw internet verbinding en probeer opnieuw.",
    "memo-can-not-be-longer-than-255":
      "De memo kan niet langer zijn dan 255 letters.",
    "error-response-is-undefined":
      "Een gebruikelijke reactie van de server werd gemist. Misschien is de internet verbinding niet geweldig.",
    "error-no-results": "Gheader-een resultaten",
    "error-no-selected-tenant": "Selecteer eerst een huurder",
    "error-this-field-is-required": "Vul hier iets in",
    "error-label-contactperson": "contactpersoon",
    "label-contactid": "Contactpersoon",
    "error-label-user": "gebruiker",
    "error-label-company": "organisatie",
    "error-notvaliddatata-agencyfee":
      "Het contract kan niet worden gemaakt. De courtage bevat een of meer onjuiste waarden. Pas de courtage aan en probeer het opnieuw.",
    "error-already-use-bank-account":
      "Deze bankrekening wordt reeds gebruikt voor :displayName ",
    "error-notvaliddatata-chargetemplate":
      "Fout in een bedrag: <:field>. Herstel en probeer opnieuw.",
    "error-notvaliddatata-chargetemplate-coach":
      "Fout in een contract bedrag: <:field>. Verwijder dit bedrag en probeer het opnieuw.",
    "error-notvaliddatata-agencyfeeunit":
      "Fout in een courtage: <:field>. Herstel en probeer opnieuw.",
    "error-attachment-download-response-was-failed":
      "Downloaden is niet mogelijk op dit moment wegens een technisch probleem. Probeer het later nog eens.",
    "memo-can-not-be-updated": "Memo kan niet worden gewijzigd",
    "label-chargetypeids": "Nota type",
    cannot_credit_credit_charge: "Een credit nota kan niet worden gecrediteerd",
    cannot_credit_credited_charge: "Deze nota is al gecrediteerd",
    cannot_credit_payout_charge:
      "Afrekening nota’s kunnen niet worden gecrediteerd. Crediteer individuele nota’s.",

    /*
    | Aplication start page
    */

    "application-starting-notice": "Starten",
    "application-crashed": "Crashed",
    "application-crashed-notice":
      "Excuse! De applicatie is onverwacht gestopt. Ga terug naar de login pagina.",

    /*
    | Settings page - agency profile tab
    */

    "agency-profile-agency-name": "Naam",

    /*
    API calls
    */

    "api-requst-confirm-email-sent": "Bevestiging email is verzonden",
    "invite-email-sent": "Uitnodiging is succesvol verzonden.",
    "reset-email-sent": "De herstel email is verzonden.",

    //Default
    "show-more-notifications": "Toon :amount meer notificaties",
    "show-less-notifications": "Toon minder notificaties",
    "save-changes": "Bewaar wijzigingen",
    "are-you-sure": "Ben je zeker?",
    "coach/close-subtitle": "De verstrekte informatie gaat verloren",
    "warning-data-may-be-lost": "Alle wijzigingen die je maakte gaan verloren.",
    "warning-data-are-lost": "Alle wijzigingen die je maakte gaan verloren.",
    "warning-templates-may-be-lost":
      "Je hebt het laatste huurbedrag niet bewaard.",
    "warning-confirm-delete":
      "Je staat op het punt iets te verwijderen. Doorgaam?",
    "contact-person-remove-dialog": "De persoon wordt verwijderd. Doorgaan?",
    "contact-company-remove-dialog":
      "De organisatie wordt verwijderd. Doorgaan?",
    "charge-unsettle-from-charge-page-content-dialog":
      "Het verrekenen van de nota wordt ongedaan gemaakt. Doorgaan?",

    //Archive
    "warning-confirm-archive-title": "Je gaat dit huurobject archiveren.",
    "warning-confirm-archive-text":
      "Je archiveert een huurobject wanneer het niet langer in beheer is. Is het huurobject slechts tijdelijk niet beschikbaar? Kies dan voor die optie.",
    "warning-confirm-archive1": `Zodra gearchiveerd:`,
    "warning-confirm-archive2": `- Worden huurnota’s niet meer gemaakt`,
    "warning-confirm-archive3": `- Worden beheervergoeding nota’s niet meer gemaakt`,
    "warning-confirm-archive4": `-  Wordt het huurobject niet meer getoond in het overzicht met huurobjecten (maar kan het nog wel worden gevonden via de zoekfunctie en in de verhuurder pagina)`,

    //Agency fee modal

    "charge-unlink-from-payment-page-content-dialog":
      "De nota wordt verwijderd. Doorgaan?",
    "charge-unlink-from-charge-page-content-dialog":
      "De betaling wordt verwijderd. Doorgaan?",
    "attachment-remove-page-content-dialog":
      "De bijlage wordt verwijderd. Doorgaan?",
    "charge-remove-from-property-page-content-dialog":
      "De nota wordt verwijderd. Doorgaan?",
    "file-remove-from-bank-transactions-page":
      "Het bestand met bank transacties wordt verwijderd. Ook de betalingen die voor de transacties werden gemaakt worden uit het systeem verwijderd. Doorgaan?",
    "unit-remove-from-property-detail-page":
      "De wooneeheid wordt verwijderd. Doorgaan?",
    "agency-fee-remove-from-settings-page":
      "De courtage wordt verwijderd. Doorgaan?",

    //Charges
    "charge-unlink-info":
      "De koppeling van nota en betaling wordt verbroken. Hierna is de nota weer - deels - onbetaald, en de betaling weer beschikbaar voor een andere nota. Doorgaan?",

    /* NEW TRANSLATION */

    /*
    | Drop down fields for objects
    */

    "dropdown-searchforproperty-label": "Selecteer locatie",
    "dropdown-searchforaddress-label": "Selecteer adres",
    "dropdown-property-notfound": "Geen locatie gevonden.",
    "dropdown-button-new-property": "Nieuwe locatie",
    "dropdown-searchforowner-label": "Zoek eigenaar",
    "dropdown-searchforlandlord-label": "Zoek verhuurder",
    "dropdown-searchlandlord-label": "Zoek verhuurder",
    "dropdown-searchforowner-label2": "Zoek verhuurder",
    "dropdown-owner-notfound": "Geen eigenaar gevonden.",
    "dropdown-button-new-owner": "Nieuwe eigenaar",
    "dropdown-tenant-label": "Zoek huurder",
    "dropdown-searchforperson-label": "Zoek persoon",
    "dropdown-selectperson-label": "Selecteer persoon",
    "dropdown-selecttenant-label": "Selecteer huurder",
    "dropdown-additional-person-label": "Zoek aanvullende persoon",
    "dropdown-searchformanager-label": "Zoek huismeester",
    "dropdown-searchforcompany-label": "Zoek organisatie",
    "dropdown-searchforunit-label": "Selecteer een huurobject",
    "dropdown-manager-notfound": "Geen huismeester gevonden.",
    "dropdown-person-notfound": "Geen persoon gevonden.",
    "dropdown-unit-notfound": "Geen huurobject gevonden.",
    "dropdown-tenant-notfound": "Geen huurder gevonden.",
    "dropdown-company-notfound": "Geen organisatie gevonden.",
    "dropdown-button-newmanager": "Nieuwe huismeester",
    "dropdown-person-label": "Persoon",
    "dropdown-company-label": "Organisatie",
    "dropdown-property-label": "Adres",
    "dropdown-unit-label": "Huurobject",
    "dropdown-owner-label": "Eigenaar",
    "dropdown-owner-label2": "Verhuurder",
    "dropdown-landlord-label": "Verhuurder",
    "dropdown-owner-landlord": "Eigenaar",
    "dropdown-manager-label": "Huismeester",
    "dropdown-button/newtenant": "Nieuwe huurder",
    "dropdown-button/newcounterparty": "Nieuwe tegenpartij",

    //General label
    "generalsearch-label": "Casadesk doorzoeken",

    //Charge for (object...)
    "page/banktransactionupdate-section/charge-tab/newcharge-field/object-label":
      "Nota betreft (contract, huurobject, locatie, eigenaar)",
    "page/banktransactionupdate-section/charge-tab/existingcharge-field/object-label":
      "Zoek nota's voor (contract, huurobject, locatie of eigenaar)",
    "page/chargecreate-section/charge-field/object-label":
      "Nota betreft (contract, huurobject, locatie, eigenaar)",
    "page/chargecreate-section/invoice-field/object-label":
      "Factuur betreft (contract, huurobject, locatie, eigenaar)",
    "page/chargesettle-section/charge-tab/newcharge-field/object-label":
      "Nota betreft (contract, huurobject, locatie, eigenaar)",
    "page/chargeupdate-section/charge-field/object-label":
      "Nota betreft (contract, huurobject, locatie, eigenaar)",
    "page/chargeupdate-section/invoice-field/object-label":
      "Factuur betreft (contract, huurobject, locatie, eigenaar)",
    "page/paymentcreate-section/charge-tab/newcharge-field/object-label":
      "Nota betreft (contract, huurobject, locatie, eigenaar)",
    "page/paymentcreate-section/charge-tab/existingcharge-field/object-label":
      "Zoek nota's voor (contract, huurobject, locatie of eigenaar)",
    "page/paymentupdate-section/charge-tab/newcharge-field/object-label":
      "Nota betreft (contract, huurobject, locatie, eigenaar)",
    "page/paymentupdate-section/charge-tab/existingcharge-field/object-label":
      "Zoek nota's voor (contract, huurobject, locatie of eigenaar)",
    "dropdown-chargeobject-notfound": "Niets gevonden",
    "dropdown/activity-field/object-label": "Activiteit betreft huurobject",
    "coach/credit-label/object":
      "Vind nota voor (contract, huurobject, locatie, eigenaar)",
    "dialog/chargecreate-popup/rentcharge-info":
      "Gebruik de optie ‘Volgende huurnota maken’ op de contract pagina. Of klik Doorgaan indien dit een bijzondere eenmalige huurnota is",

    // Charge classes
    "charge-class-receivable": "Te ontvangen van",
    "charge-class-payable": "Te betalen aan",
    "charge-class-invoice": "Factuur ontvangen van",

    /*
    | Payment section (payment details) use in Payment create, Payment update, Charge create, Payment settle, Charge update.
    */
    // Payment classes
    "payment-class-received": "Ontvangen van",
    "payment-class-paid": "Betaald aan",

    /*
    | Settings
    */
    /* agency profile */
    "page/settings-tab/agencyprofile-section/financialstartdate-info/financialstartdate1":
      "Kies de startdatum voor de afrekeningen.",
    "page/settings-tab/agencyprofile-section/financialstartdate-info/financialstartdate2":
      "Nota’s en betalingen met een datum voor de startdatum worden niet meegenomen in de afrekeningen. De startdatum kan alleen door een Administrateur worden gewijzigd.",
    "page/settings-tab/agencyprofile-section/financialstartdate-title":
      "Startdatum afrekeningen",
    "page/settings-tab/agencyprofile-section/financialstartdate-subtitle":
      "Vanaf de gekozen datum maakt Casadesk automatisch afrekeningen voor de eigenaars",
    "page/settings-tab/agencyprofile-section/financialstartdate-datepicker-label/financialstartdate":
      "Kies startdatum",
    "page/settings-tab/agencyprofile-section/financialstartdate-button/savefinancialstartdate":
      "Bewaren",
    "page/settings-tab/agencyprofile-postprocess/financialstartdateisbusy":
      "De startdatum wordt verwerkt. Totdat verwerking is afgerond kan er geen nieuwe startdatum worden ingesteld.",
    "dialog-agencyisbusy":
      "Deze functie is niet beschikaar op dit moment omdat financiële gegevens worden bijgewerkt. Probeer later opnieuw.",
    "page/settings-tab/agencyprofile-section/statementssettings-title":
      "E-mails",
    "page/settings-tab/agencyprofile-section/statementssettings-subtitle":
      "Standaard e-mail teksten, stuur een kopie, beoordelen…",
    "page/settings-tab/agencyprofile-section/invoiceactivationdate-title":
      "Factureren aanzetten",
    "page/settings-tab/agencyprofile-section/invoiceactivationdate-subtitle":
      "Maak de factuur voor een concept afrekening",
    "page/settings-tab/agencyprofile-section/invoiceactivationdate-info":
      "Na het aanzetten van factureren is het voor iedere gebruiker mogelijk om voor een concept afrekening een factuur te maken. Zo’n factuur is definitief en kan niet ongedaan worden gemaakt.",
    "page/settings-tab/agencyprofile-section/invoiceactivationdate-datepicker-label/invoiceactivationdate":
      "Kies start periode",
    "page/settings-tab/agencyprofile-section/invoiceactivationdate-button/saveinvoiceactivationdate":
      "Bewaren",
    "page/settings-tab/agencyprofile-section/invoiceactivationdate-info/preprocess":
      "De start datum voor financiele verslagen wordt ingesteld. Dit kan niet ongedaan worden gemaakt.",

    /* charge types */
    "page/settings-tab/chargetypes-label": "Nota type",
    "page/settings-tab/chargetypes-section/chargetypes-title": "Nota type",
    "page/settings-tab/chargetypes-section/chargetypes-button/addchargetype":
      "Toevoegen nota type",
    "page/settings-tab/chargetypes-section/chargetypes-dialog/deletechargetype-title":
      "Verwijderen nota type",
    "page/settings-tab/chargetypes-section/chargetypes-dialog/deletechargetype-info":
      "Deze type zal niet meer beschikbaar zijn voor nieuwe nota’s. Bestaande nota’s worden niet gewijzigd, die behouden deze type.",

    /* activity templates */
    "page/settings-tab/activitytemplates-switcher/activateactivities-label":
      "Activeer activiteiten",
    "page/settings-tab/activitytemplates-hint/foradmin-1":
      "Met activiteiten stel je gebruikers in staat om met 1 klik meerdere taken te maken. Gebruik bijvoorbeeld een activiteit om de taken voor een check in maken.",
    "page/settings-tab/activitytemplates-hint/foradmin-2":
      "Na het activeren van activiteiten zijn ze beschikbaar in het dashboard en bij ieder huurobject. Instrueer gebruikers wanneer activiteiten te gebruiken.",

    /*
    | Payment update page.
    */
    "page/paymentupdate-section/charge-button/anothercharge": "Nota toevoegen",

    /*
    | Unit create/update page.
    */
    "page/unitcreate-unitnumber-info":
      "Geen nummer huurobject invullen als de locatie maar 1 huurobject heeft.",

    /*
   | Dialogs
   */
    "dialog-signup-post-process-info1":
      "De Casadesk omgeving voor :agencyname is gereed voor gebruik.",
    "dialog-signup-post-process-info2":
      "N.B. Bevestig jouw email adres door te klikken op de link in het bericht dat we stuurden naar :email.",
    "dialog-add-agency-fee-subtitle":
      "Maandelijks wordt een courtage nota gemaakt op basis van deze informatie",
    "dialog/preprocess-editaddress/title": "Bijwerken adres",
    "dialog/preprocess-editaddress/info":
      "Kon de precieze adres specificatie niet worden gevonden (bijvoorbeeld de letter ontbreekt in het huisnummer)? Corrigeer het dan hier.",

    /* Task edit */
    "dialog/edittask-info/couldnteditfinishedtask":
      "You couldn't edit finished task",

    /* Entity names */
    company: "Organisatie",
    contract: "Contract",
    person: "Persoon",
    property: "Locatie",
    unit: "Huurobject",
    agency: "Kantoor",
    owner: "Eigenaar",
    object: "Betreft",
    tenant: "Huurder",
    charge: "Nota",
    invoice: "Factuur",

    /*
    | Company create page
    */
    "page/companycreate-companyname-info":
      "Is de eigenaar een persoon en niet een organisatie? Voer dan een fictieve bedrijfsnaam in, zoals bijvoorbeeld 'Jansen Verhuur'.",

    /*FINANCE*/
    "page/finance-tab/banktransactions-filestatusfailed": "Mislukt",

    /* Unit update page */
    "menuitem-process-payment": "Verwerken betaling",
    "unitupdate-title": "Huurobject",
    "unitupdate-section/active-status":
      "Huurobject is tijdelijk niet beschikbaar",
    "unitupdate-section/archive-status": "Dit huurobject is gearchiveerd",
    "unitupdate-section/active-button/activate": "Weer beschikbaar",
    "unitupdate-tab/info": "Details",
    "unitupdate-tab/finance": "Financiën",
    "unitupdate-tab/contracts": "Contracten",
    "unitupdate-tab/settings": "Instellingen",
    "unitupdate-tab/agreements": "Overeenkomsten",
    "unitupdate-tab/info-field/unitnumber-label": "Nummer huurobject",
    "unitupdate-tab/info-field/unittype-label": "Type huurobject",
    "unitupdate-tab/info-field/unitservicestatus-label": "Unit service status",
    "unitupdate-tab/info-field/squaremeters-label": "Vierkante meters",
    "unitupdate-tab/info-field/rooms-label": "Aantal kamers totaal",
    "unitupdate-tab/info-field/separatebedrooms-label":
      "Aantal afzonderlijke slaapkamers",
    "unitupdate-tab/info-field/bathrooms-label": "Aantal badkamers",
    "unitupdate-tab/info-field/publicationtitle-label": "Publicatie titel",
    "unitupdate-tab/finance-radiobutton/all": "Alle",
    "unitupdate-tab/finance-radiobutton/unpaid": "Onbetaald",
    "unitupdate-dialog/warning-info/cannotmakechanges":
      "Bijwerken kan niet als het huurobject inactief is",
    "unitupdate-dialog/postprocess-info/deletedcharge":
      "De nota is verwijderd. De betaling of betalingen die voor deze nota werden gebruikt zijn terug te vinden in: Financieel | Betalingen. Ze zijn opnieuw beschikbaar om andere nota's mee te betalen.",
    "page/unitupdate-section/agencyfee-info/defaultagencyfeesnotfound":
      "Geen standaard courtages gevonden",
    "page/unitupdate-dialog/agencyfee-title": "Standaard courtage",
    "page/unitupdate-section/agencyfee-info/inheritedfrom":
      "The standaard сourtage instellingen worden overgenomen van",
    "page/unitupdate-section/info-changeunitservicestatus/dialoginfomanaged":
      "De service status wordt In beheer. Nota’s worden automatisch gemaakt voor deze unit.",
    "page/unitupdate-section/info-changeunitservicestatus/dialoginactive":
      "De service status wordt Inactief. Nota’s worden niet langer automatisch gemaakt voor deze unit.",
    "page/unitupdate-section/info-changeunitservicestatus/dialogtitle":
      "Service status update",
    "page/unitupdate-section/info-changeunitservicestatus/label": "Service",
    "page/unitupdate-section/info-agreement/subtitle":
      "De afspraken met de eigenaar over de dienstverlening",
    "page/unitupdate-section/settings/charge-template/title":
      "Nieuw huurcontract",
    "page/unitupdate-section/settings/charge-template/subtitle":
      "Standaard huurbedragen voor nieuwe huurcontracten",
    "page/unitupdate-section/settings/agreement/title": "Nieuwe overeenkomst",
    "page/unitupdate-section/settings/agreement/subtitle":
      "Standaard waarden voor nieuwe beheerovereenkomsten",
    "page/unitupdate-section/settings/general/title": "Algemeen",
    "page/unitupdate-section/settings/charge-template/add-button":
      "Nieuw huurbedrag",
    "page/unitupdate-section/settings/charge-template/no-charge-templates-found":
      "Geen standaard huurbedragen gevonden",

    // Universal (used throughout the application)
    "field/optional": " (optioneel)",

    /* General buttons */
    "page/entity-button/cancel": "Annuleren",
    "page/entity-button/done": "Sluiten",
    "page/entity-button/save": "Bewaren",
    "section/balance-button/newcharge": "Nieuwe nota",
    "section/balance-button/showmore": "Toon meer",
    "section/balance-button/showless": "Toon minder",
    "dialog-button/cancel": "Annuleren",
    "dialog-button/save": "Bewaren",
    "dialog-button/create": "Bewaren",
    "dialog-button/close": "Sluiten",
    "dialog-button/newproperty": "Nieuw huurobject",
    "dialog-button/creating": "Bewaren...",
    "dialog-button/saving": "Bewaren...",
    "dialog-button/change": "Wijzig",
    "dialog-button/skip": "Overslaan",
    "page/entity-button/create": "Bewaren",
    "page/entity-button/creating": "Bewaren...",
    "dialog-button/continue": "Doorgaan",
    "dialog-button/finish": "Afronden",
    "dialog-button/yes": "Ja",
    "dialog-button/no": "Nee",
    "dialog-button/selectmt940file": "Selecteer MT940 bestand",
    "dialog/renewcontract-button/continue": "Verder",
    "dialog/renewcontract-button/cancel": "Annuleren",
    "dialog/sendemail-button/donotcancel": "Niet annuleren",
    "dialog-button/back": "Terug",
    "dialog-button/pay": "Betalen",
    "dialog-button/send": "Verzenden",
    "dialog-button/replace": "Nieuw",
    "dialog-button/reuse": "Opnieuw",
    "dialog-button/addoneunit": "Huurobject toevoegen",
    "dialog/createtask-button/finish": "Gereed",
    "dialog-button/newrealestate": "Registreer eerste huurobject",

    /* Dialog charge type */
    "dialog/chargetype-button/newchargetype": "Nieuwe nota type",
    "dialog/chargetype-title": "Nota type",
    "dialog/chargetype-field/chargetypename-label": "Naam nieuwe nota type",
    "dialog/chargetype-field/chargeclassname-label": "Nota type class",

    //3-dot menu (menuitems)
    "menu/charge-option/edit": "Bewerken",
    "menu/charge-option/pay": "Betalen",
    "menu/charge-option/settle": "Verrekenen",
    "menu/charge-option/unsettle": "Maak verrekening ongedaan",
    "menu/charge-option/remove": "Verwijderen",
    "menu/agencyfee-option/remove": "Verwijderen",
    "menu/agencyfee-option/edit": "Bewerken",
    "menu/defaultunitchargetemlpate-option/remove": "Verwijderen",
    "menu/defaultunitchargetemlpate-option/edit": "Bewerken",
    "menu/payment-option/edit": "Bewerken",
    "menu/payment-option/pay": "Betaal",
    "menu/payment-option/settle": "Verrekenen",
    "menu/payment-option/unsettle": "Maak verrekening ongedaan",
    "menu/payment-option/remove": "Verwijderen",
    "menu/payment-option/unlink": "Ontkoppelen betaling",
    "menu/payment-option/unrefund": "Terugbetaling ongedaan maken",
    "menu/charge-option/unlink": "Ontkoppelen nota",
    "menu/charge-option/unrefund": "Terugbetaling ongedaan maken",
    "menu/user-option/view": "Bekijk",
    "menu/attachment-option/setavatar": "Omslagfoto",
    "menu/status-option/open": "Heropenen",
    "menu/status-option/close": "Voltooien",
    "menu/attachment-option/download": "Download",

    // Contract, unit, property balance keys. These keys are used for sections that present a balance in various places (for example: unit update page on tab finance)
    "section/balance-info/renewdate": "Vernieuw datum",
    "section/balance-info/chargesforcontractnotfound": "Geen nota's gevonden",
    "section/balance-info/chargesforunitnotfound": "Geen nota's gevonden",
    "section/balance-info/chargesforpropertynotfound": "Geen nota's gevonden",
    "section/balance-info/chargesforcompanynotfound": "Geen nota's gevonden",
    "section/balance-info/chargesforactivitynotfound": "Geen nota's gevonden",
    "section/balance-title/balanceforunit": "Nota's voor huurobject",
    "section/balance-title/balanceforcontract": "Nota's voor contract",
    "section/balance-chargestatus/unpaid": "Onbetaald",
    "section/balance-info/chargesbeforestartdatenotpresented":
      "Nota's voor de financiële start datum :startDate worden niet getoond",

    // Balance dialogs
    "section/balance-dialog/preprocess-info/deletecharge":
      "De nota wordt verwijderd. Doorgaan?",
    "section/balance-dialog/preprocess-info/unsettlecharge":
      "De nota wordt verrekend. Doorgaan?",

    //Default charge templates section
    "section/defaultunitchargetemplates-title":
      "Standaard bedragen huurobject (voor nieuwe contracten)",
    "section/defaultunitchargetemplates-button/newprice": "Nieuw bedrag",
    "section/defaultunitchargetemplates-info/pricenotfound":
      "Geen prijzen gevonden. Klik 'Nieuwe bedrag' om er een toe te voegen.",
    "section/defaultunitchargetemplates-unitupdate/settings-title":
      "Standaard bedragen contract",
    "section/defaultunitchargetemplates-unitupdate/settings-subtitle":
      "Deze bedragen worden automatisch aan een nieuw contract toegevoegd",

    // Default charge templates dialog
    "dialog/defaultchargetemplatesdetails-title": "Standaard huurbedrag",
    "dialog/newdefaultchargetemplates-title": "Standaard huurbedrag",
    "dialog/chargetemplatesdetails-title": "Nota sjabloon",
    "dialog/newchargetemplates-title": "Nieuw nota sjabloon",
    "dialog/contractitemdetails-title": "Contract bedrag",
    "dialog/newcontractitems-title": "Nieuw contract bedrag",
    "dialog/defaultchargetemplates-field/duedatepayment-label":
      "Vervaldatum betaling",
    "dialog/defaultchargetemplates-field/duedatefirstpayment-label":
      "Eerste betaling te betalen uiterlijk (indien afwijkend)",
    "dialog/defaultchargetemplates-field/firstdate-label":
      "Maak de eerste nota op of na",
    "dialog/defaultchargetemplates-field/enddate-label": "Einddatum",
    "dialog/defaultchargetemplates-field/description-label": "Beschrijving",
    "dialog/defaultchargetemplates-field/amount-label": "Bedrag",
    "dialog/defaultchargetemplates-field/currency-label": "Valuta",
    "dialog/defaultchargetemplates-field/type-label": "Type",
    "dialog/defaultchargetemplates-field/period-label": "Herhaal periode",
    "dialog/defaultchargetemplates-field/paymentoffset-label":
      "Te betalen uiterlijk",
    "dialog/defaultchargetemplates-field/paiddirectlytoowner-label":
      "Eigenaar ontvangt betalingen direct van huurder",
    "dialog/chargetemplate-info1":
      "Op basis van deze nota sjabloon wordt automatisch een nota gemaakt voor aanvang van de periode.",
    "dialog/defaultchargetemplate-info1":
      "Dit standaard contract bedrag wordt standaard opgenomen in ieder nieuw huurcontract voor dit huurobject",
    "dialog/preprocess-endchargetemplate-info1":
      "Bepaal de laatste dag waarvoor een vergoeding moet worden betaald.",
    "dialog/preprocess-endchargetemplate-info2":
      "N.B. Verwijder handmatig nota’s die wellicht al werden gemaakt voor de periode na de laatste dag.",
    "dialog/defaultchargetemplates-label/collate":
      "Niet samenvoegen met andere nota's",
    "dialog/chargetemplatecreate-hasdifferentispaiddirectlytoowner/info":
      "Sommige bedragen worden direct aan de eigenaar betaald, andere niet. Let op dat na ondertekening van het contract een wijziging in deze instelling alleen kan worden gerealiseerd door een nieuw contract te maken.",
    "dialog/chargetemplatereadonly-info":
      "Alleen lezen: contract is getekend; wijzigen door een nieuw contract te maken.",
    "dialog/preprocess-info/deletechargetemplate":
      "De nota sjabloon wordt verwijderd. Doorgaan?",

    // Agency fees section
    "section/agencyfee-title": "Overeenkomst",
    "section/agencyfee-button/agreement": "Nieuwe overeenkomst",
    "section/agencyfee-button/newagencyfee": "Nieuwe courtage",
    "section/agencyfee-info/defaultagencyfeesnotfound":
      "Geen courtages gevonden",
    "section/agencyfee-info/inheritedfrom":
      "The сourtage instellingen worden overgenomen van",
    "section/agencyfee-subtitle/default": "Standaard courtage",
    "section/agencyfee-subtitle/defaultfornewunits":
      "Standaard waarden voor nieuwe huurobjecten",
    "section/agencyfee-info/agreementsnotfound": "Geen overeenkomst gevonden",
    "section/agencyfee-table-title": "Standaard overeenkomst instellingen",
    "address/default-agreement-subtitle":
      "Standaard overeenkomst instellingen voor huurobjecten op dit adres",

    //Agency fee dialog
    "dialog/agencyfee-title": "Courtage",
    "dialog/agreement-title": "Overeenkomst",
    "dialog/agencyfee-subtitle": "Courtage instelling voor :entity",
    "dialog/agencyfee-info":
      "Maandelijks wordt automatisch een courtage nota gemaakt op basis van onderstaande informatie.",
    "dialog/agencyfee-info/amount":
      "De courtage is het bedrag inclusief de BTW",
    "dialog/agencyfee-info/fixedfee":
      "Voor iedere huurnota wordt een courtage nota gemaakt voor het volgende vaste bedrag:",
    "dialog/agencyfee-info/percentagefee":
      "Het percentage wordt toegepast op de bedragen van het actieve contract, of op de standaard huurbedragen als er geen actief contract is.",
    "dialog/agencyfee-info/chargetypes":
      "Het percentage wordt berekend over de geselecteerde type bedragen.",
    "dialog/agencyfee-field/fixedfee-label": "Vaste maandelijkse vergoeding",
    "dialog/agencyfee-field/newagency-fixedfee-label": "Vaste vergoeding",
    "dialog/agencyfee-field/percentagefee-label": "Percentage van de huur",
    "dialog/agencyfee-field/newagency-percentagefee-label":
      "Variabele vergoeding, percentage van de huur",
    "dialog/agencyfee-field/fixedpluspercentagemode-label":
      "Vast en/of percentage",
    "dialog/agencyfee-field/currency-label": "Valuta",
    "dialog/agencyfee-field/vat-label": "BTW bedrag",
    "dialog/agencyfee-field/vatpercentage-label": "BTW percentage",
    "dialog/agencyfee-radio/dates-hint": "Datum waarop vergoedingen ingaan",
    "dialog/agencyfee-field/firstdate-label": "Specifieke datum",
    "dialog/agencyfee-field/firstdate-radiobutton": "specifieke datum",
    "dialog/agencyfee-field/startfromcontractdate-label":
      "eerste dag van het eerstvolgende contract",
    "dialog/agencyfee-field/lastdate-label": "Laatste dag voor courtage nota’s",
    "dialog/agencyfee-field/chargetypes-label": "Nota type",
    "dialog/preprocess-info/agencyfee":
      "De courtage wordt verwijderd. Doorgaan?",
    "dialog/remove-contract": "De overeenkomst wordt verwijderd. Doorgaan?",
    "dialog/postprocess-info/agencyfeeupdate":
      "De wijzigingen zijn bewaard. Deze wijzigingen worden toegepast bij nieuwe courtage nota’s die maandelijks worden gemaakt.",
    "dialog/preprocess-endagencyfee-info1":
      "Bepaal de laatste dag waarvoor de courtage moet worden berekend. Courtage nota’s die reeds zijn gemaakt voor de periode na de einddatum moeten handmatig worden verwijderd.",

    /*
    | Banktransaction page.
    */
    "page/banktransaction-section/charge-correctcharge-button": "Nota correct",
    "page/banktransaction-section/charge-incorrectcharge-button":
      "Nota verkeerd",
    "page/banktransaction-section/charge-correctcharges-button":
      "Notas correct",
    "page/banktransaction-section/charge-incorrectcharges-button":
      "Notas verkeerd",
    "page/banktransaction-section/title-transactionscount":
      "Controle transacties :current van :total",
    "page/banktransaction-section/title-transactioncount":
      "Transactie :current van :total",
    "page/banktransaction-section/unusedpayment-hint":
      "De bank transactie is als betaling geregistreerd. Een bijpassende nota werd echter niet gevonden. Selecteer een bestaande nota die bij deze betaling hoort, of maak een nieuwe nota.",

    /*
    | Banktransaction page dialog.
    */
    "dialog/banktransactioncoach-title": "Selecteer tegenpartij",
    "dialog/banktransactioncoach-info/step1":
      "Selecteer persoon of organisatie en klik Volgende",
    "dialog/banktransactioncoach-info/step2":
      "Selecteer een bestaande persoon/organisatie, of kllik Nieuw",

    /* Hints */
    "page/contracts-hint/lastdate-info":
      "De laatste dag is de laatste dag van de periode zoals die in het huurcontract werd overeengekomen.",
    "page/personcreateupdate-company-info":
      "Selecteer de organisatie voor deze persoon",
    "dialog/coachcreditinvoice-vat/info":
      "Verstrek het te crediteren bedrag (inclusief BTW, indien van toepassing)",
    "page/propertyupdate-tab/settings-hint/bankaccount":
      "Standaard bankrekening voor uitgaven en ontvangsten tbv deze adres",
    "page/contracts-hint/readonly":
      "Het contract is getekend; klik vernieuwen om een lopend contract te wijzigen, of verwijder en maak een nieuw contract indien je een fout hebt gemaakt",
    "page/contracts-label/automaticallysendrentinvoice":
      "Stuur automatisch de maandelijkse huurnota per email naar de huurder",
    "page/contracts-label/iscommercialcontract":
      "Dit is een BTW contract. De contract bedragen zijn inclusief :vatPercentage% BTW",

    /*
    | Property page
    */
    "page/property-section/attachment-hint":
      "Denk aan een foto van het pand (foto's binnenzijde toevoegen bij het huurobject)",

    /*
    | Contracts dialog
    */
    "dialog/preprocess-info/checkfirstdate":
      "De huurder mag in het huurobject verblijven tot en met de 1ste dag van de nieuwe maand. Doorgaan?",
    "dialog/preprocess-info2/checkfirstdate":
      "Of moet de huurder het huurobject hebben verlaten voor de 1ste dag van de nieuwe maand? Klik dan Annuleren, en pas de datum aan.",
    "dialog/preprocess-endcontract-info1":
      "Bepaal de laatste dag van de huurperiode. Deze datum is de einddatum en de laatste dag waarop het huurobject ter beschikking staat van de huurder.",
    "dialog/preprocess-endcontract-info2":
      "Met het instellen van de einddatum stopt Casadesk met het maken van nieuwe huurnota's. Zo nodig worden bestaande huurnota's aangepast of verwijderd. Ook wordt een nota gemaakt voor het terugbetalen van de borg.",
    "dialog/preprocess-endcontract-info3":
      "Beëindig het contract niet indien je alleen gegevens wilt wijzigen zoals: huurbedrag, bewoner, huurobject,.. e.d. Klik in dat geval op op Vernieuw contract.",
    "dialog/postprocess-endcontract-ending-info-1":
      "De status is gewijzigd naar Geeindigd, de einddatum is :endDate.",
    "dialog/postprocess-endcontract-ending-info-2":
      "Op dit moment worden nota’s bijgewerkt, indien nodig. Voor betaalde borg wordt een borg retour nota gemaakt. Zodra gereed, vind je de bijgewerkte nota’s terug op de tab Financiën.",
    "dialog/postprocess-endcontract-ended-info-1":
      "De einddatum is geregistreerd, de laatste huurdag is :endDate. Voor een betaalde borg wordt een borg retour nota gemaakt.",
    "dialog/renewcontract-info1":
      "Je gaat een nieuwe versie van een bestaand contract maken. Je kunt dan bijvoorbeeld een huurverhoging doorvoeren, of een nieuwe bewoner invoeren.",
    "dialog/renewcontract-info2":
      "Om de voorgaande contractgegevens vast te houden wordt in Casadesk een nieuwe versie van het contract gemaakt. Deze nieuwe versie hoeft niet door de huurder te worden ondertekend. Gebruikelijk geven huurcontracten de eigenaar namelijk de mogelijkheid om de huur jaarlijks te verhogen. En in die gevallen is het reeds ondertekende contract voldoende.",
    "dialog/preprocess-renewcontract":
      "Bepaal de datum vanaf wanneer de aanpassingen - die je gaat maken - actief moeten zijn.",
    "dialog/preprocess-removenotsignedcontract":
      "Het contract voor huurder :tenant wordt verwijderd. Doorgaan?",
    "dialog/preprocess-removesignedcontract-baseverison":
      "Het contract wordt verwijderd. Nota’s en betalingen die automatisch voor dit contract zijn gemaakt, worden ook verwijderd. Nota’s en betalingen die op een andere wijze voor dit contract zijn gemaakt, worden niet verwijderd.",
    "dialog/preprocess-removesignedcontract-renewedverison":
      "Omdat dit de vernieuwde versie van het contract is, wordt de voorgaande versie opnieuw actief gemaakt.",
    "dialog/postprocess-removenotsignedcontract": "Het contract is verwijderd.",
    "dialog/postprocess-removesignedcontract":
      "Het contract is verwijderd. De automatisch gegenereerde contract nota’s worden nu ook verwijderd en financiële overzichten bijgewerkt.",
    "dialog/preprocess-contractisbusy":
      "Het contract kan niet worden gewijzigd op dit moment omdat financiële gegevens worden bijgewerkt. Probeer later opnieuw.",
    "dialog/auto-email-send/tenant-email-notfound":
      "Voor deze huurder is nog geen e-mail adres vastgelegd. Klik Doorgaan om het e-mail adres nu vast te leggen.",
    "dialog/auto-email-send/company-tenant-email-notfound":
      "De contactpersoon heeft geen email adres. Nu een email adres invullen?",
    "dialog/create-pdf-title":
      "Het PDF document wordt gemaakt en als bijlage toegevoegd aan de nota. Klik deze bijlage om het document te bekijken. Of selecteer de actie Stuur een kopie per e-mail om het document door te sturen.",
    "dialog/create-pdf-contract-title":
      "Het PDF document wordt gemaakt en als bijlage toegevoegd aan de contract. Klik deze bijlage om het document te bekijken. Of selecteer de actie Stuur een kopie per e-mail om het document door te sturen.",
    "dialog/set-invoice-title":
      "Er wordt een factuur (PDF) gemaakt waarna de nota niet meer kan worden gewijzigd.",

    /*  Contract pages (update, create, extend) */
    "field/lastfinalenddate-info/error":
      "Kies een andere datum. De datum ligt nu voor de eerste dag van het contract",

    // ID document country dropdown
    "dropdown/documentcountry-label": "ID document uitgegeven in",

    /* Coach dialogs for owner (stepper) */
    "coach/propertyowner-scenario/company-step/step-1-title": "De organisatie",
    "coach/propertyowner-scenario/company-step/step-1-subtitle":
      "Verstrek de naam van de organisatie en klik 'Volgende'",
    "coach/propertyowner-scenario/company-step/step-2-title": "Samenvatting",
    "coach/propertyowner-scenario/company-step/first-info1":
      "Is de eigenaar een persoon of een organisatie?",
    "coach/propertyowner-scenario/company-step/first-info2":
      "Zijn 2 of meer personen samen de verhuurder? Kies dan voor Organisatie en voeg de personen daar later aan toe.",
    "coach/propertyowner-radiobutton/person": "Persoon",
    "coach/propertyowner-radiobutton/company": "Organistatie",
    "coach/propertyowner-title": "Nieuwe eigenaar",
    "coach/propertyowner-scenario/company-step/second-title": "Organisatie",
    "coach/propertyowner-scenario/company-step/third-title": "Samenvatting",
    "coach/propertyowner-scenario/company-step/fourth-title": "Afronden",
    "coach/propertyowner-scenario/company-step/second-field/companyname-label":
      "Naam organisatie",
    "coach/propertyowner-scenario/company-step/second-info1":
      "Verstrek de naam van de organisatie en klik 'Volgende'.",
    "coach/propertyowner-scenario/company-step/third-info1":
      "Klik 'Volgende' en de nieuwe eigenaar wordt geregistreerd op basis van de volgende gegevens:",
    "coach/propertyowner-scenario/company-step/third-info2":
      "Nieuwe eigenaar: ",
    "coach/propertyowner-scenario/company-step/fourth-info1":
      "De volgende eigenaar is succesvol geregistreerd: ",
    "coach/propertyowner-scenario/company-step/fourth-info2":
      "Klik 'Afronden' en verstrek zo nodig meer details van de eigenaar.",
    "coach/propertyowner-scenario/company-step/fourth-errorinfo1": "Probleem:",
    "coach/propertyowner-scenario/company-step/fourth-errorinfo2":
      "Ga terug en verhelp het probleem, of klik 'Sluiten' en probeer het later opnieuw.",
    "coach/propertyowner-scenario/person-step/step-1-title": "De persoon",
    "coach/propertyowner-scenario/person-step/step-1-subtitle":
      "Verstrek de naam van de persoon en klik 'Volgende'.",
    "coach/propertyowner-scenario/person-step/second-field/firstname-label":
      "Voornaam",
    "coach/propertyowner-scenario/person-step/second-field/lastname-label":
      "Achternaam",
    "coach/propertyowner-scenario/person-step/second-title": "Persoon",
    "coach/propertyowner-scenario/person-step/third-title": "Organisatie",
    "coach/propertyowner-scenario/person-step/fourth-title": "Vastleggen",
    "coach/propertyowner-scenario/person-step/fifth-title": "Afronden",
    "coach/propertyowner-scenario/person-step/third-info1":
      "Verrstrek de naam van de organisatie en klik 'Volgende'.",
    "coach/propertyowner-scenario/person-step/third-info2":
      "Een verhuurder is in Casadesk altijd een organisatie. We creëren daarom een fictieve organisatie en koppelen daaraan deze persoon.",
    "coach/propertyowner-scenario/person-step/last-hint":
      "Meer verhuurder gegevens kunnen later worden toegevoegd",
    "coach/propertyowner-scenario/person-step/third-field/companyname-label":
      "Naam organisatie",
    "coach/propertyowner-scenario/person-step/third-field/additionalnameofcompany-label":
      " Verhuur",
    "coach/propertyowner-scenario/person-step/fourth-info1":
      "Klik 'Volgende' en de nieuwe eigenaar wordt geregistreerd op basis van de volgende gegevens:",
    "coach/propertyowner-scenario/person-step/fourth-info2":
      "Person :contactName will be linked to the company :companyName.",
    "coach/propertyowner-scenario/person-step/fifth-info1":
      "De gegevens van de nieuwe eigenaar zijn vastgelegd: ",
    "coach/propertyowner-scenario/person-step/fifth-info2":
      "Klik 'Afronden' en verstrek zo nodig meer details van de persoon. Klik dan 'Bewaren' en ga door met het afronden van de nieuwe locatie.",
    "coach/propertyowner-button/next": "Volgende",
    "coach/propertyowner-field/newcompany-label": "Organisatie",
    "coach/propertyowner-field/newperson-label": "Persoon",
    "coach/owner-error/field-label": ":field",
    "coach-error-contacts.firstname": "Voornaam",
    "coach-error-name": "Naam organisatie",

    /* Coach dialogs for POA owner (stepper) */
    "coach/poaowner-scenario/company-step/first-title": "Nieuwe VVE",
    "coach/poaowner-scenario/company-step/second-title": "Contactgegevens",
    "coach/poaowner-scenario/company-step/third-title": "Vastleggen",
    "coach/poaowner-scenario/company-step/fourth-title": "Afronden",
    "coach/poaowner-scenario/company-step/first-field/companyname-label":
      "Naam organisatie",
    "coach/poaowner-scenario/company-step/first-field/poaname-label":
      "Naam VVE",
    "coach/poaowner-scenario/company-step/first-info1":
      "Verstrek de naam van de VVE.",
    "coach/poaowner-scenario/company-step/second-info1":
      "Verstrek de contactgegevens voor de VVE.",
    "coach/poaowner-radiobutton/department": "Afdeling",
    "coach/poaowner-radiobutton/person": "Contactpersoon",
    "coach/poaowner-radiobutton/none": "Niet op dit moment",
    "coach/poaowner-scenario/company-step/second-field/department-label":
      "Naam afdeling",
    "coach/poaowner-scenario/company-step/third-info1":
      "Klik Volgende en de nieuwe VVE wordt geregistreerd op basis van de volgende gegevens:",
    "coach/poaowner-scenario/company-step/third-poa/label": "Naam VVE: ",
    "coach/poaowner-scenario/company-step/third-contactdetails/label":
      "Contactgegevens: ",
    "coach/poaowner-scenario/company-step/fourth-info1":
      "De VVE is succesvol geregistreerd: ",
    "coach-error-contacts.email": "Email",
    "coach-error-email": "Email",

    /* Coach dialogs for user (stepper) */
    "coach/taskexecutor-scenario/company-step/first-info1":
      "Is de uitvoerende een contactpersoon of een gebruiker van Casadesk?",
    "coach/taskexecutor-radiobutton/person": "Contactpersoon",
    "coach/taskexecutor-radiobutton/user": "Gebruiker",
    "coach/taskexecutor-title": "Nieuw contact",
    "coach/taskexecutor-scenario/user-step/second-title": "Nieuwe gebruiker ",
    "coach/taskexecutor-scenario/user-step/third-title": "Afronden",
    "coach/taskexecutor-scenario/person-step/third-info":
      "De nieuwe contactpersoon is vastgelegd!",
    "coach/taskexecutor-scenario/user-step/third-info":
      "De nieuwe gebruiker is vastgelegd!",
    "coach/taskexecutor-scenario/person-step/second-title":
      "Nieuwe contactpersoon",
    "coach/taskexecutor-scenario/person-step/second-field/firstname-label":
      "Voornaam",
    "coach/taskexecutor-scenario/person-step/second-field/lastname-label":
      "Achternaam",
    "coach/taskexecutor-scenario/person-step/second-field/email-label": "Email",
    "coach/taskexecutor-scenario/user-step/first-error":
      "De nieuwe gebruiker kan niet worden vastgelegd. Je hebt geen Admin rol in Casadesk. Vraag een gebruiker met de Admin rol de nieuwe gebruiker voor je vast te leggen.",
    "coach/taskexecutor-button/next": "Verder",

    "coach/executor-scenario/company-step/first-info1":
      "Kies de passende optie voor de nieuw contact:",
    "coach/reporter-scenario/company-step/first-info1":
      "Kies de passende optie voor de nieuw contact:",
    "coach/executor-radiobutton/person": "Contactpersoon",
    "coach/executor-radiobutton/user": "Andere gebruiker",
    "coach/executor-radiobutton/company": "Organisatie",
    "coach/executor-radiobutton/department": "Afdeling",
    "coach/executor-scenario/person-step/second-title": "Contactpersoon",
    "coach/executor-scenario/person-step/third-title": "Organisatie",
    "coach/executor-scenario/person-step/fourth-title": "Vastleggen",
    "coach/executor-scenario/person-step/fifth-title": "Afronden",
    "coach/executor-scenario/person-step/second-info1":
      "Verstrek de gegevens van de contactpersoon:",
    "coach/executor-radiobutton/existingcompany": "Bestaande organisatie",
    "coach/executor-radiobutton/newcompany": "Nieuwe Organisatie",
    "coach/executor-radiobutton/nocompany":
      "Geen contactpersoon voor een organisatie",
    "coach/executor-scenario/person-step/third-info1":
      "Is de persoon een contactpersoon voor een organisatie?",
    "coach/executor-scenario/person-step/fourth-info1":
      "Klik 'Volgende' en de nieuwe contact wordt geregistreerd op basis van de volgende gegevens:",
    "coach/executor-scenario/person-step/fourth-label/person":
      "Contactpersoon: ",
    "coach/executor-scenario/person-step/fourth-label/companyname":
      "Naam organisatie: ",
    "coach/executor-scenario/person-step/fifth-info1":
      "De volgende uitvoerder is succesvol geregistreerd: ",
    "coach-error-firstname": "Voornaam",
    "coach/executor-scenario/company-step/second-title": "Nieuwe Organisatie",
    "coach/executor-scenario/company-step/third-title": "Contactgegevens",
    "coach/executor-scenario/company-step/fourth-title": "Vastleggen",
    "coach/executor-scenario/company-step/fifth-title": "Afronden",
    "coach/executor-scenario/company-step/second-info1":
      "Verstrek de naam van de organisatie: ",
    "coach/executor-scenario/company-step/third-info1":
      "Verstrek de contactgegevens voor de organisatie: ",
    "coach/executor-scenario/company-step/fourth-info1":
      "Klik 'Volgende' en de nieuwe contact wordt geregistreerd op basis van de volgende gegevens:",
    "coach/executor-scenario/company-step/fourth-label/newcompany":
      "Organisatie: ",
    "coach/executor-scenario/company-step/fourth-label/newperson": "Persoon: ",
    "coach/executor-scenario/company-step/fourth-label/department":
      "Afdeling: ",
    "coach/executor-scenario/company-step/fifth-info1":
      "De volgende uitvoerder is succesvol geregistreerd: ",
    "coach/executor-scenario/department-step/second-title": "Afdeling",
    "coach/executor-scenario/department-step/third-title": "Vastleggen",
    "coach/executor-scenario/department-step/fourth-title": "Afronden",
    "coach/executor-scenario/department-step/second-info1":
      "Verstrek de gegevens voor de afdeling: ",
    "coach/executor-scenario/user-step/second-info1":
      "Verstrek de gegevens van de gebruiker: ",
    "coach/executor-title": "Nieuw contact",
    "coach/create-contact-for-company":
      "Voor :companyName is er nog geen contactpersoon bekend. Maak nu een contactpersoon voor :companyName",
    "coach/executor-scenario/user-step/second-title": "Gebruiker ",
    "coach/executor-scenario/user-step/third-title": "Vastleggen",
    "coach/executor-scenario/user-step/fourth-title": "Afronden",
    "coach/executor-scenario/person-step/third-info":
      "De nieuwe contactpersoon is vastgelegd!",
    "coach/executor-scenario/user-step/third-info":
      "De nieuwe gebruiker is vastgelegd!",
    "coach/executor-scenario/person-step/second-field/firstname-label":
      "Voornaam",
    "coach/executor-scenario/person-step/second-field/lastname-label":
      "Achternaam",
    "coach/executor-scenario/person-step/second-field/email-label": "Email",
    "coach/executor-scenario/user-step/first-error":
      "De nieuwe gebruiker kan niet worden vastgelegd. Je hebt geen Admin rol in Casadesk. Vraag een gebruiker met de Admin rol de nieuwe gebruiker voor je vast te leggen.",
    "coach/executor-button/next": "Verder",
    "coach/executor-scenario/user-step/fifth-info2":
      "Er is een email verzonden naar de nieuwe gebruiker. Zodra de gebruiker de uitnodiging bevestigt, heeft hij toegang tot Casadesk.",
    "coach/executor-scenario/user-step/fourth-info1":
      "Klik 'Volgende' en de nieuwe contact wordt geregistreerd op basis van de volgende gegevens: ",
    "coach/executor-scenario/user-step/fourth-label/newuser": "Gebruiker: ",

    /* Coach dialogs UNIT (stepper) */
    "coach/newunit-step/first-step": "Verhuurder",
    "coach/newunit-step/first-title": "De verhuurder",
    "coach/newunit-step/first-subtitle":
      "Selecteer de verhuurder voor het huurobject",
    "coach/newunit-step/first-step-success":
      "De gegevens van de verhuurder zijn bewaard",
    "coach/newunit-step/first-step-person-or-company":
      "Is de verhuurder een persoon of een organisatie",
    "coach/newunit-step/first-step-two-or-more-landlords":
      "Zijn 2 of meer personen samen de verhuurder? Kies dan voor Organisatie en voeg de personen daar later aan toe.",
    "coach/newunit-step/first-step-company-hint":
      "Een verhuurder is in Casadesk altijd een organisatie. We creëren daarom een fictieve organisatie en koppelen daaraan deze persoon.",
    "coach/newunit-step/second-step": "Adres",
    "coach/newunit-step/second-title": "Het adres",
    "coach/newunit-step/second-subtitle":
      "Selecteer het adres voor :companyDisplayName",
    "coach/newunit-step/third-step": "Huurobject",
    "coach/newunit-step/third-title": "Het huurobject",
    "coach/newunit-step/third-subtitle": "De basisgegevens van het huurobject",
    "coach/newunit-step/charge-step": "Huurbedrag",
    "coach/newunit-step/charge-title": "Huurbedrag",
    "coach/newunit-step/charge-subtitle":
      "De standaard huurbedragen vastleggen voor dit huurobject",
    "coach/newunit-step/fourth-step": "Overeenkomst",
    "coach/newunit-step/fourth-title": "Overeenkomst met de verhuurder",
    "coach/newunit-step/fourth-subtitle":
      "De overeengekomen vergoeding van de verhuurder",
    "coach/newunit-step/fifth-step": "Samenvatting",
    "coach/newunit-step/fifth-title": "Samenvatting",
    "coach/newunit-step/sixth-step": "Afronden",
    "coach/newunit-step/sixth-title": "Afronden",
    "coach/newunit-step/fifth-subtitle":
      "Het nieuwe huurobject is succesvol vastgelegd",
    "coach/newunit-step/third-address/label": "Locatie:",
    "coach/newunit-step/third-unittype/label": "Type:",
    "coach/newunit-step/third-unitnumber/label": "Huurobject:",
    "coach/newunit-step/third-agencyfee/label": "Courtage:",
    "coach/newunit-step/third-amountbasicrent/label": "Bedrag: ",
    "coach-error-chargetemplates[0].amount": "Bedrag",
    "coach-error-propertyid": "Locatie",
    "coach-error-unitnumber": "Nummer huurobject",
    "coach-error-counterparty":
      "Tegenpartij niet gewijzigd. Iban is verschillend",
    "coach/newunit-step/second-info2":
      "Nadat het huurobject is vastgelegd kunnen aanvullend meer standaard bedragen worden toegevoegd voor bijvoorbeeld services, nutsvoorzieningen,.. etc. Het gaat hier om standaard bedragen, in individuele contracten kunnen deze bedragen worden aangepast.",
    "coach/newunit-step/third-info1":
      "Verstrek de maandelijkse courtage voor dit huurobject.",
    "coach/newunit-step/fourth-info1":
      "Klik Volgende en het nieuw huurobject wordt vastgelegd:",
    "coach/newunit-step/fifth-info1":
      "Huurobject gegevens succesvol vastgelegd",
    "coach/newunit-step/fifth-info2":
      "Bekijk en bewerk meer details in de detail pagina van dit nieuwe huurobject.",
    "coach/newunit-step/fifth-info3":
      "Klik Doorgaan en registreer het eerste contract voor dit huurobject, of klik Annuleren om deze coach af te sluiten.",
    "coach/newunit-step/agreement-success":
      "Overeenkomst gegevens succesvol vastgelegd",
    "coach/newunit-step/second-label/amountbasicrent": "Basis huur",
    "coach/newunit-step/first-info1": "De verhuurder",
    "coach/newunit-step/first-info1-subtitle":
      "Registreer de naam van de verhuurder",
    "coach/newunit-step/first-newowner/label": "Nieuwe verhuurder",
    "coach/newunit-step/first-selectexistingowner/label": "Bekende verhuurder",
    "coach/newunit-step/second-newproperty/label": "Nieuwe adres",
    "coach/newunit-step/second-selectexistingproperty/label": "Bekend adres",
    "coach/newunit-step/second-info1": "Registreer een nieuwe",
    "coach/newunit-step2/title": "Het adres",
    "coach/newunit-step/unit-info1": "Verstrek de huurobject gegevens.",
    "coach/newunit-step2/subtitle": "Selecteer het adres voor :companyName",

    /* Coach dialogs PROPERTY (stepper) */
    "coach/newproperty-step/first-step": " Verhuurder",
    "coach/newproperty-step/first-title": " De verhuurder",
    "coach/newproperty-step/first-subtitle":
      "Selecteer de verhuurder van het nieuwe adres",
    "coach/newproperty-step/second-step": "Adres",
    "coach/newproperty-step/second-title": "Het adres",
    "coach/newproperty-step/third-title": "Samenvatting",
    "coach/newproperty-step/forth-title": "Afronden",
    "coach/newproperty-step/forth-subtitle":
      "Het adres is succesvol geregistreerd.",
    "coach/newproperty-step/third-address/label": "Adres:",
    "coach/newproperty-step/third-owner/label": "Eigenaar:",
    "coach-error-companyid": "Eigenaar",
    "coach-error-address.googleplaceid": "Adres",
    "coach/newproperty-step/first-info1":
      "Het nieuwe adres voor :ownerDisplayName",
    "coach/newproperty-step/third-subtitle":
      "Klik Afronden en de nieuwe adres wordt geregistreerd op basis van de volgende gegevens",
    "coach/newproperty-step/third-info1":
      "De adres is succesvol geregistreerd:",
    "coach/newproperty-step/third-info2":
      "Het locatie is geregistreerd. Bekijk en bewerk de gegevens in de details pagina van dit locatie.",

    /* Coach dialogs CONTRACT (stepper) */
    "coach/newcontract-step/first-step-title": "Huurobject",
    "coach/newcontract-step/second-step-title": "Huurder",
    "coach/newcontract-step/third-step-title": "Bewoners",
    "coach/newcontract-step/fourth-step-title": "Contract",
    "coach/newcontract-step/fifth-step-title": "Samenvatting",
    "coach/newcontract-step/sixth-step-title": "Afronden",
    "coach/newcontract-step/third-unit/label": "Huurobject:",
    "coach/newcontract-step/third-amountbasicrent/label": "Bedrag:",
    "coach/newcontract-step/third-tenant/label": "Huurder:",
    "coach/newcontract-step/third-firstdate/label": "Eerste dag:",
    "coach/newcontract-step/first-title": "Het huurobject",
    "coach/newcontract-step/first-subtitle": "Selecteer een huurobject",
    "coach/newcontract-step/second-title": "De huurder",
    "coach/newcontract-step/second-subtitle":
      "Nieuwe huurder, of een bestaande huurder?",
    "coach/newcontract-step/third-title": "De bewoners",
    "coach/newcontract-step/third-subtitle":
      "Dit is de huurder van het huurobject.",
    "coach/newcontract-step/fourth-title": "Datums huurcontract",
    "coach/newcontract-step/fourth-subtitle":
      "Verstrek de contractdatums en contractbedragen",
    "coach/newcontract-step/fifth-title": "Samenvatting",
    "coach-error-firstdate": "Eerste dag",
    "coach-error-unitid": "Huurobject",
    "coach-error-maintenantcontactid": "Huurder",
    "coach-error-contactforcontracts[0].contactid": "Huurder",
    "coach/newcontract-step/first-newtenant/label": "Nieuwe huurder",
    "coach/newcontract-step/first-existingtenant/label": "Bestaande huurder",
    "coach/newcontract-step/first-existingtenant/hint1":
      "Meer informatie over de huurder kan later toegevoegd",
    "coach/newcontract-step/tenant-infoadditionaloccupant":
      "Extra huurders, of bewoners? Klik Persoon Toevoegen",
    "coach/newcontract-step/tenant-button/addperson-label": "Persoon toevoegen",
    "coach/newcontract-step/occupants-info1":
      "Dit is de huurder van het huurobject.",
    "coach/newcontract-step/occupantscreated-info1":
      "Andere mede-huurders of bewoners die in het contract worden genoemd:",
    "coach/newcontract-step/paiddirectlytoowner-label":
      "De eigenaar ontvangt betalingen direct van huurder.",

    /* Coach dialogs AGENCY (stepper) */
    "coach/newagency-step/first-welcometitle": "Welkom!",
    "coach/newagency-step/first-info1":
      "De Casadesk omgeving voor :agencyName is gereed voor gebruik.",
    "coach/newagency-step/first-info2":
      "We gaan nu de basisinformatie vastleggen. Met deze informatie zal Casadesk goed functioneren voor :agencyName.",
    "coach/newagency-step/first-info3":
      "Maar neem nu alvast een kijkje en maak een begin met Casadesk voor :agencyName.",
    "coach/newagency-step/second-info1":
      "Deze gegevens worden bijvoorbeeld gebruikt in facturen en berichten",
    "coach/newagency-step/second-info2":
      "Maandelijks worden automatisch de huurnota’s gemaakt op basis van de verhuurcontracten. Vervolgens worden de betalingen verwerkt en zijn iedere maand de afrekeningen voor de eigenaars direct beschikbaar.",
    "coach/newagency-step/third-info1": "Bankrekening van :agencyName",
    "coach/newagency-step/third-info2":
      "Dit is de bankrekening waarop - namens de verhuurders - de huur wordt ontvangen",
    "coach/newagency-step/first-title": "Welkom",
    "coach/newagency-step/second-title": "Bedrijfsgegevens",
    "coach/newagency-step/third-title": "Bankgegevens",
    "coach-loseinformation/info":
      "De coach wordt gesloten. De ingevoerde gegevens gaan verloren.",
    "coach/newagency-step/fourth-title": "Logo",
    "coach/newagency-step/fifth-title": "Afronden",
    "coach/newagency-step/fourth-info1":
      "Upload het bestand met het bedrijfslogo (jpg, jpeg, png). Het logo wordt bijvoorbeeld gebruikt in de afrekeningen, facturen en berichten.",
    "coach/newagency-step/fifth-errorinfo2": "Ga terug en verhelp het probleem",
    "coach/newagency-step/fifth-info1":
      "De belangrijkste instellingen zijn hiermee vastgelegd en de Casadesk omgeving voor :agencyName is gereed voor gebruik.",
    "coach/newagency-step/fifth-info2":
      "We gaan nu verder met het registreren van het eerste huurobject.",
    "coach-error-bankaccountid": "Bankrekening van kantoor",
    "coach-error-mainbankaccountid": "Bankrekening voor de te ontvangen huur",
    "coach-error-shortname": "Verkorte naam",
    "coach/newagency-step/first-maintitletext": "Welkom :agencyName!",
    "coach/newagency-step/second-maintitletext": "De bedrijfsgegevens",
    "coach/newagency-step/third-maintitletext":
      "De bankrekening voor het beheer",
    "coach/newagency-step/fourth-maintitletext": "Upload het bedrijfslogo",
    "coach/newagency-step/fifth-maintitletext": "Instellingen opgeslagen",
    "coach/newpropertyfirstuser-step/fifth-hintforaddress":
      "Start met het typen van huisnummer en straat, en klik het best passende adres",
    "coach/newpropertyfirstuser-step/fifth-hintforiban":
      "Verstrek een volledig Iban nummer ( voorbeeld: NL91ABNA0417164300 )",
    "label-bank-account-name": "Bankrekening op naam van",
    "list-label-bank-account-name": "Ten name van",
    "coach-welcome-error-phone": "Algemeen telefoonnummer",
    "coach-welcome-error-email": "Algemeen bedrijfs e-mailadres",
    "agency-general-address": "Kies het adres van de hoofdvestiging",
    "coach/newagency-step/fourth-hintlogo":
      "Je kunt deze stap ook overslaan en het bedrijfslogo later toevoegen",
    "coach/newagency-step/fifth-info3":
      "Eén of enkele problemen verhinderen dat we de gegevens kunnen bewaren:",

    /* Coach  dialogs NEW PROPERTY FIRST USER (stepper) */
    "coach/newpropertyfirstuser-scenario/single-step/first-title": "Type",
    "coach/newpropertyfirstuser-scenario/single-step/second-title":
      "Verhuurder",
    "coach/newpropertyfirstuser-scenario/single-step/third-title": "Huurobject",
    "coach/newpropertyfirstuser-scenario/single-step/fourth-title":
      "Overeenkomst",
    "coach/newpropertyfirstuser-scenario/single-step/fifth-title": "Huurder",
    "coach/newpropertyfirstuser-scenario/single-step/sixth-title": "Contract",
    "coach/newpropertyfirstuser-scenario/single-step/seventh-title":
      "Afrekening",
    "coach/newpropertyfirstuser-scenario/single-step/eighth-title": "Afsluiten",
    "coach/newpropertyfirstuser-radiobutton/single":
      "Zelfstandig huurobject (appartement, vrijstaand,..)",
    "coach/newpropertyfirstuser-radiobutton/multiple":
      "Eén adres met meerdere onzelfstandige huurobjecten (kamers, studio’s,..)",
    "coach/newpropertyfirstuser-radiobutton/complex":
      "Wooncomplex met zelfstandige huurobjecten en een eigen naam",
    "coach/newpropertyfirstuser-step/first-title": "Type huurobject",
    "coach/newpropertyfirstuser-step/first-subtitle":
      "Voor het vastleggen van alle essentiële huurobjectgegevens beginnen we met het type huurobject",
    "coach/newpropertyfirstuser-step/owner-title": "Naam van de eigenaar",
    "coach/newpropertyfirstuser-step/landlord-title": "De verhuurder",
    "coach/newpropertyfirstuser-step/owner-info":
      "Meer gegevens over de eigenaar kunnen later worden toegevoegd",
    "coach/newpropertyfirstuser-step/fifth-info1":
      "Huurder gegevens succesvol vastgelegd",
    "coach/newpropertyfirstuser-step/fifth-last-hint":
      "Meer huurder gegevens kunnen later worden toegevoegd",
    "coach/newpropertyfirstuser-step/fifth-company-title": "Contactpersoon",
    "coach/newpropertyfirstuser-step/sixth-info3":
      "Klik 'Sluiten' en werk de contractgegevens bij alvorens te status in te stellen op Ondertekend.",
    "coach/newpropertyfirstuser-step/eighth-info3":
      "Klik Sluiten om deze coach te beëindigen",
    "coach/newpropertyfirstuser-step/eighth-info4":
      "Registreer nog een huurobject",
    "coach/newpropertyfirstuser-step/unit-info1": "Het huurobject",
    "coach/newpropertyfirstuser-step/unit-info2":
      "De basisgegevens van het huurobject",
    "coach/newpropertyfirstuser-step/agreement-info1":
      "Overeenkomst met de verhuurder",
    "coach/newpropertyfirstuser-step/agreement-info2":
      "De overeengekomen vergoeding van de verhuurder",
    "coach/newpropertyfirstuser-step/unit-scenario/multiple-info1":
      "Verstrek de gegevens van de verschillende huurobjecten op dit adres.",
    "coach/newpropertyfirstuser-step/tenant-info1": "Naam van de huurder.",
    "coach/newpropertyfirstuser-step/contract-info1":
      "Verstrek de contractdatums en contractbedragen.",
    "coach/newpropertyfirstuser-step/contract-info": "Het huurcontract",
    "coach/newpropertyfirstuser-step/contract-info2":
      "De afspraken met de huurder",
    "coach/newpropertyfirstuser-step/statement-info":
      "De afrekening voor de verhuurder",
    "coach/newpropertyfirstuser-step/statement-info2":
      "De aankomende afrekening wordt onmiddellijk bijgewerkt zodra een nota of betaling is verwerkt.",
    "coach/newpropertyfirstuser-scenario/owner-info1":
      "Verhuurder gegevens succesvol vastgelegd",
    "coach/newpropertyfirstuser-step/sixth-info1":
      "De gegevens van het huurobject zijn succesvol geregistreerd",
    "coach/newpropertyfirstuser-step/sixth-info2":
      "Registreer nog een huurobject op hetzelfde adres",
    "coach/newpropertyfirstuser-step/sixth-info-title": "NL:Succes",
    "coach/newpropertyfirstuser-step/sixth-info-subtitle":
      "De gegevens van het huurobject zijn succesvol geregistreerd",
    "coach/newpropertyfirstuser-scenario/complex-step/third-title": "Complex",
    "coach/newpropertyfirstuser-scenario/complex-info1":
      "Verstrek de naam of beschrijving van het complex.",
    "coach/newpropertyfirstuser-scenario/complex-info2":
      "De Complex is succesvol geregistreerd:",
    "coach/newpropertyfirstuser-step/sixth-info4":
      "Klik 'Nieuw huurobject' om nog een huurobject te registreren voor dit complex.",
    "coach/newpropertyfirstuser-step/forth-infocomplex":
      "Verstrek de gegevens van de verschillende huurobjecten in dit complex.",
    "coach/newpropertyfirstuser-step/forth-addresscreated":
      "Het adres is succesvol geregistreerd.",
    "coach/newpropertyfirstuser-step/forth-hintforunittype":
      "Meer huurobject gegevens kunnen later worden toegevoegd",
    "coach/newpropertyfirstuser-step/fifth-hintfortenant":
      "Meer informatie over de huurder kan later worden toegevoegd.",
    "coach/newpropertyfirstuser-step/sixth-field/paiddirectlytoowner-label":
      "De verhuurder ontvangt betalingen direct van de huurder.",
    "coach/propertyowner-scenario/tenant-step/first-choosetype":
      "Is de huurder een persoon, of een organisatie?",
    "coach/newpropertyfirstuser-step/tenant-info3":
      "Contactpersoon bij de organisatie",
    "coach/newpropertyfirstuser-step/cotract-infochargetemplates":
      "Klik 'Toevoegen’ om nog een contractbedrag toe te voegen.",
    "coach/newpropertyfirstuser-step/cotract-amounts": "Bedragen huurcontract",
    "coach/newpropertyfirstuser-step/cotract-infochargetemplates2":
      "Klik Toevoegen om een bedrag toe te voegen.",
    "coach/newpropertyfirstuser-step/forth-hintforunitnumber":
      "Zijn er meerdere huurobjecten op hetzelfde adres, identificeer de huurobjecten dan met een nummer of beschrijving",
    "coach/propertyowner-step/tenant-info1": "De huurder",
    "coach/propertyowner-step/tenant-info2": "De basisgegevens van de huurder",
    "coach/newpropertyfirstuser-step/eighth-hintforlaststep":
      "Je kunt deze coach op ieder gewenst moment opnieuw starten",
    "coach/newpropertyfirstuser-step/title-contract-amounts": "Bedragen",
    "coach/newpropertyfirstuser-step/contract-success-title":
      "Contract gegevens succesvol vastgelegd",
    "coach/newpropertyfirstuser-step/vat-contract": "BTW contract",
    "coach/newpropertyfirstuser-step/directly-paid": "Direct betaald",

    //Coach dialog new tenant
    "coach/newtenant-step/second-title": "Afronden",
    "coach/newtenant-step/tenant-info2":
      "Dit is de persoon die het huurcontract ondertekend",

    //Coach dialog new counterparty
    "coach/newcounterparty-step/first-title": "Nieuwe persoon of organisatie",
    "coach/newcounterparty-step/first-info1":
      "The counterparty is a person, or an organization?",
    "coach/newcounterparty-step/second-info1":
      "The counterparty was successfully saved.",
    "coach/knowncounterparty/first-title": "Bekende persoon of organisatie",

    //Coach Move unit
    "coach/moveunit-step/first-title": "Adres",
    "coach/moveunit-step/select-address":
      "Vind het adres (powered by Google address search)",
    "coach/moveunit-step/select-address-hint":
      "Vergeet het huisnummer niet (inclusief toevoegingen)",
    "coach/moveunit-step/second-title": "Samenvatting",
    "coach/moveunit-step/third-title": "Resultaat",
    "coach/moveunit-step/first-info1":
      "Selecteer een andere locatie van verhuurder :ownerDisplayName",
    "coach/moveunit-step/second-info1":
      "Huurobject :unitDisplayName wordt omgekoppeld van locatie",
    "coach/moveunit-step/second-info2": "naar locatie",
    "coach/moveunit-step/third-info1": "Het adres is succesvol gewijzigd",
    "coach/moveunit-step/third-errorinfo1":
      "Er deed zich een probleem voor. Het huurobject is niet omgekoppeld.",

    //Coach Update counterparty
    "coach/counterparty-step/third-info1":
      "Het tegenpartij is succesvol gewijzigd",
    "coach/counterparty-step/third-errorinfo1":
      "Er deed zich een probleem voor. Het tegenpartij is niet omgekoppeld.",
    /* Abstract pane (information about related to object) */
    "info/receivedfrom": "Ontvangen van",
    "info/paidto": "Betaald aan",

    // Payment Information component (use for payments and charge pages: for example ChargeUpdate)
    "payment-unused-information-received":
      "Ontvangen van :counterparty op :date.",
    "payment-unused-information-paid": "Betaald aan :counterparty op :date.",
    "payment-partly-used-information-received":
      "Ontvangen van :counterparty op :date.",
    "payment-partly-used-information-paid":
      "Betaald aan :counterparty op :date.",
    "payment-fully-used-information-received":
      "Ontvangen van :counterparty op :date.",
    "payment-fully-used-information-paid":
      "Betaald aan :counterparty op :date.",
    "payment-unused-information-received-no-counterparty":
      "Ontvangen op :date.",
    "payment-unused-information-paid-no-counterparty": "Betaald op :date.",
    "payment-partly-used-information-received-no-counterparty":
      "Ontvangen op :date.",
    "payment-partly-used-information-paid-no-counterparty": "Betaald op :date.",
    "payment-fully-used-information-received-no-counterparty":
      "Ontvangen op :date.",
    "payment-fully-used-information-paid-no-counterparty": "Betaald op :date.",
    "payment-unused-information-2":
      "Kies een nota om met deze betaling te betalen.",
    "payment-partly-used-information-2":
      "Van deze betaling is het volgende bedrag nog beschikbaar om een nota mee te betalen:",
    "payment-fully-used-information-2":
      "Deze betaling is volledig gebruikt om een of meerdere nota's mee te betalen.",

    // Charge Information component (use for payments and charge pages: for example PaymentUpdate)
    "charge-unpaid-information-receivable":
      "Te ontvangen van :counterparty uiterlijk :dueDate voor :type, :period.",
    "charge-unpaid-information-payable":
      "Een nota te betalen aan :counterparty uiterlijk :dueDate voor :type, :period.",
    "charge-fully-paid-information-receivable":
      "Te ontvangen van :counterparty uiterlijk :dueDate voor :type, :period.",
    "charge-fully-paid-information-payable":
      "Een nota te betalen aan :counterparty uiterlijk :dueDate voor :type, :period.",
    "charge-partly-paid-information-receivable":
      "Te ontvangen van :counterparty uiterlijk :dueDate voor :type, :period.",
    "charge-partly-paid-information-payable":
      "Een nota te betalen aan :counterparty uiterlijk :dueDate voor :type, :period.",
    "invoice-unpaid-information-receivable":
      "Te ontvangen van :counterparty uiterlijk :dueDate voor :type, :period.",
    "invoice-unpaid-information-payable":
      "Een factuur te betalen aan :counterparty uiterlijk :dueDate voor :type, :period.",
    "invoice-fully-paid-information-receivable":
      "Te ontvangen van :counterparty uiterlijk :dueDate voor :type, :period.",
    "invoice-fully-paid-information-payable":
      "Een factuur te betalen aan :counterparty uiterlijk :dueDate voor :type, :period.",
    "invoice-partly-paid-information-receivable":
      "Te ontvangen van :counterparty uiterlijk :dueDate voor :type, :period.",
    "invoice-partly-paid-information-payable":
      "Een factuur te betalen aan :counterparty uiterlijk :dueDate voor :type, :period.",
    "charge-fully-paid-information-2": "Deze nota is volledig betaald.",
    "invoice-fully-paid-information-2": "Deze factuur is volledig betaald.",
    "charge-partly-paid-information-2":
      "Van deze nota is :paidAmount reeds betaald.",
    "invoice-partly-paid-information-2":
      "Van deze factuur is :paidAmount reeds betaald.",
    "section/charge-info/relatedtoobject": "Deze nota is gerelateerd aan:",
    "section/invoice-info/relatedtoobject": "Deze factuur is gerelateerd aan:",

    // Payment section component (use for different pages: ChargeUpdate, BankTransaction, PaymentCreate, PeymentSettle, PaymentUpdate, PaymentLink)

    /*Charge statuses (use like information text for charge)*/
    "status-paid": "Betaald",
    "status-unpaid": "Onbetaald",
    "status-partially-paid": "Deels",
    "status-to-receive": "TE ONTVANGEN",
    "status-to-pay": "TE BETALEN",
    "status-still-to-receive": "NOG TE ONTVANGEN",
    "status-still-to-pay": "NOG TE BETALEN",
    "status-received": "ONTVANGEN",
    "status-amount/paid": "BETAALD",
    "status-withdrawal": "OPNAME",
    "status-deposit": "STORTING",

    /*Payment statuses (use like information text for payment)*/
    "payment-status-to-receive": "te verwerken - ONTVANGEN",
    "payment-status-to-pay": "te verwerken - BETAALD",
    "payment-status-still-to-receive": "te verwerken - ONTVANGEN",
    "payment-status-still-to-pay": "te verwerken - BETAALD",
    "payment-status-received": "ONTVANGEN",
    "payment-status-amount/paid": "BETAALD",

    /*
    | Snackbar messages
    */

    "snackbar-message-unit-created-successfully": "Nieuw huurobject toegevoegd",
    "snackbar-message-unit-updated-successfully": "Huurobject bijgewerkt",
    "snackbar-message-user-created-successfully":
      "Nieuwe gebruiker toegevoegd.",
    "snackbar-message-user-updated-successfully": "Gebruiker bijgewerkt",
    "snackbar-message-person-created-successfully":
      "Nieuwe contactpersoon toegevoegd.",
    "snackbar-message-person-updated-successfully":
      "Contactpersoon bijgewerkt.",
    "snackbar-message-tenant-created-successfully":
      "Nieuwe huurder toegevoegd.",
    "snackbar-message-caretaker-created-successfully":
      "Nieuwe huismeester toegevoegd.",
    "snackbar-message-executor-created-successfully":
      "Nieuwe contact toegevoegd.",
    "snackbar-message-manager-created-successfully":
      "Nieuwe manager toegevoegd.",
    "snackbar-message-owner-created-successfully":
      "Nieuwe eigenaar toegevoegd.",
    "snackbar-message-company-created-successfully":
      "Nieuwe organisatie toegevoegd.",
    "snackbar-message-company-updated-successfully": "Organisatie bijgewerkt",
    "snackbar-message-unit-removed-successfully": "Huurobject verwijderd",
    "snackbar-message-person-removed-successfully": "Contactpersoon verwijderd",
    "snackbar-message-user-removed-successfully": "Gebruiker verwijderd",
    "snackbar-message-company-removed-successfully": "Organisatie verwijderd",
    "snackbar-message-property-updated-successfully": "Locatie bijgewerkt",
    "snackbar-message-property-created-successfully":
      "Nieuwe locatie toegevoegd",
    "snackbar-message-property-removed-successfully": "Locatie verwijderd",
    "snackbar-message-activity-template-created-successfully":
      "Nieuwe activiteit sjabloon toegevoegd",
    "snackbar-message-activity-template-updated-successfully":
      "Activiteit sjabloon bijgewerkt",
    "snackbar-message-activity-template-removed-successfully":
      "Activiteit sjabloon verwijderd",
    "snackbar-message-agency-fee-created-successfully":
      "Nieuwe courtage toegevoegd",
    "snackbar-message-default-agency-fee-created-successfully":
      "Standaard overeenkomst instellingen bewaard",
    "snackbar-message-default-agency-fee-updated-successfully":
      "Standaard overeenkomst instellingen bewaard",
    "snackbar-message-agency-fee-updated-successfully": "Courtage bijgewerkt",
    "snackbar-message-agency-fee-removed-successfully": "Courtage verwijderd",
    "snackbar-message-agency-settings-updated-successfully":
      "Kantoor instellingen bijgewerkt",
    "snackbar-message-bill-settlement-processed-successfully":
      "Verrekening eindafrekening verwerkt",
    "snackbar-message-user-settings-updated-successfully":
      "Gebruiker instellingen bijgewerkt",
    "snackbar-message-bank-account-created-successfully":
      "Nieuwe bankrekening toegevoegd",
    "snackbar-message-bank-account-updated-successfully":
      "Bankrekening bijgewerkt",
    "snackbar-message-bank-account-removed-successfully":
      "Bankrekening verwijderd",
    "snackbar-message-charge-created-successfully": "Nieuwe nota toegevoegd",
    "snackbar-message-charge-updated-successfully": "Nota bijgewerkt",
    "snackbar-message-charge-removed-successfully": "Nota verwijderd",
    "snackbar-message-charge-settled-successfully": "Nota verrekend",
    "snackbar-message-charge-unsettled-successfully":
      "Nota verrekening ongedaan gemaakt",
    "snackbar-message-charge-unlinked-successfully": "Nota ontkoppeld",
    "snackbar-message-charge-credited-successfully":
      "De nota is - deels - verrekend met de nieuw gemaakte credit nota",
    "snackbar-message-charge-undo-credit-successfully":
      "Creditering verwijderd",
    "snackbar-message-charge-type-created-successfully": "Nota type bewaard",
    "snackbar-message-charge-type-updated-successfully": "Nota type bewaard",
    "snackbar-message-charge-type-removed-successfully": "Nota type verwijderd",
    "snackbar-message-charge-template-created-successfully":
      "Nieuw nota sjabloon toegevoegd",
    "snackbar-message-charge-template-updated-successfully":
      "Nota sjabloon bijgewerkt",
    "snackbar-message-charge-template-removed-successfully":
      "Nota sjabloon verwijderd",
    "snackbar-message-contract-created-successfully":
      "Nieuw contract toegevoegd",
    "snackbar-message-contract-updated-successfully": "Contract bijgewerkt",
    "snackbar-message-contract-removed-successfully": "Contract verwijderd",
    "snackbar-message-contract-renewed-successfully": "Contract vernieuwd",
    "snackbar-message-contract-end-date-updated-successfully":
      "Contract einddatum bijgewerkt",
    "snackbar-message-contract-expiration-date-updated-successfully":
      "Contract notificatie datum bijgewerkt",
    "snackbar-message-email-sent-successfully": "EMail verzonden",
    "snackbar-message-event-created-successfully":
      "Nieuw :eventname toegevoegd",
    "snackbar-message-event-updated-successfully": ":eventname bijgewerkt",
    "snackbar-message-event-removed-successfully": ":eventname verwijderd",
    "snackbar-message-event-snoozed-successfully": "Event snoozed",
    "snackbar-message-financial-start-date-updated-successfully":
      "Financiële startdatum bijgewerkt",
    "snackbar-message-payment-created-successfully":
      "Nieuwe betaling toegevoegd",
    "snackbar-message-payment-updated-successfully": "Betaling bijgewerkt",
    "snackbar-message-payment-removed-successfully": "Betaling verwijderd",
    "snackbar-message-payment-settled-successfully": "Betaling verrekend",
    "snackbar-message-payment-unsettled-successfully":
      "Betaling verrekening ongedaan gemaakt",
    "snackbar-message-payment-linked-successfully": "Betaling gekoppeld",
    "snackbar-message-payment-unlinked-successfully": "Betaling ontkoppeld",
    "snackbar-message-charge-payment-created-successfully":
      "Nieuwe nota en nieuwe betaling toegevoegd",
    "snackbar-message-transaction-file-uploaded-successfully":
      "Bank transacties bestand uploaded",
    "snackbar-message-transaction-file-removed-successfully":
      "Bank transacties bestand verwijderd",
    "snackbar-expiring-contract-notification-deactivated-contract-ended":
      "Contract verloopt notificatie is inmiddels inactief, het contract is beëindigd",
    "snackbar-expiring-contract-notification-deactivated-contract-updated":
      "Contract verloopt notificatie is inmiddels inactief, het contract is bijgewerkt",
    "snackbar-expiring-contract-notification-deactivated-contract-continued":
      "Contract verloopt notificatie is inmiddels inactief, het contract wordt voortgezet",
    "snackbar-notification-snoozed": "Notificatie sluimert tot ",
    "snackbar-action-successful": "Actie succesvol",
    "snackbar-person-added-to-company-successfully":
      "Person added to this company.",
    "snackbar-person-unlinked-from-company-successfully":
      "Contactpersoon ontkoppeld van organisatie",
    "snackbar-widhdrawal-amount-from-company-successfully":
      "De opname is verwerkt.",
    "snackbar-deposit-to-savings-done-successfully": "De storting is verwerkt",
    "snackbar-message-charge-memo-updated-successfully": "Memo bijgewerkt",
    "snackbar-message-charge-memo-removed-successfully": "Memo verwijderd",
    "snackbar-chargetempalte-cannot-be-removed":
      "Wijzigen kan niet, het contract is al getekend",
    "snackbar-message-unit-service-status-updated-successfully":
      "Huurobject service status bijgewerkt",
    "snackbar-message-settle-with-savings-successfully":
      "Verrekening met tegoed is verwerkt",
    "snackbar-message-undosettle-with-savings-successfully":
      "Verrekening met tegoed ongedaan gemaakt",
    "snackbar-message-charge-snooze-updated-successfully": "Nota gesnoozed",
    "snackbar-message-charge-unsnooze-updated-successfully":
      "Nota niet meer gesnoozed",
    "snackbar-message-payment-snooze-updated-successfully":
      "Betaling gesnoozed",
    "snackbar-message-payment-unsnooze-updated-successfully":
      "Betaling niet meer gesnoozed",
    "snackbar-message-statement-snooze-updated-successfully":
      "Afrekening gesnoozed",
    "snackbar-message-statement-unsnooze-updated-successfully":
      "Afrekening niet meer gesnoozed",
    "snackbar-message-charges-for-next-mounth-create-successfully":
      "Nota’s zijn gemaakt",

    // UNIVERSAL
    // Dropdown component button label
    // The dropdown components allow users to (a) search for and select an existing object or (b) create a new object
    // The buttons, for which a label is defined below, are used to start the creation of a new object
    //
    "dropdown/chargetype-button/newchargetype": "Nieuwe type nota",
    "dropdown/person-button/newperson": "Nieuwe persoon",
    "dropdown/company-button/newcompany": "Nieuwe organisatie",
    "dropdown/bankaccount-button/newbankaccount": "Nieuwe bankrekening",
    "dropdown/company-button/propertyassociation": "Nieuwe VVE",

    // Dialogs
    //
    "dialog/warning-title": "Waarschuwing",
    "dialog/attention-title": "Opgelet",
    "dialog/attention-info/chooseexistingpayment":
      "Selecteer bestaande betaling", //User clicks Save but did not select a payment while the option Existing payments in the section payment is open in the ChargeCreate, ChargeUpdate or ChargePay page
    "dialog/attention-info/chooseexistingcharge":
      "Selecteer een bestaande nota", //   User clicks Save but did not select a charge while the option Existing charge in the section charge is open in the PaymentCreate, PaymentUpdate or PaymentLink page
    "dialog/preprocess-info/ibanalreadyused":
      "Deze bankrekening wordt reeds gebruikt voor :displayName1. Deze bankrekening verwijderen bij :displayName2 en toevoegen aan :displayName3?", // User clicks Save in a create or update page but the bank account number provided is already used by another person or company
    "dialog/preprocess-info/deletecharge":
      "De nota wordt verwijderd. Doorgaan?", //  User chooses to remove a charge
    "preprocess/cannotpaycharge-info/differentclasses":
      "Koppelen van een te betalen nota met een ontvangen betaling, of een te ontvangen nota met een betaalde betaling, is niet mogelijk.", // User selected a payment with a different class from the charge (chargeClass vs paymentClass) and clicked Save in the ChargeCreate, ChargeUpdate, PaymentCreate, PaymentUpdate or BankTranksaction page.
    "preprocess/selectbanktransactionfile-info":
      "Selecteer een bestand van het type MT940. Download het MT940 bestand met banktransacties via jouw online bank omgeving.",
    "preprocess/cantcreateactivitytemplate-info":
      "Deze functie is alleen beschikaar voor gebruikers met de Administrator rol.",
    "preprocess/cantupdateentity-info":
      "De entiteit was verwijderd en kan niet meer worden bijgewerkt",
    "dialog/preprocess-info/withdrawal":
      "Het beschikbaar tegoed voor :companyName bedraagt: :savingsAmount. Bepaal het op te nemen bedrag en klilk Doorgaan.",
    "dialog/preprocess-info/deposit":
      "Doe een storting in het spaartegoed van de eigenaar. Het bedrag wordt meegenomen in de eerstvolgende verrekening met de eigenaar. Verstrek de details en klik Doorgaan.",
    "dialog/postprocess-info/withdrawalforpayablecharge":
      "The opname is gedaan en in de afrekening verwerkt om zo de nota met de eigenaar te verrekenen.",
    "dialog/preprocess-settlewithsavings/title": "Verrekenen met het tegoed",
    "dialog/preprocess-settlewithsavings/info-select-acc":
      "Selecteer het tegoed om :savingsAmount mee te verrekenen",
    "dialog/preprocess-settlewithsavings/select-owner": "Selecteer verhuurder",
    "dialog/preprocess-undosettlewithsavings/title":
      "Maak verrekening met tegoed ongedaan",
    "dialog/preprocess-chargeundosettlewithsavings/info":
      "Maak de verrekening van deze nota met het tegoed ongedaan.",
    "dialog/preprocess-paymentundosettlewithsavings/info":
      "Maak de verrekening van deze betaling met het tegoed ongedaan.",
    "dialog/preprocess-unithasactivecontract/info":
      "Er is nog een actief contract zonder einddatum. Klik Doorgaan om een nieuw contract voor een nieuwe huurder te maken. Of klik Annuleren om het bestaande contract te vernieuwen.",
    "dialog/preprocess-negativesavingsaccount/info":
      "Onvoldoende saldo in het tegoed om deze actie te voltooien. Het beschikbare tegoed bedraagt :savingsAmount.",

    //Withdrawal dialogs
    "dialog/preprocess-withdrawal/title": "Opname tegoed",
    "dialog/preprocess-deposit/title": "Doe een storting",
    "dialog/preprocess-info/savingsamount":
      "Het nota bedrag :withdrawalamount wordt opgenomen van de spaarrekening.",
    "dialog/preprocess-info/savingsamountnotenough":
      "Het spaarbedrag is niet toereikend. Het beschikbare bedrag :savingsamount wordt opgenomen van de spaarrekening.",
    "dialog/preprocess-info/nosavings": "Er is geen spaarbedrag op dit moment.",

    //Deposit process
    "menuitem-deposit-to-owner-savings": "Storten naar tegoed van eigenaar",
    "dialog/preprocess-title/deposittoowner":
      "Storten naar tegoed van eigenaar",
    "dialog/deposittoowner-info":
      "Het bedrag wordt toegevoegd aan het tegoed van de eigenaar.",
    "menuitem-deposit-to-agency-savings": "Storten naar tegoed van :agency",
    "dialog/preprocess-title/deposittoagency":
      "Storten naar tegoed van :agency",
    "dialog/deposittoagency-info":
      "Het bedrag wordt toegevoegd aan het tegoed van :agency",

    // CHARGE SECTION
    // Charge section component
    // This component is used to present the details for charge, create new charge or select existing charge in the following pages:
    // Payment Create,
    // Payment Update,
    // Payment Link,
    // Charge Create,
    // Charge Update,
    // Charge Settle,
    // BankTransaction
    // Invoice Create
    // Invoice Update
    "section/charge-title": "Nota", // Use for charge details section, also for createNew/selectExisting charge section.
    "section/invoice-title": "Factuur", // Use for invoice details section, also for createNew/selectExisting charge section.
    "section/charge-status/lefttopay": "nog te betalen",
    "section/charge-status/paid": "Betaald",
    "section/charge-status/unpaid": "Onbetaald",
    "section/charge-status/partiallypaid": "Deels betaald",
    "section/charge-field/class-label": "We gaan",
    "section/charge-field/classreceivable-label": "Ontvangen",
    "section/charge-field/classreceivableexplanation-label":
      "inkomsten voor eigenaar, of :agencyName",
    "section/charge-field/classpayable-label": "Betalen",
    "section/charge-field/classpayableexplanation-label":
      "uitgave voor eigenaar, of :agencyName",
    "section/charge-field/аmount-label": "Bedrag",
    "section/charge-field/from-label": "Van",
    "section/charge-field/to-label": "Naar",
    "section/charge-field/for-label": "Betreft",
    "section/charge-field/invoicedate-label": "Factuurdatum",
    "section/charge-field/invoicenumber-label": "Factuurnummer",
    "section/charge-field/invoiceperiod-label": "Betreft periode",
    "section/charge-field/vat-label": "BTW",
    "section/charge-field/currency-label": "Valuta",
    "section/charge-field/type-label": "Type",
    "section/charge-field/person-label": "Persoon",
    "section/charge-field/company-label": "Organisatie",
    "section/charge-field/forperiod-label":
      "Deze nota opnemen in afrekening voor",
    "section/charge-field/description-label": "Beschrijving",
    "section/charge-radiobutton/newcharge": "Nota maken", // Use for createNew/selectExisting charge section.
    "section/charge-radiobutton/existingcharge": "Zoek nota", // Use for createNew/selectExisting charge section.
    "section/charge-radiobutton/nocharge": "Nota onbekend", // Use for createNew/selectExisting charge section.
    "section/charge-tab/nocharge-hint/nochargeexplanation":
      "De nota for deze betaling is nog niet bekend",
    "section/charge-tab/nocharge-hint/dummyexplanation":
      "Wordt deze betaling niet gekoppeld aan een betaling? :link",
    "section/charge-tab/nocharge-link/considerused":
      "Beschouw deze betaling als verwerkt",
    "section/charge-checkbox/paidcharges": "Inclusief betaalde nota's", // Use for select existing charge section.
    "section/charge-tab/existing-info/chargesnotfound": "Geen nota's gevonden.", // Use for select existing charge section, when list of charges is empty
    "section/charge-tab/existing-switch/listswitcher-label":
      "Automatisch nota’s vinden",
    "section/charge-info/islocked": "This charge is locked", // Use for charge details section
    "section/charge-info/isremoved": "Deze nota is verwijderd.", // Use for charge details section
    "section/charge-info/chargetosettle": "Verreken met deze nota", // Information text for user on settle charge page, that this charge is used to settle, use for charge details section.
    "section/charge-info/invoicetosettle": "Verreken met deze factuur", // Information text for user on settle charge page, that this invoice is used to settle, use for charge details section.
    "section/charge-info/cannottselectchargepaymentfullyused":
      "Deze nota kan niet worden betaald met deze betaling. De betaling is al volledig gebruikt.",
    "section/charge-info/cannottselectchargemaxchargenumberselected":
      "Er kunnen maximaal :number nota’s in een keer aan een betaling worden gekoppeld.",
    "section/charge-info/cannotpaychargeswithdifferentclasses":
      "Een betaling maken voor de geselecteerde nota’s lukt niet. Er zijn zowel te betalen als te ontvangen nota’s geselecteerd. Selecteer alleen te betalen of te ontvangen nota’s. en probeer het dan opnieuw.",
    "section/charge-label/invoicereceivedfrom": "Factuur ontvangen van",
    "section/invoice-label/amount": "Totaal bedrag",
    "section/invoice-field/vat-label": "BTW bedrag",
    "section/invoice-field/vatpercentage-label": "BTW percentage",
    "section/charge-for-hint":
      "Voor wat of wie betalen of ontvangen we het bedrag?",

    //Settle With Savings Check Scenario Translation
    it_is_not_possible_to_make_savings_action:
      "Het bedrag kan niet worden verrekend met een tegoed.",
    deposit_to_owner: "Verreken :savingsAmount met het tegoed van owner",
    withdrawal_from_owner: "Verreken :savingsAmount met het tegoed van owner",
    deposit_to_agency:
      "Het bedrag wordt toegevoegd aan het tegoed van :agency.",
    withdrawal_from_agency:
      "Het bedrag wordt opgenomen uit het tegoed van :agency.",
    choose_saving_account_for_withdraw:
      "Selecteer de tegoed rekening om van op te nemen.",
    choose_saving_account_for_deposit:
      "Selecteer de tegoed rekening om naartoe te storten.",
    "label-choise-saving-account-owner": "Eigenaar",
    "label-choise-saving-account-agency": "Kantoor",

    // PAYMENT SECTION
    // Payment section component
    // This component is used to present the details for payment, create new payment or select existing payment in the following pages:
    // Charge Update,
    // Payment Create,
    // Payment Update,
    // Peyment Settle,
    // Payment Link,
    // Charge Link,
    // BankTransaction
    //
    "section/payment-title": "Betaling", // Use for payment details section, also for createNew/selectExisting payment section.
    "section/payment-status/unused": "Ongebruikt", // Use for payment details section or for select existing payment section(in table row with payment).
    "section/payment-field/person-label": "Persoon",
    "section/payment-field/company-label": "Organisatie",
    "section/payment-field/аmount-label": "Bedrag",
    "section/payment-field/currency-label": "Valuta",
    "section/payment-field/date-label": "Datum",
    "section/payment-field/bankaccount-label": "Bankrekening",
    "section/payment-field/counterpartyiban-label": "Bankrekening tegenpartij",
    "section/payment-sub/banktransaction-title/banktransaction":
      "Bank transactie", //use for BankTransaction page.
    "section/payment-sub/banktransaction-field/bankaccount-label":
      "Bankrekening", //use for BankTransaction page.
    "section/payment-sub/banktransaction-field/counterparty-label": "Naam", //use for BankTransaction page.
    "section/payment-sub/banktransaction-field/description-label":
      "Beschrijving", //use for BankTransaction page.
    "section/payment-sub/banktransaction-field/transaction-details-label":
      "Transactie details", //use for BankTransaction page.
    "section/payment-radiobutton/existingpayment": "Bestaande betaling", // Use for createNew/selectExisting payment section.
    "section/payment-radiobutton/newpayment": "Nieuwe betaling", // Use for createNew/selectExisting payment section.
    "section/payment-radiobutton/nopayment": "Betaling nog niet bekend", // Use for createNew/selectExisting payment section.
    "section/payment-tab/existing-switch/listswitcher-label":
      "Automatisch betalingen vinden",
    "section/payment-info/islocked":
      "Deze betaling kan niet worden gewijzigd omdat hij is opgenomen in een financieel verslag", // Use for payment details section.
    "section/payment-info/isremoved": "Deze betaling is verwijderd", // Use for payment details section.
    "section/payment-info/paymenttosettle": "Verreken met deze betaling", // Information text for user on settle payment page, that this payment is used to settle, use for payment details section.
    "section/payment-hint/companyperson":
      "Selecteer de persoon of organisatie die de betaling heeft gedaan",
    "section/payment-info/selectorcreatecounterparty":
      "Deze tegenpartij werd niet gevonden. Klik 'Selecteren' en selecteer de juiste tegenpartij",
    "section/payment-button/create": "Nieuw",
    "section/payment-button/select": "Selecteren",
    "section/payment-field/forperiod-label": "Periode afrekening",
    "section/chapaymentrge-field/class-label": "We",
    "section/payment-field/classreceived-label": "Ontvangen",
    "section/payment-field/classpaid-label": "Betaald",
    "section/payment-info/cannottselectpaymentchargefullypaid":
      "Deze betaling kan niet worden gekoppeld met deze nota. De nota is al volledig betaald.",
    "section/payment-info/cannottselectpaymentmaxpaymentnumberselected":
      "Er kunnen maximaal :number betalingen in een keer aan een nota worden gekoppeld.",

    // CHARGES

    // Charge create page
    // Page to create a new charge object
    //
    "page/chargecreate-title": "Nieuwe nota",
    "page/invoicecreate-title": "Nieuwe factuur",
    "page/chargecreate-field/invoiceswitch-label": "Factuur",
    "page/payables": "Te betalen",
    "page/receivables": "Te ontvangen",
    // Charge update page
    // Page to update the details for an existing charge
    //
    "page/chargeupdate-title": "Nota",
    "page/invoiceupdate-title": "Factuur",
    "page/chargeupdate-section/payment-button/anotherpayment":
      "Betaling toevoegen",
    "page/chargeupdate-section/payment-title": "Betalingen",
    "page/chargeupdate-section/payment-button/addpayment":
      "Toevoegen nieuw betalingen",
    "page/chargeupdate-dialog/warning-title/chargeisfullypaid":
      "De nota is reeds volledig betaald",
    "page/chargeupdate-dialog/warning-title/invoiceisfullypaid":
      "Factuur is volledig betaald",
    "page/chargeupdate-dialog/warning-info/chargeisfullypaid":
      "Aan deze nota kan geen betaling meer worden toegevoegd. De nota is reeds volledig betaald.", // When the user clicks the button 'Add another payment', but charge is fully paid.
    "page/chargeupdate-dialog/warning-info/invoiceisfullypaid":
      "Aan deze factuur kan geen betaling meer worden toegevoegd. De factuur is reeds volledig betaald.", // When the user clicks the button 'Add another payment', but invoice is fully paid.
    "page/chargeupdate-dialog/preprocess-info/unlinkpayment":
      "De betaling wordt ontkoppeld van de nota. Doorgaan?", //User chooses to unlink a payment
    "page/chargeupdate-dialog/preprocess-info/removepayment":
      "De betaling wordt verwijderd. Doorgaan?", //User chooses to remove a payment
    "page/chargeupdate-section/charge-info/specialcreatedsettlecharge":
      "Alleen lezen. Deze nota is gemaakt voor het verrekenen van 2 betalingen en kan daarom niet worden gewijzigd.", // Additional user information that cannot be modified charge details , use for special charge with type settlement, when user settle two paymnets.
    "page/chargeupdate-section/charge-info/cantupdatesettlecharge":
      "Alleen lezen. Deze nota werd verrekend met een andere nota en kan daarom niet meer worden gewijzigd", // Additional user information that cannot be modified charge details , use for charges which were settled.
    "page/chargeupdate-preprocess/considerpay-title":
      "Beschouw deze nota als betaald",
    "page/chargeupdate-preprocess/considerpay-info":
      "Wat is de reden om deze nota als betaald te beschouwen?",
    "page/chargeupdate-preprocess/considerpay-reason/label": "Reden",
    "page/chargeupdate-preprocess/considerpay-dummydescription":
      "Betaling details onbekend.",
    "page/chargeupdate-section/charge-info/specialcreatedsavingscharge":
      "De nota details kunnen niet worden gewijzigd omdat de nota is vastgelegd in verband met het tegoed.",
    "page/chargeupdate-preprocess/paythischarge-title":
      "Verwerken betaling voor deze nota",
    "page/chargeupdate-preprocess/unrefund-title":
      "Terugbetaling ongedaan maken",
    "page/chargeupdate-preprocess/unrefund-info":
      "Klik Maak ongedaan om de terugbetaal nota te verwijderen",
    "page/chargeupdate-preprocess/unrefund-button": "Verwijderen",
    "page/chargeupdate-preprocess/undo-credit-title": "Creditering verwijderen",
    "page/chargeupdate-preprocess/undo-credit-info":
      "Klik Verwijderen om de credit nota te verwijderen en de creditering ongedaan te maken.",
    "page/chargeupdate-preprocess/undo-credit-button": "Verwijderen",
    "page/chargeupdate-preprocess/undo-withdrawal-title":
      "Opname ongedaan maken",
    "page/chargeupdate-preprocess/undo-withdrawal-info":
      "Klik Doorgaan om deze opname uit het tegoed ongedaan te maken",
    "page/chargeupdate-preprocess/undo-withdrawal-button": "Doorgaan",
    "page/chargeupdate-preprocess/undo-deposit-title":
      "Storting ongedaan maken",
    "page/chargeupdate-preprocess/undo-deposit-info":
      "Klik Doorgaan om deze storting in het tegoed ongedaan te maken",
    "page/chargeupdate-label/paidby": "betaald met",
    "page/chargeupdate-label/settledwith": "verrekend met",
    "page/chargeupdate-hint/chargehasnotmatchingpayments":
      "Vind en selecteer de bijbehorende betaling en klik Bewaren. Of verwerk een betaling voor deze nota.",
    "page/chargeupdate-hint/chargehasmatchingpayments":
      "Selecteer de bijbehorende betaling en klik Doorgaan. Of klik de schakelaar en vind zelf de bijbehorende betaling. Of maak een nieuw betaling.",

    // Charge settlement page
    // Page to settle a charge with a another charge which is to be selected by the user
    //
    "page/chargesettle-title": "Nota verrekenen",
    "page/chargesettle-dialog/attention-info/selectcharge":
      "Selecteer nota in deze lijst",
    "page/chargesettle-dialog/warning-info/notpossibilitychangeamount":
      "Het bedrag van de nota kan niet worden gewijzigd",

    // Charge settlement dialogs
    // Dialogs used for preprocess and postprocess of the charge settlement process
    //
    "dialog/preprocess-title/settlecharge": "Nota verrekenen",
    "dialog/preprocess-info/сontinuebuttondescription":
      "Klik 'Doorgaan' om nota :chargeToSettle te verrekenen met nota :chargeSelected",
    "dialog/postprocess-title/paymentcreate": "Betaling gemaakt",
    "dialog/postprocess-info/paymentwascreated": "De nota's zijn verrekend",

    // Pay charge page
    // Page to allow a user to link a charge with a payment to be selected by the user
    //
    "page/paycharge-title": "Betalen nota",
    "page/payinvoice-title": "Betalen factuur",
    "page/paycharge-button/pay": "Betalen",

    // Extra charge dialog
    // Dialog used when we link payment with charge and amount of payment more than amount of charge (amountPayment > amountCharge)
    // This dialog is in the following pages:
    //   ChargeUpdate
    //   ChargeCreate
    //   PaymentUpdate
    //   ChargeLink
    //
    "dialog/extracharge-title": "Extra nota",
    "dialog/extracharge-button/createextracharge": "Betaling toevoegen",
    "dialog/extracharge-button/settlethedifference": "Nota verrekenen",
    "dialog/extracharge-info/buttonskip":
      "Klik 'Overslaan' om de nota later verder te verwerken.",
    "dialog/extracharge-info-1":
      "Slechts :chargeAmount van de betaling :paymentAmount is gebruikt. Klik 'Nota toevoegen' om een volgende nota te betalen. Of klik 'Betaling verrekenen' om met een andere betaling te verrekenen.",
    "dialog/extracharge-info-2":
      "Klik 'Aanvullende nota' om een aanvullende nota te selecteren voor :additionalChargeAmount. Of klik 'Overslaan' om het bedrag later te gebruiken",
    "dialog/extracharge-info/chargeisfullypaid":
      "De nota is reeds volledig betaald",
    "dialog/settlewithsavings-info":
      "Het nota bedrag :chargeamount wordt opgenomen van de spaarrekening en in de afrekening verwerkt om zo de nota te verrekenen.",

    // Extra payment dialog
    // Dialog used when we link charge with payment and amount of charge more than amount of payment (amountCharge > amountPayment)
    // This dialog is used in the following pages:
    //   ChargeUpdate
    //   PaymentCreate
    //   PaymentUpdate
    //   PaymentLink
    "dialog/extrapayment-title": "Extra betaling",
    "dialog/extrapayment-info/createextrapayment":
      "Slechts :paymentAmount van :chargeAmount is betaald. Klik 'Betaling toevoegen' om het ontbrekende bedrag mee te betalen. Of klik 'Nota verrekenen' om het restant met een andere nota te verrekenen.",
    "dialog/extrapayment-info/buttoncreateextrapayment":
      "Klik 'Aanvullende betaling' om een aanvullende betaling voor deze nota te registreren.",
    "dialog/extrapayment-info/buttonskip":
      "Klik 'Overslaan' om de nota later verder te verwerken.",
    "dialog/extrapayment-button/createextrapayment": " Betaling toevoegen",
    "dialog/extrapayment-button/settlethedifference": "Nota verrekenen",

    // PAYMENTS

    // payment create page
    // Page to allow a user to create a new payment
    //
    "page/paymentcreate-title": "Nieuwe betaling",

    // Payment update page
    // Page to allow a user to update the details for a payment
    //
    "page/paymentupdate-title": "Betaling",
    "page/paymentupdate-section/charge-title": "Nota's",
    "page/paymentupdate-section/charge-info/chargesnotfound":
      "Geen nota's gevonden",
    "page/paymentupdate-dialog/warning-title/fullyused":
      "Betaling volledig gebruikt",
    "page/paymentupdate-dialog/warning-info/fullyused":
      "Het bedrag van deze betaling is reeds volledig gebruikt om nota's mee te betalen. Er is geen ruimte meer om nog een andere nota mee te betalen.",
    "page/paymentupdate-dialog/preprocess-info/chargewillbeunlinked":
      "De koppeling van nota en betaling wordt verbroken. Hierna is de nota weer - deels - onbetaald, en de betaling weer beschikbaar voor een andere nota. Doorgaan?",
    "page/paymentupdate-link/updatestatementperiod": "Wijzigen",
    "page/paymentupdate-dialog/updatestatementperiod-title":
      "Selecteer de afrekening periode",
    "page/paymentupdate-dialog/updatestatementperiod-hint":
      "Selecteer de periode waarin de betaling moet worden opgenomen",
    "page/chargeupdate-dialog/updatestatementperiod-hint":
      "Selecteer de periode waarin de nota moet worden opgenomen",
    "page/paymentupdate-section/payment-info/specialcreatedsettlepayment":
      "Deze betaling werd gemaakt om twee nota’s te verrekenen", // Additional user information that cannot be modified payment details , use for special payment with type settlement, when user settle two charges.
    "page/paymentupdate-section/payment-info/cantupdatesettlepayment":
      "Deze betaling werd verrekend met een andere betaling", // Additional user information that cannot be modified payment details , use for payments which were settled.
    "page/paymentupdate-preprocess/considerused-title":
      "Beschouw deze betaling als verwerkt",
    "page/paymentupdate-preprocess/considerused-info":
      "Reden om deze betaling als verwerkt te beschouwen?",
    "page/paymentupdate-preprocess/considerused-reason/label": "Reden",
    "page/paymentupdate-preprocess/considerused-dummydescription":
      "Skipped transaction",
    "page/paymentupdate-preprocess/considerfullyused-info":
      "Deze betaling wordt beschouwd als volledig gebruikt. Voor dat doel wordt voor het resterende bedrag een nota gemaakt en aan deze betaling gekoppeld.",
    "page/paymentupdate-preprocess/agencycosts-info":
      "Deze betaling wordt verwerkt als kosten voor :agencyName. Hiervoor wordt een inkoopnota gemaakt en aan de betaling gekoppeld.",
    "page/paymentupdate-postprocess/agencycosts-info":
      "Een inkoopnota gemaakt en aan de betaling gekoppeld.",
    "page/paymentupdate-preprocess/agencycosts-title":
      "Verwerk als kosten voor :agencyName",
    "page/paymentupdate-preprocess/agencycosts-hint":
      "De naam in de betaling is: :paymentName",
    "page/paymentupdate-preprocess/agencyfeecharge-info":
      "Deze betaling wordt gekoppeld aan onbetaalde courtage nota’s, de oudste eerst. Doorgaan?",
    "page/paymentupdate-postprocess/agencyfeecharge-linked-info":
      "Met deze betaling zijn :count nota's betaald.",
    "page/paymentupdate-postprocess/agencyfeecharge-max-linked-info":
      "Het maximum van 5 nota's zijn betaald. Probeer opnieuw om meer courtage nota's te betalen.",
    "page/paymentupdate-preprocess/incomeforagency-info":
      "Het ontvangen bedrag wordt toegevoegd aan :agencyname's tegoed. Het tegoed wordt gebruikt om kosten mee te verrekenen, of kan later worden overgemaakt naar :agencyname's bankrekening.",
    "page/paymentupdate-section/payment-info/specialcreatedsavingspayment":
      "Deze betaling is gemaakt om een nota te verrekenen met het tegoed", // Additional user information that cannot be modified payment details , use for special payment with type savings, when user registered payments for the savings account.
    "page/paymentupdate-preprocess/considerprocess-description":
      "Nota onbekend",
    "page/paymentupdate-preprocess/refund-title": "Terugbetaling",
    "page/paymentupdate-preprocess/refund-info":
      "Kik Terugbetalen om een terugbetaal nota te maken",
    "page/paymentupdate-preprocess/refund-button": "Terugbetalen",
    "page/paymentupdate-label/paidfor": "betaald voor",
    "page/paymentupdate-label/settledwith": "verrekend met",
    "page/paymentchargeupdate-label/relatedto": "gerelateerd aan",
    "page/paymentupdate-hint/transactionautomaticallylinked":
      "Casadesk koppelde automatisch deze nota('s) aan deze betaling. Correct? Klik dan Gecontroleerd. Niet correct? Ontkoppel dan de nota('s) en koppel zelf de juiste nota('s).",
    "page/paymentupdate-hint/paymenthasnotmatchingcharges":
      "Zoek en selecteer de bijbehorende nota, en klik Bewaren. Of maak een nieuwe nota op basis van deze betaling.",
    "page/paymentupdate-hint/paymenthasmatchingcharges":
      "Selecteer de nota('s) voor deze betaling en klik Bewaren. Of klik de schakelaar en vind zelf de bijbehorende nota('s). Of maak de nota voor deze betaling.",
    "page/paymentupdate/question1":
      "De nota hieronder werd automatisch gekoppeld met deze betaling. Is het de juiste nota voor deze betaling?",
    "page/paymentupdate/tab/select-charge": "Selecteer nota",
    "page/paymentupdate/tab/find-charge": "Vind nota",
    "page/paymentupdate/tab/new-charge": "Nieuwe nota",
    "page/paymentupdate/tab/select-charge/panel-title":
      "Selecteer de nota('s) voor deze betaling en klik Bewaren",
    "page/paymentupdate/tab/find-charge/panel-title":
      "Vind en selecteer de nota('s) voor deze betaling en klik Bewaren",

    // Payment settlement page
    // Page to allow a user to settle the payment with a payment which the user needs to select
    //
    "page/paymentsettle-title": "Betaling verrekenen",
    "page/paymentsettle-dialog/warning-info/notpossibilitychangeamount":
      "Het bedrag van de betaling kan niet worden gewijzigd",
    "page/paymentsettle-dialog/warning-info/cannotsettlewithequaltypes":
      "Verrekenen is niet mogelijk indien de betaling en nota beide 'te betalen' of 'te ontvangen' zijn.",
    "page/paymentsettle-dialog/warning-info/selectpayment":
      "Kies een bestaande betaling of maak een nieuwe",

    // Payment settlement dialogs
    // Dialogs used for preprocess and postprocess of the payment settlement process
    //
    "dialog/preprocess-title/paymentsettle": "Betaling verrekenen", // Use for dialog on page payment settle and for payment list.
    "dialog/preprocess-info/settlepayment":
      "Klik 'Doorgaan' om :paymentToSettle met :paymentSelected te verrekenen",
    "dialog/postprocess-title/chargecreated": "Nota vastgelegd",
    "dialog/postprocess-info/chargecreated":
      "Er is een speciale verrekening-nota gemaakt voor het verrekenen van betaling :paymentToSettle met betaling :paymentSelected",

    // Payment link/use page
    // Page to allow a user to link a payment (and thus pay) a charge
    //
    "page/paymentlink-title/additionalcharge": "Volgende nota voor betaling", // Title when only a remaining amount is available as the payment was already used before
    "page/paymentlink-title/usepayment":
      "Betaling gebruiken om nota te betalen", // Title when the full amount of the payment is still available
    "page/paymentlink-section/charge-title/additionalcharge":
      "Selecteer een volgende nota",

    // Bank Account dialog
    // Dialog used when we want choose bank account for payment or add new bank account to payment.
    //
    "dialog/bankaccount-title": "Bankrekening",
    "dialog/bankaccount-field/number-label": "Bankrekening",
    "dialog/bankaccount-field/name-label": "Tenaamstelling bankrekening",
    "dialog/bankaccount-field/label-label": "Naam",
    "dialog/bankaccount-checkbox/default": "Standaard",

    // Task create/update dialogs
    // Dialogs used for preprocess and postprocess of task create/update processes
    //
    "preprocess/taskcreate-hint":
      "De nieuwe taak wordt bewaard en een email met de details van de taak wordt gezonden aan de uitvoerder.",
    "postprocess/taskcreate-hint":
      "De nieuwe taak is vastgelegd maar de email met de details is niet verzonden omdat het email adres van de uitvoerder niet bekend is. ",
    "preprocess/taskupdate-hint":
      "De taak wordt bewaard en een email met de details van de taak wordt gezonden aan de uitvoerder.",
    "postprocess/taskupdate-hint":
      "De taak is bewaard maar de email met de details is niet verzonden omdat het email adres van de uitvoerder niet bekend is.",

    // Task update page
    "page/taskupdate-hint/taskforproperty": "Betreft Locatie: ",
    "page/taskupdate-hint/taskforunit": "Betreft Verhuurobject: ",
    "page/taskupdate-hint/object": "Betreft: ",
    "page/taskupdate-hint/taskforcharge": "Betreft Nota: ",
    "page/taskupdate-link/sendinvoice": "Stuur per email",
    "page/taskupdate-hint/taskfor": ":entity",

    // Conversation update page
    "page/conversationupdate-hint/relatedto": "Betreft :entity: ",

    // Note update page
    "page/noteupdate-hint/notefor": "Notitie voor :entity: ",

    //Timelime component
    "tab/tasks-by/label": "Door",
    "tab/tasks-for/label": "voor",
    "tab/tasks-duedate/label": "te doen",

    // Unit list
    "page/unitlist-tooltip/taskicon-overdueunfinished":
      "Taken: :unfinished onvoltooid(:overdue te laat)",
    "page/unitlist-tooltip/taskicon-unfinished":
      "Taken: :unfinished onvoltooid",
    "page/unitlist-unit-info/templateupdatedate": "huur aangepast :date",

    // Launchpanel
    "launchpanel-link/register-an-incoming-invoice":
      "Verwerk een inkomende factuur",
    "launchpanel-link/create-a-new-task": "Nieuwe taak",
    "launchpanel-title": "DOE NU",
    "launchpanel-link/send-statements": "Verzend afrekeningen naar eigenaars",
    "launchpanel-link/withdrawal-agency-savings": "Opname uit tegoed",
    "launchpanel-link/createnewunit": "Nieuw huurobject",
    "launchpanel-link/createnewproperty": "Nieuw locatie",
    "launchpanel-link/createnewcontract": "Nieuw contract",
    "launchpanel-charge-title": "KIES EEN ACTIE VOOR DEZE NOTA",
    "launchpanel-payment-title": "KIES ACTIE VOOR DEZE BETALING",
    "launchpanel-contract-title": "KIES EEN ACTIE VOOR DIT CONTRACT",
    "launchpanel-unit-title": "KIES EEN ACTIE VOOR DIT HUUROBJECT",
    "launchpanel-property-title": "KIES EEN ACTIE VOOR DEZE ADRES",
    "launchpanel-person-title": "KIES EEN ACTIE VOOR DEZE CONTACTPERSOON",
    "launchpanel-person-task": "KIES EEN ACTIE VOOR DE TAAK",
    "launchpanel-company-title": "KIES EEN ACTIE VOOR DEZE ORGANISATIE",
    "launchpanel-conversation-title": "ACTIES VOOR DEZE CONVERSATIE",
    "launchpanel-link/newrealestate": "Nieuw vastgoed",
    "launch-panel-send-tenant-portal-link": "Stuur portal link naar huurder",
    "launch-panel-create-incident": "Nieuwe taak",
    "launchpanel-agreement-title": "KIES EEN ACTIE VOOR DEZE OVEREENKOMST",
    "launchpanel-hint/deletecompany": "De organisatie definitief verwijderen",
    "launchpanel-link/addcontactforcompany": "Contactpersoon toevoegen",
    "launchpanel-hint/addcontactforcompany":
      "Een contactpersoon toevoegen aan deze organisatie",
    "launchpanel-link/addpropertyforcompany": "Huurobject toevoegen",
    "launchpanel-hint/addpropertyforcompany":
      "Een huurobject toevoegen waarvoor deze organisatie de verhuurder is",
    "launchpanel/unit-option/createchargetemplate": "Nieuw nota sjabloon",
    "launchpanel/unit-option/createchargetemplate-hint":
      "Maandelijks automatisch een nota maken voor dit huurobject, bijvoorbeeld voor de VVE bijdragen",
    "launchpanel/property-option/createunit": "Huurobject toevoegen",
    "launchpanel/property-option/createunit-hint":
      "Maak een huurobject en koppel die aan deze adres",
    "launchpanel/property-option/createchargetemplate": "Nieuwe nota sjabloon",
    "launchpanel/property-option/createchargetemplate-hint":
      "Laat maandelijks automatisch een nota maken voor deze locatie, bijvoorbeeld voor de VVE bijdragen",
    "launchpanel/property-option/createcharge": "Maak een extra nota",

    "launchpanel/property-option/createcharge-hint": "Extra eenmalige kosten voor de eigenaar van deze adres, of juist een te ontvangen bedrag (een belastingteruggave bijvoorbeeld)",
    "launchpanel/download-csv-file": "Download nota’s als XLSX bestand (comma seperated values) om te gebruiken in - bijvoorbeeld - een spreadsheet applicatie",
    // Invoice update
    "page/invoiceupdate-link/sendinvoice": "Stuur per e-mail",
    "page/invoiceupdate-link/sendinvoice-hint":
      "Stuur een kopie van deze nota per e-mail naar wie jij wilt",
    "page/invoiceupdate-link/sendcontract-hint":
      "Stuur de details van dit contract per e-mai",
    "page/invoiceupdate-dialog/sendinvoice-title":
      "Verzend deze factuur per email",
    "page/invoiceupdate-dialog/sendinvoice-field/to-label": "Aan",
    "page/invoiceupdate-dialog/sendinvoice-field/message-label": "Bericht",

    // Property update page
    "page/propertyupdate-section/property-tab/details-field/contactinformationofassociation-label":
      "VVE contact instructies",

    // Property create page
    "page/propertycreate-field/contactinformationofassociation-label":
      "VVE contact instructies",
    "page/propertycreate-field/associationownerid-label": "VVE",

    /* Contract renew page */
    "page/renewcontract-dialog/calculateprice-field/oldamount-label":
      "Oud bedrag",
    "page/renewcontract-dialog/calculateprice-field/newamount-label":
      "Nieuw bedrag",
    "page/renewcontract-dialog/calculateprice-field/percentage-label":
      "Percentage",
    "page/renewcontract-dialog/calculateprice-title":
      "Aanpassen contract bedrag",
    "page/renewcontract-section/prices-icon/updatecontractprice-tip":
      "Aanpassen contract bedrag",
    "coach/renew-contract/first-title": "Contract",
    "coach/renew-contract/second-title": "Huurder",
    "coach/renew-contract/third-title": "Huur",
    "coach/renew-contract/fourth-title": "Startdatum",
    "coach/renew-contract-step/step1-title": "Het contract",
    "coach/renew-contract-step/step1-subtitle":
      "Het contract dat wordt vernieuwd",
    "coach/renew-contract-step/step2-title": "De huurder",
    "coach/renew-contract-step/step2-subtitle":
      "Vernieuw de huurder gegevens, of klik Volgende",
    "coach/renew-contract-step/step3-title": "De huur",
    "coach/renew-contract-step/step3-subtitle":
      "Vernieuw huurbedragen voor :unitShortDisplayName",
    "coach/renew-contract-step/step4-title": "Datums",
    "coach/renew-contract-step/step4-subtitle":
      "Bepaal de datums voor het vernieuwde contract voor :unitShortDisplayName",
    "coach/renew-contract-step/step5-hint": "Controleer en klik Afronden",
    "coach/renew-contract-step/step6-hint":
      "De nieuwe contract voorwaarden zijn vastgelegd.",
    "coach/renew-contract-step/new-person": "Nieuwe persoon",
    "coach/renew-contract-step/known-person": "Bekende persoon",

    //Stepper for new user
    "stepper/invitenewuser-step/first-title": "Welkom!",
    "stepper/invitenewuser-step/first-info":
      "Welkom bij Casadesk. De slimme keuze van vastgoedbeheerders voor het verzorgen van de financiële administratie en het operationeel beheer.",
    "stepper/invitenewuser-step/second-title": "Hoofdmenu",
    "stepper/invitenewuser-step/second-info":
      "Het hoofdmenu vind je links in iedere pagina. Kies een item en vind meer details over dat item.",
    "stepper/invitenewuser-step/third-title": "Zoeken",
    "stepper/invitenewuser-step/third-info":
      "Vind de algemene zoekfunctie bovenin iedere pagina. Start met het typen van een naam of adres en vind zo snel het object dat je zoekt.",

    // Send Email
    "page/sendemail-title/sendemail": "Stuur email",
    "page/sendemail-hint/objectdetails":
      "De verzonden email zal tevens wat meer informatie bevatten over: :object.",
    "page/sendemail-dialog/attention-info": "Nieuw email bericht annuleren?",
    "page/sendemail-message1/statement":
      "In de bijlage vindt u een afrekening. Een te ontvangen bedrag maken wij zo snel mogelijk aan u over. Een te betalen bedrag verzoeken wij u vriendelijk binnen 14 dagen aan ons over te maken.",
    "page/sendemail-message2/statement":
      "Mochten er in de afgelopen periode aanvullende kosten zijn gemaakt, dan vindt u kopieën van de facturen eveneens als bijlagen bij dit bericht.",
    "page/sendemail-message/invoice": "Hieronder meer informatie over de nota.",
    "page/sendemail-message/contract":
      "Hieronder meer informatie over de contract.",
    "page/sendemail-message/payment": "Hieronder vind je de betaling gegevens.",
    "page/sendemail-message/task":
      "Vind hieronder meer gegevens over de taak. De contactgegevens van de bewoner zijn:",
    "page/sendemail-message/chargeunpaid":
      "De vervaldatum van een nota is gepasseerd. We stellen een spoedige betaling op prijs.",
    "page/sendemail-message/chargepartlypaid":
      "Een nota is nog niet - volledig - betaald. We stellen een spoedige betaling op prijs.",
    "page/sendemail-message/hello": "Beste",
    "page/sendemail-message/dear": "Beste",
    "page/sendemail-message1/collectiveinvoice":
      "Als bijlage bij dit bericht vind je de details voor de eerste betaling voor de huur van :unitDisplayName.",
    "page/sendemail-message2/collectiveinvoice":
      "We verwachten betaling uiterlijk op of voor :chargeDueDate.",
    "page/sendemail-message3/collectiveinvoice": "Vriendelijke groet,",
    "page/sendemail-message1/lastcollectiveinvoice":
      "Als bijlage de eindafrekening in verband met de huur van :unitDisplayName.",
    "page/sendemail-message/requeststatementsreview":
      "De link hieronder leidt naar de lijst met afrekeningen die gereed zijn voor beoordeling.\n\nKlik de PDF link in de lijst en beoordeel de afrekening.\n\nZet de afrekening op ‘Klaar voor verzenden’, zodra de afrekening daarvoor gereed is.\n\nhttps://:domain/app/dashboard/statements",
    "page/sendemail-message/tenant-login-portal-link":
      "Klik de knop hieronder en open de huurder portaal van :agencyName",
    "page/sendemail-link/updatedefaulttext":
      "Update de standaard tekst voor deze email",
    "page/sendemail-label/sendcopytoemails": "Stuur kopie bijlage(n) naar",
    "page/sendemail-message/sendcopytomessage": "Zie bijlagen.",
    "page/sendemail-label/sendcopyto": "Stuur kopie bijlage(n) naar",
    "page/sendemail-message/message-beginning":
      "In overeenstemming met de contract voorwaarden en overheidsbesluiten wijzigt de huur met ingang van :newContractStartDate voor :unitDisplayName.",
    "page/sendemail-message/rent-until":
      "Het huurbedrag tot :oldContractEndDate:",
    "page/sendemail-message/rent-after":
      "Het huurbedrag met ingang van :newContractStartDate:",
    "page/sendemail-message/message-ending": "Zie ook de bijlage.",
    "page/sendemail-message/renewed-contract":
      "Binnenkort voeren wij een huurwijziging door. Door de huurwijziging kan ook de beheervergoeding wijzigen. Hieronder vind je de details.\n\nDit bericht is ter informatie, er is geen actie nodig. Heb je vragen? Neem dan gerust contact met ons op, of stuur een antwoord op dit bericht.",
    "page/sendemail-message3/renewed-contract": "Met vriendelijke groet,",
    "page/sendemail-message/agreement-until":
      "De beheervergoeding tot :oldContractEndDate:",
    "page/sendemail-message/agreement-after":
      "De beheervergoeding met ingang van :newContractStartDate:",

    // Dashboard
    "page/dashboard-tab/notifications": "Notificaties",
    "page/dashboard-tab/receivables": "Te ontvangen",
    "page/dashboard-tab/payables": "Te betalen",
    "page/dashboard-tab/activities": "Activiteiten",
    "page/dashboard-tab/notes": "Notities",
    "title-no-notifications-to-list": "No notifications found",
    "title-no-activities-to-list": "Geen activiteiten gevonden",
    "title-no-contracts-to-list": "Geen contracten gevonden",
    "title-no-tasks-to-list": "Geen taken gevonden",
    "title-no-notes-to-list": "No notities found",
    "page/dashboard-tab/activities-dialog/noactivitytemplates-1":
      "Een nieuwe activiteit maken is niet mogelijk. Voor een nieuwe activiteit is een activiteit sjabloon nodig, en er zijn geen activiteit sjablonen beschikbaar op dit moment.",
    "page/dashboard-tab/activities-dialog/noactivitytemplates-2":
      "Ga naar Instellingen om een activiteit sjabloon te maken (alleen beschikbaar voor een administrator).",
    "page/dashboard-tab/activities-section/tableofactivities-label/closedtasks":
      "Taken afgerond",
    "page/dashboard-tab/unpaid-section/charge-info/chargesnotfound":
      "Geen nota's gevonden",
    "page/dashboard-tab/payments": "Betalingen",
    "page/dashboard-tab/messages": "Berichten",
    "page/dashboard-tab/statements-button/requeststatementsreview":
      "Verzoek beoordeling afrekeningen",
    "page/dashboard-tab/start-section/statistic-button/newrentalunit":
      "Nieuw huurobject",
    "page/dashboard-tab/start-section/statistic-label/registred":
      "GEREGISTREERD",
    "page/dashboard-tab/start-section/statistic-label/clickbutton":
      "Klik en registreer een",
    "page/dashboard-tab/start-section/statistic-info/includingpropertyandowner":
      "Inclusief locatie en eigenaar details",
    "page/dashboard-tab/start-section/statistic-info2/unitrental":
      "Nieuwe eigenaar + objecten",
    "page/dashboard-tab/start-section/statistic-info1/unitrental":
      "Klik en registreer een nieuwe eigenaar en huurobjecten",
    "page/dashboard-tab/start-section/statistic-button/newunit":
      "Nieuw huurobject",
    "page/dashboard-tab/start-section/statistic-info1/unit":
      "Een huurobject is een:",
    "page/dashboard-tab/start-section/statistic-info2/unit":
      "zelfstandige woonruimte of commercieel huurobject",
    "page/dashboard-tab/start-section/statistic-info3/unit":
      "onzelfstandige woonruimte met gedeelde faciliteiten",
    "page/dashboard-tab/start-section/statistic-info1/property":
      "Een adres is gebruikelijk 1 met:",
    "page/dashboard-tab/start-section/statistic-info2/property":
      "één zelfstandige woonruimte of",
    "page/dashboard-tab/start-section/statistic-info3/property":
      "meerdere kamers en/of studio’s, afzonderlijk verhuurd",
    "page/dashboard-tab/start-section/statistic-button/newproperty":
      "Nieuwe adres",
    "page/dashboard-tab/start-section/statistic-button/newlandlord":
      "Nieuwe eigenaar",
    "page/dashboard-tab/start-section/statistic-info1/landlord":
      "De contactpersoon voor een huurobject is de eigenaar. De eigenaar kan tevens de eigenaar zijn, of de beheerder van het object.",

    "page/dashboard-tab/start-section/statistic-button/newrentalcontract":
      "Nieuw huurcontract",
    "page/dashboard-tab/start-section/statistic-info/includingtenantandoccupant":
      "Inclusief huurder en bewoner details",
    "page/dashboard-tab/start-section/statistic-info1/contract":
      "Een huurcontract is de overeenkomst tussen de huurder en de eigenaar. Het staat de huurder toe het huurobject te bewonen en/of te gebruiken.",
    "page/dashboard-tab/start-section/statistic-button/newcontract":
      "Nieuw huurcontract",
    "page/dashboard-tab/start-section/statistic-title/contract": "Huurcontract",
    "page/dashboard-tab/start-section/statistic-button/increaserent":
      "Huur aanpassen",
    "page/dashboard-tab/start-section/statistic-title/increaserent":
      "Huur aanpassen",
    "page/dashboard-tab/start-section/statistic-info1/increaserent":
      "Een huurverhoging doorvoeren, of andersinds de huur aanpassen, voor een bestaand contract.",
    "coach/increaserent-step/first-title": "Contract",
    "coach/increaserent-step/second-title": "Huur",
    "coach/increaserent-step2/title": "De nieuwe huurbedragen",
    "coach/increaserent-step2/subtitle":
      "De nieuwe huurbedragen voor :unitDisplayName",
    "coach/increaserent-step3/title": "Bepaal de eerste dag",
    "coach/increaserent-step3/subtitle":
      "Bepaal de eerste dag voor de nieuwe bedragen voor :unitDisplayName",
    "coach/increaserent-step3/date-hint":
      "Datum om de huur opnieuw op te beoordelen",
    "coach/increaserent-step/third-title": "Datum",
    "coach/increaserent-step/first-info1":
      "Selecteer het huurobject waarvoor de huur wordt aangepast",
    "coach/increaserent-step/second-info1":
      "Pas de bedragen aan voor het huurcontract",
    "coach/increaserent-step/third-info1":
      "Bepaal de datum voor de nieuwe bedragen en klik 'Afronden'",
    "coach/increaserent-step/step1-hint":
      "Selecteer het contract waarvoor een of meer bedragen worden gewijzigd",
    "coach/increaserent-step/step2-hint": "Wijzig huurbedragen",
    "coach/increaserent-step/step3-hint":
      "De nieuwe bedragen gelden met ingang van de startdatum",
    "coach/increaserent-step/step4-hint": "Controleer en klik Afronden",
    "coach/increaserent-step/step5-hint":
      "De nieuwe contract voorwaarden zijn vastgelegd.",
    "coach/increaserent-step/old-prices": "Oude bedragen",
    "coach/increaserent-step/new-prices": "Nieuwe bedragen",
    "coach/increaserent-step/start-date": "Start datum",
    "coach/increaserent-step/new-price": "Nieuw bedrag",
    "page/dashboard-tab/start-section/statistic-info1/tenant":
      "De huurder is partij in het huurcontract en kan zijn een:",
    "page/dashboard-tab/start-section/statistic-info2/tenant": "persoon of",
    "page/dashboard-tab/start-section/statistic-info3/tenant": "organisatie",
    "page/dashboard-tab/start-section/statistic-button/newtenant":
      "Nieuwe huurder",
    "increaserent-label": "Huur aanpassen",
    "page/dashboard-tab/start-section/statistic-info1/creditcharge":
      "Credit factuur",
    "page/dashboard-tab/start-section/statistic-info1/provideinvoice":
      "Inkomende factuur",
    "page/dashboard-tab/start-section/statistic-title/statements":
      "Afrekeningen",
    "page/dashboard-tab/start-section/statistic-info/statements":
      "Afrekeningen die gereed zijn om te beoordelen en verzenden.",
    "coach/creditcharge-info1":
      "Vind de nota waarvoor je een credit nota wilt maken",
    "coach/creditcharge-error": "Geen nota’s gevonden",
    "link-to-all-charges": "Naar alle nota’s",
    "link-to-all-payments": "Naar alle betalingen",
    "link-to-all-statements": "Naar alle afrekeningen",

    // Pay Unit Charges
    "page/payunitcharges-section/payment-hint":
      "Klik Afronden om de betaling van :amount vast te leggen en de geselecteerde nota’s te betalen.",

    // Activity details
    "page/activitydetails-dilalog/checkclosedstatus-info":
      "De activiteit wordt als voltooid genoteerd. Echter, nog niet alle taken in deze activiteit zijn voltooid. De activiteit toch voltooien?",
    "page/activitydetails-hint/opentasksnumber":
      "Controleer de taken voor deze activiteit ( open taken: :numberOfOpenTasks ) en Sluit deze activiteit wanneer alle taken zijn gedaan.",
    "page/activitydetails-dilalog/checkclosedstatus-button/close": "Voltooien",

    // Finance -> Charges
    "finance-charges-filter/date-label/chargesbefore": "Nota's tot datum",

    // Finance -> Invoices
    "finance-invoice-filter/date-label/fromdate": "Vanaf datum",

    // Finance -> Payments
    "finance-payments-filter/date-label/paymentsbefore": "Betalingen tot datum",

    "charge-summary-title/receivable": "NOTA te ontvangen van",
    "charge-summary-title/payable": "NOTA te betalen aan",
    "chargetemplate-summary-title/receivable": "Nota sjabloon - te ontvangen",
    "chargetemplate-summary-title/payable": "Nota sjabloon - te betalen",
    "contractitem-summary-title/receivable": "Contract bedrag - te ontvangen",
    "contractitem-summary-title/payable": "Contract bedrag - te betalen",
    "defaultchargetemplate-summary-title/receivable":
      "Standaard contract bedrag - te ontvangen",
    "defaultchargetemplate-summary-title/payable":
      "Standaard contract bedrag - te betalen",
    "charge/payment-summary-title/savings": "tegoed",
    "charge-summary-details/period": "Periode:",
    "charge-summary-details/ownerstatement": "Afrekening:",
    "charge-summary-details/invoicenumber": "Factuurnummer",
    "charge-summary-details/credits": "Credit gerelateerde nota: ",
    "charge-summary-details/related": "Gerelateerde nota: ",
    "charge-summary-details/not-part-of-owner-statement":
      "Deze nota is geen onderdeel van een verhuurder afrekening",
    "charge-summary-class/receive": "te ontvangen",
    "charge-summary-class/pay": "betalen",
    "charge-summary-class/settled": "verrekend",
    "charge-summary-state/paid": "betaald",
    "charge-summary-state/received": "ontvangen",
    "charge-summary-state/unpaid": "onbetaald",
    "charge-summary-state/removed": "verwijderd",
    "charge-summary-state/remainingtoreceive": "nog te ontvangen:",
    "charge-summary-state/remainingtopay": "nog te betalen:",
    "charge-summary-state/status": "Status:",
    "charge-summary-readonly/wassettled":
      "Deze nota is verrekend met een andere nota",
    "charge-summary-readonly/settlement":
      "Deze nota werd gemaakt om twee betalingen te verrekenen",
    "charge-summary-readonly/payout":
      "Deze nota werd gemaakt voor een afrekening",
    "charge-summary-readonly/withsavings":
      "Deze nota is verrekend met het tegoed",
    "charge-summary-readonly/removed": "Deze nota is verwijderd",
    "charge-summary-readonly/refund":
      "Deze nota is onderdeel van een terugbetaling",
    "charge-summary-readonly/ispaiddirectlytoowner":
      "Deze nota werd rechtstreeks aan de eigenaar betaald",
    "charge-summary-readonly/isinvoice": "De nota is in een factuur verwerkt",
    "charge-summary-readonly/islocked":
      "Deze nota is onderdeel van een inmiddels afgesloten afrekening",
    "charge-summary-details/savings": "Gerelateerde nota: ",
    "charge-section/payment-action/findpayment": "Zoek betaling",
    "charge-section/payment-action/settlecherge": "Nota verrekenen",
    "payment-summary-title/receivable": "BETALING ontvangen van",
    "payment-summary-title/payable": "BETALING betaald aan",
    "payment-summary-class/received": "Ontvangen van",
    "payment-summary-class/paid": "betaald",
    "payment-summary-details/amount": "Bedrag",
    "payment-summary-details/type": "Type",
    "payment-summary-details/paidto": "Naar",
    "payment-summary-details/paidfrom": "Van",
    "payment-summary-details/unknown": "Onbekend",
    "payment-summary-details/description": "Beschrijving",
    "payment-summary-details/transactiondetails": "Transactie",
    "payment-summary-readonly/refund":
      "Deze betaling is onderdeel van een terugbetaling",
    "payment-summary-readonly/transaction":
      "Deze betaling werd gemaakt op basis van een MT940 bank transactie",
    "payment-summary-readonly/ponto":
      "Deze betaling werd gemaakt op basis van een Ponto",
    "payment-summary-state/used": "verwerkt",
    "payment-summary-state/unused": "ongebruikt",
    "payment-summary-state/part-unused": "ongebruikt",
    "payment-summary-state/removed": "verwijderd",
    "payment-summary-state/remainingtouse": "remaining to use:",
    "payment-summary-state/status": "Status:",

    // Readonly reasons

    "agreement-readonly/removed": "Deze overeenkomst is verwijderd",
    "agreement-readonly/signed":
      "Het contract is getekend; om te vernieuwen, stel de einddatum in en maak een nieuwe overeenkomst",
    "contract-readonly/removed": "Dit contract is verwijderd",
    "contract-readonly/signed":
      "Dit contract is getekend. Kies vernieuwen om gegevens in dit contract te wijzigen, een nieuwe bewoner bijvoorbeeld. Of verwijder dit contract als het fouten bevat, en maak een nieuw.",
    "property-readonly/removed": "Dit adres is verwijderd",
    "unit-readonly/removed": "Dit huurobject is verwijderd",
    "person-readonly/removed": "Dit contract is verwijderd",
    "company-readonly/removed": "Deze organisatie is verwijderd",

    // Conversations

    "label-conversation": "Conversatie",
    "label-new-conversation": "Nieuwe conversatie",
    "label-conversation-with": "Conversatie met :person",
    "title-messages": "Berichten",
    "label-unread": "Unread",
    "label-email-notification": "E-mail notificaties naar",
    "label-sms-notification": "Sms notificatie",
    "status-email-notification-failed": "Email niet afgeleverd!",
    "status-sms-notification-failed": "SMS niet afgeleverd!",
    "title-no-messages-to-list": "Geen open conversaties gevonden",
    "preprocess/createincidentfromconversation-hint":
      "Er wordt een nieuwe taak gemaakt en aan deze conversatie gekoppeld",
    "label-subject": "Onderwerp",

    // Unit spreadsheet
    "spreadsheet/unit-property": "Locatie",
    "spreadsheet/unit-type": "Type",
    "spreadsheet/unit-agreementservice": "Overeenkomst.Service",
    "spreadsheet/unit-defaultdeposit": "Standaard borg",
    "spreadsheet/unit-defaultbasicrent": "Standaard kale huur",
    "spreadsheet/unit-agreementagencyfee": "Overeenkomst.Courtage",
    "spreadsheet/unit-contracttenant": "Contract.Huurder",
    "spreadsheet/unit-contractoccupants": "Contract.Bewoners",
    "spreadsheet/unit-contractstatus": "Contract.Status",
    "spreadsheet/unit-contractfirstdate": "Contract.Eerste dag",
    "spreadsheet/unit-contractexpirationdate1": "Contract.Vervaldatum1",
    "spreadsheet/unit-contractexpirationdate2": "Contract.Vervaldatum2",
    "spreadsheet/unit-contractenddate": "Contract.Einddatum",
    "spreadsheet/unit-contractnotificationdate": "Contract.Notificatiedatum",
    "spreadsheet/unit-contractdeposit": "Contract.Borg",
    "spreadsheet/unit-contractbasicrent": "Contract.Kale huur",

    // New charge coach
    "coach/newcharge-step1/title": "Nieuwe nota",
    "coach/newcharge-step1/title-payment": "Nieuwe nota voor :amount",
    "coach/newcharge-step1/subtitle":
      "Door verhuurder of :agencyName te betalen of ontvangen bedrag",
    "coach/newcharge-step1/option-tobereceived":
      "Registreer een te ontvangen bedrag",
    "coach/newcharge-step1/option-tobepaid": "Registreer een te betalen bedrag",
    "coach/newcharge-step1/option-registerincominginvoice":
      "Verwerk een te betalen factuur",
    "coach/newcharge-step1/hint-registerincominginvoice":
      "Een door een verhuurder of door :agencyName te betalen factuur",
    "coach/newcharge-step2/title-type/tobereceived": "Ontvanger",
    "coach/newcharge-step2/subtitle-type/tobereceived":
      "Selecteer namens wie het bedrag wordt ontvangen",
    "coach/newcharge-step2/choicehint-type/tobereceived":
      "Bedrag te ontvangen door:",
    "coach/newcharge-step2/title-type/tobepaid": "Te betalen",
    "coach/newcharge-step2/subtitle-type/tobepaid":
      "Selecteer namens wie het bedrag wordt betaald",
    "coach/newcharge-step2/choicehint-type/tobepaid": "Bedrag te betalen door:",
    "coach/newcharge-step2/title-type/registerincominginvoice": "Betaler",
    "coach/newcharge-step2/subtitle-type/registerincominginvoice":
      "Selecteer namens wie het bedrag wordt betaald",
    "coach/newcharge-step2/choicehint-type/registerincominginvoice":
      "Factuur te betalen door:",
    "coach/newcharge-step3/step-title-tobereceived": "Te ontvangen",
    "coach/newcharge-step3/title-type/tobereceived": "Te ontvangen",
    "coach/newcharge-step3/subtitle-type/tobereceived":
      "Gegevens over het te ontvangen bedrag",
    "coach/newcharge-step3/step-title-tobepaid": "Te betalen",
    "coach/newcharge-step3/title-type/tobepaid": "Te betalen",
    "coach/newcharge-step3/title-type/tobepaid-payment":
      "Nieuwe nota: te betalen",
    "coach/newcharge-step3/subtitle-type/tobepaid":
      "Gegevens over het te betalen bedrag",
    "coach/newcharge-step3/title-type/registerincominginvoice": "Te betalen",
    "coach/newcharge-step3/subtitle-type/registerincominginvoice":
      "Verstrek meer informatie over de factuur",
    "coach/newcharge-step3/payment/received-title": "Ontvangen bedrag :amount",
    "coach/newcharge-step3/payment/paid-title": "Betaald bedrag :amount",
    "coach/newcharge-step3/payment/received-title-counterparty":
      "Het bedrag :amount is ontvangen van :counterparty",
    "coach/newcharge-step3/payment/paid-title-counterparty":
      "Het bedrag :amount is betaald aan :counterparty",
    "coach/newcharge-step4/title": "Bijlage toevoegen",
    "coach/newcharge-step4/subtitle": "Gerelateerde bestanden uploaden",
    "coach/newcharge-step5/toreceivefrom": "Te ontvangen van",
    "coach/newcharge-step5/topayto": "Te betalen aan",
    "link/anameonly": "Alleen een naam",
    "link/selectcounterparty": "Selecteer tegenpartij",
    "charge-creation-successful": "De nieuwe nota is succesvol geregistreerd",
    "charge-creation-failed": "Charge creation failed",
    amount_related_to: "Betreft contact of huurobject",
    service_provided_in_period: "Dienst of product geleverd in periode",
    include_charge_in_statement_for_period:
      "Nota opnemen in afrekening voor periode",
    "coach/newcharge-step2/error/please-select-an-owner":
      "Selecteer een verhuurder",
    "coach/paymentcharge-step1/charge-to-be-received": "Nota te ontvangen",
    "coach/paymentcharge-step1/charge-to-be-paid": "Nota te betalen",
    "coach/paymentcharge-step1/credit-charge": "Credit nota",
    credit_charge_for_payment: "Credit factuur voor betaling",
    show_more: "Meer...",
    show_less: "Minder...",
    received_for: "Ontvangen voor",
    paid_for: "Betaald in verband met",
    this_field_automatically_filled: "Dit veld is automatisch ingevuld",
    "coach/newcharge/selectcharge": "Selecteer een nota",
    "coach/newcharge/selectchargelabel":
      "De nota waarvoor de credit wordt verleend",
    "coach/summary/object-label": "Betreft",
    "coach/step2/landlord-label": "Verhuurder",
    "coach/counterpartystep/receivable/title": "Te ontvangen van",
    "coach/counterpartystep/receivable/subtitle": "Kies van wie te ontvangen",
    "coach/counterpartystep/payable/title": "Te betalen aan",
    "coach/counterpartystep/payable/subtitle": "Kies aan wie te betalen",
    "coach/newagreement/step1/title": "Nieuwe overeenkomst",
    "coach/newagreement/step1/subtitle":
      "Datum overeenkomst en te leveren dienst",
    "coach/newagreement/step2/title": "Vergoeding",
    "coach/newagreement/step2/subtitle":
      "Informatie voor de automatisch te genereren vergoeding nota(’s) ",
    "coach/newagreement/date-agreement": "Datum overeenkomst",
    "agreement-creation-successful":
      "De nieuwe overeenkomst is succesvol geregistreerd",
    "agreement-update-successful": "The agreement was successfully updated",
    bank_account_minimum_amount_error: "Er is minstens 1 bankrekening nodig",
    "payment-details-hint":
      "Is de betaling een uitbetaling aan :agencyName? Verreken deze betaling dan met het tegoed van :agencyName.",

    // General Coach translations
    "coach/general-forelast-create-subtitle-dutch-de":
      "Klik Afronden om de nieuwe :entity",
    "coach/general-forelast-create-subtitle-dutch-het":
      "Klik Afronden om het nieuwe :entity te maken",
    "coach/general-summary-create-subtitle-dutch-de":
      "De nieuwe :entity is succesvol vastgelegd",
    "coach/general-summary-create-subtitle-dutch-het":
      "Het nieuwe :entity is succesvol vastgelegd",
    "coach/general-forelast-update-subtitle-dutch-de":
      "Klik Afronden om de :entity bij te werken",
    "coach/general-forelast-update-subtitle-dutch-het":
      "Klik Afronden om het :entity bij te werken",
    "coach/general-summary-update-subtitle-dutch-de":
      "De :entity is succesvol bijgewerkt",
    "coach/general-summary-update-subtitle-dutch-het":
      "Het :entity is succesvol bijgewerkt",
    "charge-to-be-created": "nota te bewaren",

    // Ponto
    "revoke-access-from-ponto-button": "Bankrekening ontkoppelen",
    "syncronize-with-ponto-button": "Sync met bankrekening",
    please_disconnect_from_ponto:
      "Ontkoppel eerst de actieve standaard bankrekening van Ponto, en probeer het dan opnieuw.",
    ponto_count_of_created_payments: ":count nieuwe betalingen :datetime",
    ponto_no_default_bank_account:
      "Stel een standaard bankrekening in via Instellingen om Ponto te gebruiken.",
    ponto_no_default_bank_account_title: "Stel standaard bankrekening in",
    ponto_no_default_bank_account_body:
      "Ga naar Instellingen | Bankrekeningen en stel één bankrekening in als standaard.",
    // Ponto: panel status
    ponto_status_authorizing: "Autorisatie bezig...",
    ponto_status_connected: "Verbonden, nog niet gesynchroniseerd",
    ponto_status_sync_pending: "Synchronisatie bezig...",
    ponto_status_sync_failed: "Synchronisatie mislukt",
    ponto_status_sync_failed_at: "Synchronisatie mislukt :datetime",
    ponto_status_sync_failed_at_with_reason: "Synchronisatie mislukt :datetime — :reason",
    // Ponto: sync failure reasons
    ponto_sync_failure_reason_synchronization_failed: "synchronisatiefout bij Ponto",
    ponto_sync_failure_reason_authorization_expired: "autorisatie verlopen",
    ponto_sync_failure_reason_bank_connection_required: "autorisatie verlopen",
    ponto_sync_failure_reason_unknown: "onbekende fout",
    ponto_sync_failure_reason_fallback: "onbekende fout",
    // Ponto: snackbars
    ponto_redirect_success: "Bankrekening gekoppeld",
    ponto_no_sync_needed_snackbar: "Vorige synchronisatie is nog actueel",
    // Ponto: auth dialogs — shared
    "connect-to-ponto-button": "Bankrekening koppelen",
    ponto_auth_button: "Autoriseren",
    ponto_auth_close_button: "Sluiten",
    ponto_auth_restart_button: "Opnieuw",
    // Ponto: auth dialog titles
    ponto_auth_no_integration_title: "Bankrekening koppelen aan Ponto",
    ponto_auth_reconnect_title: "Ponto opnieuw verbinden",
    ponto_auth_expired_title: "Ponto-autorisatie verlopen",
    ponto_auth_bank_required_title: "Bankrekening opnieuw verbinden",
    ponto_auth_in_progress_title: "Autorisatie bezig",
    // Ponto: auth dialog bodies
    ponto_auth_no_integration_body:
      "Klik Autoriseren om bankrekening :accountId te koppelen aan Ponto.",
    ponto_auth_reconnect_body:
      "De Ponto-verbinding is verbroken. Klik Autoriseren om opnieuw toegang te verlenen tot bankrekening :accountId.",
    ponto_auth_expired_body:
      "De Ponto-autorisatie is verlopen. Klik Autoriseren om opnieuw toegang te verlenen tot bankrekening :accountId.",
    ponto_auth_bank_required_body:
      "Casadesk heeft toegang tot Ponto maar niet meer tot bankrekening :accountId. Klik Autoriseren om de bankrekening opnieuw te verbinden.",
    ponto_auth_in_progress_body:
      "Een autorisatie voor de bankrekening is al gestart door een andere gebruiker. Klik Sluiten om de lopende autorisatie af te wachten, of klik Opnieuw om opnieuw te beginnen.",
    ponto_reauth_connect_error:
      "Kan geen verbinding maken met uw bank. Probeer opnieuw of neem contact op met support.",
    // Ponto: error dialog titles
    ponto_connection_failed_title: "Autorisatie mislukt",
    bank_connection_failed_title: "Autorisatie: bankrekening niet gevonden",
    ponto_oauth_error_title: "Autorisatie: onverwachte fout",
    bank_account_not_found_title: "Synchronisatie: bankrekening niet gevonden",
    financial_operations_were_blocked_title: "Synchronisatie: financiële verwerking bezig",
    be_ajv_not_validated_title: "Ongeldige aanvraag",
    no_ponto_integration_title: "Geen actieve Ponto-koppeling",
    ponto_unexpected_error_title: "Onverwachte fout",
    // Ponto: error dialog bodies
    ponto_connection_failed_body:
      "De autorisatie is mislukt. Klik Sluiten en probeer het opnieuw.",
    bank_connection_failed_body:
      "De autorisatie met Ponto is gelukt, maar toestemming voor :accountId werd niet gevonden. Klik op Sync en verleen toegang tot :accountId.",
    ponto_oauth_error_body:
      "Er is een onverwachte fout opgetreden bij Ponto. Klik op Autoriseren om het opnieuw te proberen.",
    bank_account_not_found_body:
      "De bankrekening :accountId werd niet gevonden. Neem contact op met de helpdesk.",
    financial_operations_were_blocked_body:
      "De synchronisatie is niet mogelijk omdat financiële gegevens worden bijgewerkt. Probeer het later opnieuw.",
    be_ajv_not_validated_body:
      "De aanvraag kon niet worden verwerkt. Neem contact op met de helpdesk.",
    no_ponto_integration_body:
      "Er is geen actieve Ponto-koppeling gevonden. Ververs de pagina en probeer het opnieuw.",
    ponto_unexpected_error_body:
      "Er is een onverwachte fout opgetreden. Probeer het opnieuw.",
    "dialog-new-notification-title": "Nieuwe notificatie",
    "dialog-new-notification-text": "Notificatie tekst",
    "default-error-message":
      "Er is een onverwachte fout opgetreden. Het Casadesk team is geinformeerd.",
    "button/show-keys": "Show keys",
    "notification-done": "Klaar",
    "button/show-translations": "Show translations",

    // XLSX Sheets
    "sheets-date": "Datum",
    "sheets-type": "Type",
    "sheets-object": "Betreft",
    "sheets-counterpart": "Tegenpartij",
    "sheets-description": "Beschrijving",
    "sheets-amount-receivable": "Te ontvangen",
    "sheets-amount-payable": "Te betalen",

    /* Coach dialogs BILLS (stepper) */
    "coach/newbills-step/label": "De afrekening betreft het volgende adres",
    "coach/newbills-step/second-subtitle": "Gegevens van de afrekening",
    "coach/newbills-step/second-step-first-field-label": "Afrekening betreft:",
    //  "coach/newbills-step-field/type-label":"" ?,
    "coach/newbills-step/second-step-second-field-label": "Totaal:",
    "coach/newbills-step/first-step-title": "ADRES",
    "coach/newbills-step/second-step-title": "AFREKENING",
    "coach/newbills-step/third-step-title": "HUUREENHEDEN",
    "coach/newbills-step/fourth-step-title": "HUURDERS",
    "coach/newbills-step/fifth-step-title": "AFRONDEN",

// coach new bill settlement
  "coach/new-bill-settlement/action-buttons/cancel": "Annuleren",
  "coach/new-bill-settlement/action-buttons/back": "Vorige",
  "coach/new-bill-settlement/action-buttons/next": "Volgende",
  "coach/new-bill-settlement/action-buttons/finish": "Afronden",

  // address
  "coach/new-bill-settlement/steps/address/title": "Adres",
  "coach/new-bill-settlement/steps/address/property-lookup-label": "De eindafrekening is voor het volgende adres:",
  "coach/new-bill-settlement/steps/address/property-lookup-input-floating-label": "Type het adres",
  

  // bill
  "coach/new-bill-settlement/steps/bill/title":"Afrekening",
  "coach/new-bill-settlement/steps/bill/section-one/title":"Details van de afrekening",

  "coach/new-bill-settlement/steps/unit/section-one/company/label": "Afrekening van",
  "coach/new-bill-settlement/steps/bill/section-one/charge-type-for-landlord/label": "Afrekening betreft",
  "coach/new-bill-settlement/steps/bill/section-one/charge-type-for-tenant/label": "Nota type voor huurder",
  "coach/new-bill-settlement/steps/bill/section-one/total-amount/label": "Afrekening bedrag (excl. voorschotten):",
  "coach/new-bill-settlement/steps/bill/section-one/paid-amount/label": "Betaalde voorschotten:",
  "coach/new-bill-settlement/steps/bill/section-one/description/label": "Beschrijving:",
  "coach/new-bill-settlement/steps/bill/section-one/description/default": "Eindafrekening voor periode",
  "coach/new-bill-settlement/steps/bill/landlord-section/title": "Administratievergoeding verhuurder",
  "coach/new-bill-settlement/steps/bill/landlord-section/percentage-fee/label": "Percentage",
  "coach/new-bill-settlement/steps/bill/documents/title": "Maak deze documenten beschikbaar voor de huurder(s):",
  "coach/new-bill-settlement/steps/bill/documents/upload": "Upload bestanden",

  // unit
  "coach/new-bill-settlement/steps/unit/title":"Huurobject",
  "coach/new-bill-settlement/steps/unit/section-one/title":"De afrekening",
  "coach/new-bill-settlement/steps/unit/section-one/table/utility-bill/label":"Afrekening betreft",
  "coach/new-bill-settlement/steps/unit/section-one/table/bill-period/label": "Betreft periode",
  "coach/new-bill-settlement/steps/unit/section-one/table/total-bill-amount/label": "Bedrag (excl. voorschotten)",
  "coach/new-bill-settlement/steps/unit/section-one/table/administration-fee/label": "Administratiekosten verhuurder",
  "coach/new-bill-settlement/steps/unit/section-one/table/total-settled-amount/label": "Totaal te verrekenen",
  "coach/new-bill-settlement/steps/unit/section-one/table/monthly/label": "Maandelijks bedrag",
  "coach/new-bill-settlement/steps/unit/section-one/table/bill-period/difference/years": "Jaren",
  "coach/new-bill-settlement/steps/unit/section-one/table/bill-period/difference/months":"Maanden",
  "coach/new-bill-settlement/steps/unit/section-one/table/bill-period/difference/days":"Dagen",
  "coach/new-bill-settlement/steps/unit/section-two/title": "Verdeling over de huurobjecten",
  "coach/new-bill-settlement/steps/unit/section-two/unit-number": "Huurobject",
  "coach/new-bill-settlement/steps/unit/section-two/one-unit-only-message": "Het adres heeft één huurobject. Het totaal te verrekenen bedrag hoeft dus niet te worden verdeeld over meerdere huurobjecten.",
  "coach/new-bill-settlement/steps/unit/section-two/distribution-key/label": "Verdeelsleutel",
  "coach/new-bill-settlement/steps/unit/section-two/hint": "Bepaal de verdeling door voor ieder huurobject een getal van 0-100 in te vullen",

  // tenant
  "coach/new-bill-settlement/steps/tenant/title":"Huurder",
  "coach/new-bill-settlement/steps/tenant/section-two/title": "Verdeling over de huurder(s)",
  "coach/new-bill-settlement/steps/tenant/section-two/no-contracts-found":"Geen contracten gevonden",
  "coach/new-bill-settlement/steps/tenant/section-two/distributed-amount-by-unit":"Verdeling:",
  "coach/new-bill-settlement/steps/tenant/section-two/expected-amount-by-unit":"Te betalen:",
  "coach/new-bill-settlement/steps/tenant/section-two/paid-amount-by-unit":"Voorschotten:",
  "coach/new-bill-settlement/steps/tenant/section-two/remaining-amount-by-unit":"Verschil:",
  "coach/new-bill-settlement/steps/tenant/section-two/accordion/details/contract/label":"Contract no.:",
  "coach/new-bill-settlement/steps/tenant/section-two/hint": "Op basis van de contract periode(n) is het totaal te verrekenen bedrag verdeeld over de huurder(s)",

  "coach/new-bill-settlement/steps/tenant/tenants/header/unit": "Huurobject",
  "coach/new-bill-settlement/steps/tenant/tenants/header/tenant": "Huurder",
  "coach/new-bill-settlement/steps/tenant/tenants/header/contract": "Contract",
  "coach/new-bill-settlement/steps/tenant/tenants/header/to-pay": "Te betalen",
  
  // finish
  "coach/new-bill-settlement/steps/finish/title":"Afronden",
  "coach/new-bill-settlement/steps/finish/tenants/title": "Resteert te verrekenen met de huurder(s)",
  "coach/new-bill-settlement/steps/finish/tenants/header/unit": "Huurobject",
  "coach/new-bill-settlement/steps/finish/tenants/header/tenant": "Huurder",
  "coach/new-bill-settlement/steps/finish/tenants/header/to-pay": "Te betalen",
  "coach/new-bill-settlement/steps/finish/tenants/header/deposited": "Voorschotten",
  "coach/new-bill-settlement/steps/finish/tenants/header/remains-to-settle": "Resteert",

  // errors
  "coach/new-bill-settlement/steps/address/errors/property-missing": "Selecteer een adres",
  "coach/new-bill-settlement/steps/bill/section-one/company/error/company-missing": "Selecteer een organisatie",
  "coach/new-bill-settlement/steps/bill/section-one/utility-bill-type/error/charge-type-for-landlord-missing": "Selecteer een afrekening type",
  "coach/new-bill-settlement/steps/bill/section-one/utility-bill-type/error/charge-type-for-tenant-missing": "Selecteer een nota type",
  "coach/new-bill-settlement/steps/bill/section-one/end-date/error/end-date-missing" : "Selecteer een einddatum",
  "coach/new-bill-settlement/steps/bill/section-one/end-date/error/end-date-in-future": "Kies een laatste dag van de afrekeningperiode die voor vandaag ligt",
  "coach/new-bill-settlement/steps/bill/section-one/end-date/error/end-date-before-start": "Kies een laatste dag die na de eerste dag van de afrekeningperiode ligt",
  "coach/new-bill-settlement/steps/bill/section-one/first-date/error/first-date-missing": "Selecteer een eerste dag",
  "coach/new-bill-settlement/steps/bill/section-one/first-date/error/first-date-in-future": "Kies een eerste dag die voor vandaag ligt",
  "coach/new-bill-settlement/steps/bill/section-one/first-date/error/first-date-too-early": "Kies een eerste dag in deze eeuw",
  "coach/new-bill-settlement/steps/bill/section-one/bill-period/error/bill-period-too-long": "Kies een kortere afrekeningperiode",
  "coach/new-bill-settlement/steps/bill/section-one/total-amount/error/total-amount-missing": "Vul een bedrag in",
  "coach/new-bill-settlement/steps/bill/section-one/total-amount/error/total-amount-negative": "Vul een bedrag in dat niet negatief is",
  "coach/new-bill-settlement/steps/bill/section-one/total-amount/error/total-amount-too-high": "Het totaal bedrag is te hoog",
  "coach/new-bill-settlement/steps/bill/section-one/paid-amount/error/paid-amount-missing": "Vul een voorschot in",
  "coach/new-bill-settlement/steps/bill/section-one/paid-amount/error/paid-amount-negative": "Vul een voorschot iin dat niet negatief is",
  "coach/new-bill-settlement/steps/bill/landlord-section/percentage-fee/error/percentage-fee-missing": "Vul een percentage in",
  "coach/new-bill-settlement/steps/bill/landlord-section/percentage-fee/error/not-in-range": "Vul een percentage van 0 tot 100 in",
  "coach/new-bill-settlement/steps/unit/section-two/distribution-key/error/not-set": "Vul minstens één verdeelsleutel in",
  "coach/new-bill-settlement/steps/unit/section-two/distribution-key/error/not-in-range": "Vul een verdeelsleutel van 0 tot 100 in",

  // process
  "process/create-charges-for-contracts":"Start productie nota's voor contracten",
  "process/mail-charges-without-owner-statement":"Zend email met nota's waar afrekening ontbreekt",
  
  //! fixes
  //"settled_bill_receivable": "[MISSING TRANSLATION] settled_bill_receivable",
  //"settled_bill_payable": "[MISSING TRANSLATION] settled_bill_payable",

  };

  public get(key) {
    key = key ? key : "default-error-message";
    return this.language[key];
  };
};

export { Dutch };
